"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13716],{

/***/ 94201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HP": function() { return /* binding */ memoize; },
/* harmony export */   "RJ": function() { return /* binding */ PluginHost; },
/* harmony export */   "tP": function() { return /* binding */ slice; },
/* harmony export */   "vp": function() { return /* binding */ EventEmitter; },
/* harmony export */   "w2": function() { return /* binding */ easeOutCubic; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; },
/* harmony export */   "zh": function() { return /* binding */ getMessagesFormatter; }
/* harmony export */ });
/* unused harmony exports argumentsShallowEqual, createClickHandlers, easeInCubic, easeInOutCubic, easeInOutQuad, easeInOutQuart, easeInOutQuint, easeInQuad, easeInQuart, easeInQuint, easeOutQuad, easeOutQuart, easeOutQuint, hasWindow */
/**
 * Bundle of @devexpress/dx-core
 * Generated: 2021-06-24
 * Version: 2.7.6
 * License: https://js.devexpress.com/Licensing
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var DELAY = 200;
var compare = function (a, b) {
    var aPosition = a.position();
    var bPosition = b.position();
    for (var i = 0; i < Math.min(aPosition.length, bPosition.length); i += 1) {
        if (aPosition[i] < bPosition[i])
            return -1;
        if (aPosition[i] > bPosition[i])
            return 1;
    }
    return aPosition.length - bPosition.length;
};
/** @internal */
var insertPlugin = function (array, newItem) {
    var result = array.slice();
    var nextItemIndex = array.findIndex(function (item) { return compare(newItem, item) <= 0; });
    var targetIndex = nextItemIndex < 0 ? array.length : nextItemIndex;
    var alreadyExists = (targetIndex >= 0 && targetIndex < array.length)
        && compare(newItem, array[targetIndex]) === 0;
    result.splice(targetIndex, alreadyExists ? 1 : 0, newItem);
    return result;
};
/** @internal */
var removePlugin = function (array, item) {
    var itemIndex = array.indexOf(item);
    return itemIndex >= 0 ? __spread(array.slice(0, itemIndex), array.slice(itemIndex + 1)) : array;
};
/** @internal */
var createClickHandlers = function (click, dblClick) {
    var timeoutId;
    var events = {};
    if (click) {
        events.onClick = function (e) {
            if (!timeoutId) {
                timeoutId = setTimeout(function () {
                    clearTimeout(timeoutId);
                    click(e);
                }, DELAY);
            }
        };
    }
    if (dblClick) {
        events.onDoubleClick = function (e) {
            clearTimeout(timeoutId);
            dblClick(e);
        };
    }
    return events;
};
/** @internal */
var slice = function (arr) { return Array.prototype.slice.call(arr); }; // slice can be renamed to copy as well
/** @internal */
var hasWindow = function () { return typeof window !== 'undefined'; };

var getDependencyError = function (pluginName, dependencyName) { return new Error("The '" + pluginName + "' plugin requires '" + dependencyName + "' to be defined before it."); };
/** @internal */
var PluginHost = /*#__PURE__*/ (function () {
    function PluginHost() {
        this.gettersCache = {};
        this.knownKeysCache = {};
        this.validationRequired = true;
        this.plugins = [];
        this.subscriptions = new Set();
    }
    PluginHost.prototype.ensureDependencies = function () {
        var defined = new Set();
        var knownOptionals = new Map();
        this.plugins
            .filter(function (plugin) { return plugin.container; })
            .forEach(function (plugin) {
            var pluginName = plugin.name || '';
            if (knownOptionals.has(pluginName)) {
                throw (getDependencyError(knownOptionals.get(pluginName), pluginName));
            }
            (plugin.dependencies || [])
                .forEach(function (dependency) {
                if (defined.has(dependency.name))
                    return;
                if (dependency.optional) {
                    if (!knownOptionals.has(dependency.name)) {
                        knownOptionals.set(dependency.name, pluginName);
                    }
                    return;
                }
                throw (getDependencyError(pluginName, dependency.name));
            });
            defined.add(pluginName);
        });
    };
    PluginHost.prototype.registerPlugin = function (plugin) {
        this.plugins = insertPlugin(this.plugins, plugin);
        this.cleanPluginsCache();
    };
    PluginHost.prototype.unregisterPlugin = function (plugin) {
        this.plugins = removePlugin(this.plugins, plugin);
        this.cleanPluginsCache();
    };
    PluginHost.prototype.knownKeys = function (postfix) {
        if (!this.knownKeysCache[postfix]) {
            this.knownKeysCache[postfix] = Array.from(this.plugins
                .map(function (plugin) { return Object.keys(plugin); })
                .map(function (keys) { return keys.filter(function (key) { return key.endsWith(postfix); })[0]; })
                .filter(function (key) { return !!key; })
                .reduce(function (acc, key) { return acc.add(key); }, new Set()))
                .map(function (key) { return key.replace(postfix, ''); });
        }
        return this.knownKeysCache[postfix];
    };
    PluginHost.prototype.collect = function (key, upTo) {
        if (this.validationRequired) {
            this.ensureDependencies();
            this.validationRequired = false;
        }
        var res = this.gettersCache[key];
        if (!res) {
            // Add cache for original plugin indexes
            var indexCache = this.plugins
                .map(function (plugin, index) { return ({ key: plugin[key], index: index }); })
                .filter(function (plugin) { return !!plugin.key; });
            this.gettersCache[key + "_i"] = indexCache;
            res = indexCache.map(function (item) { return item.key; });
            this.gettersCache[key] = res;
        }
        if (!upTo)
            return res;
        var upToIndex = this.plugins.indexOf(upTo);
        // Try to get a result from upToIndex cache first.
        var upToIndexKey = key + upToIndex;
        var upToRes = this.gettersCache[upToIndexKey];
        if (!upToRes) {
            var indexCache_1 = this.gettersCache[key + "_i"];
            upToRes = this.gettersCache[key]
                .filter(function (getter, index) { return indexCache_1[index].index < upToIndex; });
            this.gettersCache[upToIndexKey] = upToRes;
        }
        return upToRes;
    };
    PluginHost.prototype.get = function (key, upTo) {
        var plugins = this.collect(key, upTo);
        if (!plugins.length)
            return undefined;
        var result;
        // slice creates shallow copy, when do it many times, it costs about 5%
        plugins.forEach(function (plugin) {
            result = plugin(result);
        });
        return result;
    };
    PluginHost.prototype.registerSubscription = function (subscription) {
        this.subscriptions.add(subscription);
    };
    PluginHost.prototype.unregisterSubscription = function (subscription) {
        this.subscriptions.delete(subscription);
    };
    PluginHost.prototype.broadcast = function (event, message) {
        this.subscriptions.forEach(function (subscription) { return subscription[event] && subscription[event](message); });
    };
    PluginHost.prototype.cleanPluginsCache = function () {
        this.validationRequired = true;
        this.gettersCache = {};
        this.knownKeysCache = {};
    };
    return PluginHost;
}());

/** @internal */
var EventEmitter = /*#__PURE__*/ (function () {
    function EventEmitter() {
        this.handlers = [];
    }
    EventEmitter.prototype.emit = function (e) {
        this.handlers.forEach(function (handler) { return handler(e); });
    };
    EventEmitter.prototype.subscribe = function (handler) {
        this.handlers.push(handler);
    };
    EventEmitter.prototype.unsubscribe = function (handler) {
        this.handlers.splice(this.handlers.indexOf(handler), 1);
    };
    return EventEmitter;
}());

/** @internal */
var shallowEqual = function (objA, objB) {
    if (objA === objB) {
        return true;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    // tslint:disable-next-line: prefer-for-of
    for (var i = 0; i < keysA.length; i += 1) {
        if (!hasOwn.call(objB, keysA[i])
            || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB) {
            return false;
        }
    }
    return true;
};
/** @internal */
var argumentsShallowEqual = function (prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
        return false;
    }
    for (var i = 0; i < prev.length; i += 1) {
        if (prev[i] !== next[i]) {
            return false;
        }
    }
    return true;
};

/** @internal */
var memoize = function (func) {
    var lastArgs = null;
    var lastResult = null;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (lastArgs === null || !argumentsShallowEqual(lastArgs, args)) {
            lastResult = func.apply(void 0, __spread(args));
        }
        lastArgs = args;
        return lastResult;
    };
};

/** @internal */
var easeInQuad = function (t) { return t * t; };
/** @internal */
var easeOutQuad = function (t) { return t * (2 - t); };
/** @internal */
var easeInOutQuad = function (t) { return (t < 0.5
    ? 2 * t * t
    : -1 + ((4 - (2 * t)) * t)); };
/** @internal */
var easeInCubic = function (t) { return t * t * t; };
/** @internal */
var easeOutCubic = function (t) { return ((t - 1) * (t - 1) * (t - 1)) + 1; };
/** @internal */
var easeInOutCubic = function (t) { return (t < 0.5
    ? 4 * t * t * t
    : ((t - 1) * ((2 * t) - 2) * ((2 * t) - 2)) + 1); };
/** @internal */
var easeInQuart = function (t) { return t * t * t * t; };
/** @internal */
var easeOutQuart = function (t) { return 1 - ((t - 1) * (t - 1) * (t - 1) * (t - 1)); };
/** @internal */
var easeInOutQuart = function (t) { return (t < 0.5
    ? 8 * t * t * t * t
    : 1 - (8 * (t - 1) * (t - 1) * (t - 1) * (t - 1))); };
/** @internal */
var easeInQuint = function (t) { return t * t * t * t * t; };
/** @internal */
var easeOutQuint = function (t) { return 1 + ((t - 1) * (t - 1) * (t - 1) * (t - 1) * (t - 1)); };
/** @internal */
var easeInOutQuint = function (t) { return (t < 0.5
    ? 16 * t * t * t * t * t
    : 1 + (16 * (t - 1) * (t - 1) * (t - 1) * (t - 1) * (t - 1))); };

var processPattern = function (pattern, params) { return Object.keys(params).reduce(function (msg, key) { return msg.replace("{" + key + "}", params[key]); }, pattern); };
/** @internal */
var getMessagesFormatter = function (messages) { return function (key, params) {
    var message = messages[key];
    if (typeof message === 'function') {
        return message(params);
    }
    if (params) {
        return processPattern(message, params);
    }
    return message !== null && message !== void 0 ? message : '';
}; };


//# sourceMappingURL=dx-core.es.js.map


/***/ }),

/***/ 47855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$bB": function() { return /* binding */ bandLevelsVisibility; },
/* harmony export */   "$cC": function() { return /* binding */ getNextColumnName; },
/* harmony export */   "$dF": function() { return /* binding */ getColumnFilterConfig; },
/* harmony export */   "AEb": function() { return /* binding */ shouldSendRequest; },
/* harmony export */   "Bpw": function() { return /* binding */ isEditCommandsTableCell; },
/* harmony export */   "Bqx": function() { return /* binding */ isGroupIndentStubTableCell; },
/* harmony export */   "C9d": function() { return /* binding */ createRowChangeGetter; },
/* harmony export */   "CHX": function() { return /* binding */ isGroupTableRow; },
/* harmony export */   "CNL": function() { return /* binding */ tableColumnsWithDataRows; },
/* harmony export */   "CXl": function() { return /* binding */ isFixedTableRow; },
/* harmony export */   "CeY": function() { return /* binding */ checkColumnWidths; },
/* harmony export */   "Cmv": function() { return /* binding */ tableHeaderRowsWithFixed; },
/* harmony export */   "D4z": function() { return /* binding */ setCurrentPage; },
/* harmony export */   "DQD": function() { return /* binding */ isDataTableCell; },
/* harmony export */   "DQX": function() { return /* binding */ draftOrder; },
/* harmony export */   "Df8": function() { return /* binding */ isEditTableRow; },
/* harmony export */   "Dwn": function() { return /* binding */ groupSummaryValues; },
/* harmony export */   "E69": function() { return /* binding */ TABLE_STUB_TYPE; },
/* harmony export */   "ED7": function() { return /* binding */ isDetailToggleTableCell; },
/* harmony export */   "EMK": function() { return /* binding */ emptyVirtualRows; },
/* harmony export */   "EOv": function() { return /* binding */ getColumnSummaries; },
/* harmony export */   "EXW": function() { return /* binding */ cancelColumnGroupingDraft; },
/* harmony export */   "E_$": function() { return /* binding */ isDataTableRow; },
/* harmony export */   "E_b": function() { return /* binding */ getRowChange; },
/* harmony export */   "F$P": function() { return /* binding */ TABLE_DATA_TYPE; },
/* harmony export */   "F2k": function() { return /* binding */ TABLE_EDIT_TYPE; },
/* harmony export */   "FY1": function() { return /* binding */ getCellGeometries; },
/* harmony export */   "Fm5": function() { return /* binding */ isGroupIndentTableCell; },
/* harmony export */   "G5D": function() { return /* binding */ isTreeSummaryTableRow; },
/* harmony export */   "GDU": function() { return /* binding */ loadedRowsStart; },
/* harmony export */   "GlP": function() { return /* binding */ columnsWithEditingCells; },
/* harmony export */   "GlU": function() { return /* binding */ isRowHighlighted; },
/* harmony export */   "Gvg": function() { return /* binding */ startEditRows; },
/* harmony export */   "H_k": function() { return /* binding */ calculateFixedColumnProps; },
/* harmony export */   "Hnd": function() { return /* binding */ stopEditCells; },
/* harmony export */   "HzE": function() { return /* binding */ tableHeaderColumnChainsWithBands; },
/* harmony export */   "I$R": function() { return /* binding */ isNoDataTableCell; },
/* harmony export */   "IL0": function() { return /* binding */ isFilterValueEmpty; },
/* harmony export */   "JMo": function() { return /* binding */ isBandedTableRow; },
/* harmony export */   "JNm": function() { return /* binding */ expandedTreeRows; },
/* harmony export */   "Jpp": function() { return /* binding */ rowsWithEditingCells; },
/* harmony export */   "K6E": function() { return /* binding */ isHeaderStubTableCell; },
/* harmony export */   "KPr": function() { return /* binding */ changeAddedRow; },
/* harmony export */   "KUD": function() { return /* binding */ rowIdGetter; },
/* harmony export */   "KcK": function() { return /* binding */ groupedRows; },
/* harmony export */   "Knv": function() { return /* binding */ treeSummaryValues; },
/* harmony export */   "Ku0": function() { return /* binding */ tableRowsWithHeading; },
/* harmony export */   "Kvg": function() { return /* binding */ TABLE_TOTAL_SUMMARY_TYPE; },
/* harmony export */   "LQV": function() { return /* binding */ tableRowsWithExpandedDetail; },
/* harmony export */   "M5U": function() { return /* binding */ deleteRows; },
/* harmony export */   "MCY": function() { return /* binding */ isTreeRowLeafGetter; },
/* harmony export */   "MPu": function() { return /* binding */ isFilterTableCell; },
/* harmony export */   "MS1": function() { return /* binding */ filterActiveAnimations; },
/* harmony export */   "MX2": function() { return /* binding */ prepareGroupSummaryItems; },
/* harmony export */   "MYE": function() { return /* binding */ unwrappedFilteredRows; },
/* harmony export */   "Mbi": function() { return /* binding */ isSelectAllTableCell; },
/* harmony export */   "Mi9": function() { return /* binding */ tableHeaderColumnChainsWithFixed; },
/* harmony export */   "N9C": function() { return /* binding */ isGroupSummaryTableRow; },
/* harmony export */   "NLR": function() { return /* binding */ TABLE_BAND_TYPE; },
/* harmony export */   "NxM": function() { return /* binding */ cancelDeletedRows; },
/* harmony export */   "OHV": function() { return /* binding */ tableColumnsWithWidths; },
/* harmony export */   "OXP": function() { return /* binding */ getRequestMeta; },
/* harmony export */   "PD5": function() { return /* binding */ toggleDetailRowExpanded; },
/* harmony export */   "PJk": function() { return /* binding */ getCollapsedGrids; },
/* harmony export */   "Pgx": function() { return /* binding */ changedRowsByIds; },
/* harmony export */   "Pjf": function() { return /* binding */ isFilterTableRow; },
/* harmony export */   "PoP": function() { return /* binding */ virtualRowsWithCache; },
/* harmony export */   "PuF": function() { return /* binding */ isHeadingTableCell; },
/* harmony export */   "QU7": function() { return /* binding */ getColumnExtension; },
/* harmony export */   "Qg5": function() { return /* binding */ someSelected; },
/* harmony export */   "QgS": function() { return /* binding */ toggleExpandedGroups; },
/* harmony export */   "RB7": function() { return /* binding */ searchFilterExpression; },
/* harmony export */   "RBi": function() { return /* binding */ BAND_HEADER_CELL; },
/* harmony export */   "RKA": function() { return /* binding */ changeSearchValue; },
/* harmony export */   "S72": function() { return /* binding */ getColumnExtensionValueGetter; },
/* harmony export */   "SAz": function() { return /* binding */ addRow; },
/* harmony export */   "SR5": function() { return /* binding */ changeRow; },
/* harmony export */   "STh": function() { return /* binding */ rowCount; },
/* harmony export */   "TF9": function() { return /* binding */ isTotalSummaryTableRow; },
/* harmony export */   "TQW": function() { return /* binding */ rowsWithAvailableToSelect; },
/* harmony export */   "Tcd": function() { return /* binding */ groupRowLevelKeyGetter; },
/* harmony export */   "TfZ": function() { return /* binding */ isDetailRowExpanded; },
/* harmony export */   "Tgp": function() { return /* binding */ needFetchMorePages; },
/* harmony export */   "Trq": function() { return /* binding */ cellValueGetter; },
/* harmony export */   "U5h": function() { return /* binding */ setPageSize; },
/* harmony export */   "URs": function() { return /* binding */ getTopRowId; },
/* harmony export */   "U_c": function() { return /* binding */ visibleTableColumns; },
/* harmony export */   "Ued": function() { return /* binding */ getColumnFilterOperations; },
/* harmony export */   "Ule": function() { return /* binding */ toggleSelection; },
/* harmony export */   "Uxi": function() { return /* binding */ tableColumnsWithGrouping; },
/* harmony export */   "V3r": function() { return /* binding */ toggleRowExpanded; },
/* harmony export */   "Vaq": function() { return /* binding */ tableColumnsWithDetail; },
/* harmony export */   "Vfj": function() { return /* binding */ isTotalSummaryTableCell; },
/* harmony export */   "Vj": function() { return /* binding */ columnChooserItems; },
/* harmony export */   "WfV": function() { return /* binding */ tableHeaderRowsWithReordering; },
/* harmony export */   "Wtz": function() { return /* binding */ BAND_EMPTY_CELL; },
/* harmony export */   "XGx": function() { return /* binding */ TABLE_HEADING_TYPE; },
/* harmony export */   "XN9": function() { return /* binding */ tableColumnsWithFixed; },
/* harmony export */   "XaB": function() { return /* binding */ tableHeaderRowsWithFilter; },
/* harmony export */   "XcA": function() { return /* binding */ groupCollapsedRowsGetter; },
/* harmony export */   "Xh8": function() { return /* binding */ defaultFilterPredicate; },
/* harmony export */   "YPZ": function() { return /* binding */ TABLE_DETAIL_TYPE; },
/* harmony export */   "YS6": function() { return /* binding */ TOP_POSITION; },
/* harmony export */   "YZN": function() { return /* binding */ changeColumnFilter; },
/* harmony export */   "YZY": function() { return /* binding */ isGroupTableCell; },
/* harmony export */   "Z6d": function() { return /* binding */ isDetailTableRow; },
/* harmony export */   "ZN$": function() { return /* binding */ lastRowOnPage; },
/* harmony export */   "ZdZ": function() { return /* binding */ TABLE_FILTER_TYPE; },
/* harmony export */   "Zt5": function() { return /* binding */ isGroupSummaryTableCell; },
/* harmony export */   "_UB": function() { return /* binding */ TABLE_REORDERING_TYPE; },
/* harmony export */   "_UY": function() { return /* binding */ columnVisibleIntervals; },
/* harmony export */   "_qj": function() { return /* binding */ getGroupCellTargetIndex; },
/* harmony export */   "_tb": function() { return /* binding */ defaultFormatlessSummaries; },
/* harmony export */   "a6c": function() { return /* binding */ isNoDataTableRow; },
/* harmony export */   "aGW": function() { return /* binding */ changeColumnOrder; },
/* harmony export */   "aOc": function() { return /* binding */ getViewport; },
/* harmony export */   "aXb": function() { return /* binding */ getBandComponent; },
/* harmony export */   "ag_": function() { return /* binding */ getTreeRowLevelGetter; },
/* harmony export */   "b9p": function() { return /* binding */ TABLE_NODATA_TYPE; },
/* harmony export */   "bQN": function() { return /* binding */ cancelAddedRows; },
/* harmony export */   "bh": function() { return /* binding */ adjustSortIndex; },
/* harmony export */   "bmW": function() { return /* binding */ orderedColumns; },
/* harmony export */   "cA6": function() { return /* binding */ TABLE_GROUP_TYPE; },
/* harmony export */   "co8": function() { return /* binding */ getColumnSortingDirection; },
/* harmony export */   "cpB": function() { return /* binding */ isHeadingEditCommandsTableCell; },
/* harmony export */   "cxm": function() { return /* binding */ getScrollTop; },
/* harmony export */   "d6P": function() { return /* binding */ changeTableColumnWidth; },
/* harmony export */   "dEG": function() { return /* binding */ groupRowChecker; },
/* harmony export */   "dF$": function() { return /* binding */ firstRowOnPage; },
/* harmony export */   "dFf": function() { return /* binding */ TABLE_EDIT_COMMAND_TYPE; },
/* harmony export */   "dJU": function() { return /* binding */ filterExpression; },
/* harmony export */   "dMj": function() { return /* binding */ isDetailTableCell; },
/* harmony export */   "dSj": function() { return /* binding */ unwrapSelectedRows; },
/* harmony export */   "dwe": function() { return /* binding */ evalAnimations; },
/* harmony export */   "eHw": function() { return /* binding */ TABLE_ADDED_TYPE; },
/* harmony export */   "eNm": function() { return /* binding */ draftTableColumnWidth; },
/* harmony export */   "eaB": function() { return /* binding */ isPreviousCellContainSummary; },
/* harmony export */   "efG": function() { return /* binding */ isFooterSummary; },
/* harmony export */   "f2u": function() { return /* binding */ tableDetailCellColSpanGetter; },
/* harmony export */   "fQA": function() { return /* binding */ totalSummaryValues; },
/* harmony export */   "foY": function() { return /* binding */ getAvailableRowCount; },
/* harmony export */   "fqm": function() { return /* binding */ isTreeTableCell; },
/* harmony export */   "gEi": function() { return /* binding */ isTreeSummaryTableCell; },
/* harmony export */   "gUT": function() { return /* binding */ filteredCollapsedRowsGetter; },
/* harmony export */   "hMn": function() { return /* binding */ isBandedOrHeaderRow; },
/* harmony export */   "hPT": function() { return /* binding */ tableColumnsWithEditing; },
/* harmony export */   "hRj": function() { return /* binding */ columnBandLevels; },
/* harmony export */   "i8P": function() { return /* binding */ TABLE_GROUP_SUMMARY_TYPE; },
/* harmony export */   "iQ1": function() { return /* binding */ tableRowsWithSummaries; },
/* harmony export */   "j2K": function() { return /* binding */ getAvailableFilterOperationsGetter; },
/* harmony export */   "jOT": function() { return /* binding */ calculateGroupCellIndent; },
/* harmony export */   "jSt": function() { return /* binding */ filteredRows; },
/* harmony export */   "jzv": function() { return /* binding */ tableRowsWithBands; },
/* harmony export */   "k9C": function() { return /* binding */ tableRowsWithDataRows; },
/* harmony export */   "kBB": function() { return /* binding */ addedRowsByIds; },
/* harmony export */   "kw6": function() { return /* binding */ calculateStartPage; },
/* harmony export */   "lTK": function() { return /* binding */ getReferenceIndex; },
/* harmony export */   "loR": function() { return /* binding */ currentPage; },
/* harmony export */   "m9h": function() { return /* binding */ isSelectTableCell; },
/* harmony export */   "mC0": function() { return /* binding */ pageCount; },
/* harmony export */   "mlk": function() { return /* binding */ calculateKeepOther; },
/* harmony export */   "myI": function() { return /* binding */ cancelTableColumnWidthDraft; },
/* harmony export */   "n3s": function() { return /* binding */ paginatedRows; },
/* harmony export */   "nbo": function() { return /* binding */ getGroupInlineSummaries; },
/* harmony export */   "ne": function() { return /* binding */ plainRows; },
/* harmony export */   "nrC": function() { return /* binding */ tableGroupCellColSpanGetter; },
/* harmony export */   "oHq": function() { return /* binding */ getAnimations; },
/* harmony export */   "odc": function() { return /* binding */ collapsedTreeRowsGetter; },
/* harmony export */   "oiZ": function() { return /* binding */ BAND_GROUP_CELL; },
/* harmony export */   "ooZ": function() { return /* binding */ isRowSummaryCell; },
/* harmony export */   "pEZ": function() { return /* binding */ customGroupingRowIdGetter; },
/* harmony export */   "pLp": function() { return /* binding */ getPersistentSortedColumns; },
/* harmony export */   "pdv": function() { return /* binding */ tableDataColumnsExist; },
/* harmony export */   "pq5": function() { return /* binding */ TABLE_SELECT_TYPE; },
/* harmony export */   "pyc": function() { return /* binding */ changeColumnSorting; },
/* harmony export */   "qJP": function() { return /* binding */ TABLE_FLEX_TYPE; },
/* harmony export */   "qfg": function() { return /* binding */ rowsWithPageHeaders; },
/* harmony export */   "qkl": function() { return /* binding */ sortedRows; },
/* harmony export */   "quG": function() { return /* binding */ getColumnWidthGetter; },
/* harmony export */   "qvl": function() { return /* binding */ customTreeRowIdGetter; },
/* harmony export */   "r1L": function() { return /* binding */ startEditCells; },
/* harmony export */   "rPD": function() { return /* binding */ draftColumnGrouping; },
/* harmony export */   "rQc": function() { return /* binding */ trimRowsToInterval; },
/* harmony export */   "riC": function() { return /* binding */ customTreeRowLevelKeyGetter; },
/* harmony export */   "ruB": function() { return /* binding */ tableRowsWithGrouping; },
/* harmony export */   "sHI": function() { return /* binding */ BAND_DUPLICATE_RENDER; },
/* harmony export */   "sYV": function() { return /* binding */ customGroupedRows; },
/* harmony export */   "seX": function() { return /* binding */ isHeadingTableRow; },
/* harmony export */   "stj": function() { return /* binding */ tableColumnsWithDraftWidths; },
/* harmony export */   "ttV": function() { return /* binding */ tableColumnsWithSelection; },
/* harmony export */   "u$D": function() { return /* binding */ toggleColumn; },
/* harmony export */   "uXn": function() { return /* binding */ cancelChanges; },
/* harmony export */   "uvs": function() { return /* binding */ isEditTableCell; },
/* harmony export */   "v3L": function() { return /* binding */ isStubTableCell; },
/* harmony export */   "vEG": function() { return /* binding */ customTreeRowsWithMeta; },
/* harmony export */   "vTw": function() { return /* binding */ isAddedTableRow; },
/* harmony export */   "vyY": function() { return /* binding */ tableRowsWithTotalSummaries; },
/* harmony export */   "w8d": function() { return /* binding */ stopEditRows; },
/* harmony export */   "wNK": function() { return /* binding */ changeColumnGrouping; },
/* harmony export */   "wTC": function() { return /* binding */ unwrappedCustomTreeRows; },
/* harmony export */   "wXR": function() { return /* binding */ BAND_FILL_LEVEL_CELL; },
/* harmony export */   "wmT": function() { return /* binding */ isGroupRowOrdinaryCell; },
/* harmony export */   "xLh": function() { return /* binding */ allSelected; },
/* harmony export */   "xRW": function() { return /* binding */ BOTTOM_POSITION; },
/* harmony export */   "xZ4": function() { return /* binding */ groupingPanelItems; },
/* harmony export */   "yF3": function() { return /* binding */ defaultSummaryCalculator; },
/* harmony export */   "yL5": function() { return /* binding */ tableRowsWithEditing; },
/* harmony export */   "yOS": function() { return /* binding */ checkTableColumnExtensions; },
/* harmony export */   "ynt": function() { return /* binding */ getSelectedFilterOperation; },
/* harmony export */   "yrm": function() { return /* binding */ tableCellColSpanGetter; },
/* harmony export */   "yxL": function() { return /* binding */ getTableTargetColumnIndex; },
/* harmony export */   "zGH": function() { return /* binding */ TABLE_TREE_SUMMARY_TYPE; },
/* harmony export */   "zGz": function() { return /* binding */ expandedGroupRows; }
/* harmony export */ });
/* unused harmony exports DEFAULT_COLUMN_WIDTH, DEFAULT_FILTER_OPERATIONS, FIXED_COLUMN_LEFT_SIDE, FIXED_COLUMN_RIGHT_SIDE, GROUP_KEY_SEPARATOR, ROOT_GROUP, TABLE_FIXED_TYPE, buildGroupTree, calculateBand, calculateRequestedRange, calculateScrollHeight, clamp, closeGroupGetter, closeSheet, convertWidth, emptyViewport, exportHeader, exportRows, exportSummaryGetter, exportSummaryItems, findChainByColumnIndex, findRanges, generateSimpleChains, getCollapsedGrid, getColumnBoundaries, getColumnMeta, getColumnSizes, getColumnsRenderBoundary, getFixedColumnKeys, getForceReloadInterval, getRowsRenderBoundary, getRowsVisibleBoundary, getTableColumnGeometries, groupFooterSummaryExists, groupOutlineLevels, intervalUtil, isInlineGroupCaptionSummary, isNoDataColumn, isValidValue, maximumGroupLevel, mergeRows, normalizeRanges, recalculateBounds, removeEmptyGroups, rowToPageIndex, rowsToExport, sortAndSpliceColumns, splitHeaderColumnChains */
/* harmony import */ var _devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94201);
/**
 * Bundle of @devexpress/dx-grid-core
 * Generated: 2021-06-24
 * Version: 2.7.6
 * License: https://js.devexpress.com/Licensing
 */



var GRID_GROUP_TYPE = Symbol('group');
var GRID_GROUP_CHECK = Symbol(GRID_GROUP_TYPE.toString() + "_check");
var GRID_GROUP_LEVEL_KEY = Symbol(GRID_GROUP_TYPE.toString() + "_levelKey");
var GRID_GROUP_COLLAPSED_ROWS = Symbol(GRID_GROUP_TYPE.toString() + "_collapsedRows");

var warnIfRowIdUndefined = function (getRowId) { return function (row) {
    var result = getRowId(row);
    if (!row[GRID_GROUP_CHECK] && result === undefined) {
        // tslint:disable-next-line: no-console
        console.warn('The row id is undefined. Check the getRowId function. The row is', row);
    }
    return result;
}; };
var rowIdGetter = function (getRowId, rows) {
    if (!getRowId) {
        var map_1 = new Map(rows.map(function (row, rowIndex) { return [row, rowIndex]; }));
        return function (row) { return map_1.get(row); };
    }
    return warnIfRowIdUndefined(getRowId);
};
var defaultGetCellValue = function (row, columnName) { return row[columnName]; };
var cellValueGetter = function (getCellValue, columns) {
    if (getCellValue === void 0) { getCellValue = defaultGetCellValue; }
    var useFastAccessor = true;
    var map = columns.reduce(function (acc, column) {
        if (column.getCellValue) {
            useFastAccessor = false;
            acc[column.name] = column.getCellValue;
        }
        return acc;
    }, {});
    if (useFastAccessor) {
        return getCellValue;
    }
    return function (row, columnName) { return (map[columnName]
        ? map[columnName](row, columnName)
        : getCellValue(row, columnName)); };
};

var changeColumnSorting = function (state, _a) {
    var columnName = _a.columnName, direction = _a.direction, keepOther = _a.keepOther, sortIndex = _a.sortIndex;
    var sorting = state.sorting;
    var nextSorting = [];
    if (keepOther === true) {
        nextSorting = sorting;
    }
    if (Array.isArray(keepOther)) {
        nextSorting = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(sorting)
            .filter(function (s) {
            return keepOther.indexOf(s.columnName) > -1;
        });
    }
    var columnSortingIndex = sorting.findIndex(function (s) { return s.columnName === columnName; });
    var columnSorting = sorting[columnSortingIndex];
    var newColumnSorting = {
        columnName: columnName,
        direction: direction
            || (!columnSorting || columnSorting.direction === 'desc' ? 'asc' : 'desc'),
    };
    if (columnSortingIndex > -1) {
        nextSorting = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(nextSorting);
        nextSorting.splice(columnSortingIndex, 1);
    }
    if (direction !== null) {
        var newIndexFallback = columnSortingIndex > -1 ? columnSortingIndex : nextSorting.length;
        var newIndex = sortIndex !== undefined ? sortIndex : newIndexFallback;
        nextSorting = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(nextSorting);
        nextSorting.splice(newIndex, 0, newColumnSorting);
    }
    return {
        sorting: nextSorting,
    };
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var unique = function (arr) { return __spread(Array.from(new Set(arr))); };
var getColumnSortingDirection = function (sorting, columnName) {
    var columnSorting = sorting.filter(function (s) { return s.columnName === columnName; })[0];
    return columnSorting ? columnSorting.direction : null;
};
var getPersistentSortedColumns = function (sorting, columnExtensions) {
    if (columnExtensions === void 0) { columnExtensions = []; }
    return columnExtensions.reduce(function (acc, _a) {
        var columnName = _a.columnName, sortingEnabled = _a.sortingEnabled;
        if (sortingEnabled === false) {
            if (sorting.findIndex(function (sortItem) { return sortItem.columnName === columnName; }) > -1) {
                acc.push(columnName);
            }
        }
        return acc;
    }, []);
};
var calculateKeepOther = function (sorting, keepOther, persistentSortedColumns) {
    if (persistentSortedColumns === void 0) { persistentSortedColumns = []; }
    if (!persistentSortedColumns.length)
        return keepOther;
    if (!keepOther)
        return persistentSortedColumns;
    return Array.isArray(keepOther)
        ? unique(__spread(keepOther, persistentSortedColumns))
        : unique(__spread(sorting.map(function (item) { return item.columnName; }), persistentSortedColumns));
};

/* eslint-disable no-plusplus, no-param-reassign, no-use-before-define, no-constant-condition */
/* tslint:disable no-increment-decrement */
var merge = function (array, auxiliary, lo, mid, hi, compare) {
    var i = lo;
    var j = mid + 1;
    var k = lo;
    while (true) {
        var cmp = compare(array[i], array[j]);
        if (cmp <= 0) {
            auxiliary[k++] = array[i++];
            if (i > mid) {
                do {
                    auxiliary[k++] = array[j++];
                } while (j <= hi);
                break;
            }
        }
        else {
            auxiliary[k++] = array[j++];
            if (j > hi) {
                do {
                    auxiliary[k++] = array[i++];
                } while (i <= mid);
                break;
            }
        }
    }
};
var sortArrayToAuxiliary = function (array, auxiliary, lo, hi, compare) {
    if (hi < lo)
        return;
    if (hi === lo) {
        auxiliary[lo] = array[lo];
        return;
    }
    var mid = Math.floor(lo + ((hi - lo) / 2));
    sortAuxiliaryToArray(array, auxiliary, lo, mid, compare);
    sortAuxiliaryToArray(array, auxiliary, mid + 1, hi, compare);
    merge(array, auxiliary, lo, mid, hi, compare);
};
var sortAuxiliaryToArray = function (array, auxiliary, lo, hi, compare) {
    if (hi <= lo)
        return;
    var mid = Math.floor(lo + ((hi - lo) / 2));
    sortArrayToAuxiliary(array, auxiliary, lo, mid, compare);
    sortArrayToAuxiliary(array, auxiliary, mid + 1, hi, compare);
    merge(auxiliary, array, lo, mid, hi, compare);
};
var mergeSort = (function (array, compare) {
    if (compare === void 0) { compare = function (a, b) {
        if (a < b)
            return -1;
        if (a > b)
            return 1;
        return 0;
    }; }
    var result = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(array);
    var auxiliary = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(array);
    sortAuxiliaryToArray(result, auxiliary, 0, result.length - 1, compare);
    return result;
});

var NODE_CHECK = Symbol('node');
var rowsToTree = function (rows, getRowLevelKey) {
    if (!rows.length)
        return rows;
    var levels = [{ children: [] }];
    rows.forEach(function (row) {
        var _a;
        var levelKey = getRowLevelKey(row);
        if (levelKey) {
            var levelIndex = levels.slice(1)
                .findIndex(function (level) { return getRowLevelKey(level.root) === levelKey; }) + 1;
            if (levelIndex > 0) {
                levels.splice(levelIndex, levels.length - levelIndex);
            }
            var node = (_a = {}, _a[NODE_CHECK] = true, _a.root = row, _a.children = [], _a);
            levels[levels.length - 1].children.push(node);
            levels.push(node);
        }
        else {
            levels[levels.length - 1].children.push(row);
        }
    });
    return levels[0].children;
};
var treeToRows = function (tree, rows) {
    if (rows === void 0) { rows = []; }
    if (!tree.length)
        return tree;
    return tree.reduce(function (acc, node) {
        if (node[NODE_CHECK]) {
            acc.push(node.root);
            treeToRows(node.children, rows);
        }
        else {
            acc.push(node);
        }
        return acc;
    }, rows);
};

var defaultCompare = function (a, b) {
    if (a === b)
        return 0;
    if (a === null) {
        return b === undefined ? -1 : 1;
    }
    if (a === undefined) {
        return 1;
    }
    if (b === null || b === undefined) {
        return -1;
    }
    return a < b ? -1 : 1;
};
var createCompare = function (sorting, getColumnCompare, getComparableValue) { return sorting.reduceRight(function (prevCompare, columnSorting) {
    var columnName = columnSorting.columnName;
    var inverse = columnSorting.direction === 'desc';
    var columnCompare = (getColumnCompare && getColumnCompare(columnName)) || defaultCompare;
    return function (aRow, bRow) {
        var a = getComparableValue(aRow, columnName);
        var b = getComparableValue(bRow, columnName);
        var result = columnCompare(a, b);
        if (result !== 0) {
            return inverse ? -result : result;
        }
        return prevCompare(aRow, bRow);
    };
}, function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return 0;
}); };
var sortTree = function (tree, compare) {
    var sortedTree = tree.map(function (node) {
        if (node[NODE_CHECK]) {
            return __assign(__assign({}, node), { children: sortTree(node.children, compare) });
        }
        return node;
    });
    return mergeSort(sortedTree, function (a, b) { return compare(a[NODE_CHECK] ? a.root : a, b[NODE_CHECK] ? b.root : b); });
};
var sortHierarchicalRows = function (rows, compare, getRowLevelKey) {
    var tree = rowsToTree(rows, getRowLevelKey);
    var sortedTree = sortTree(tree, compare);
    return treeToRows(sortedTree);
};
var sortedRows = function (rows, sorting, getCellValue, getColumnCompare, isGroupRow, getRowLevelKey) {
    if (!sorting.length || !rows.length)
        return rows;
    var compare;
    if (!getRowLevelKey) {
        compare = createCompare(sorting, getColumnCompare, getCellValue);
        return mergeSort(rows.slice(), compare);
    }
    compare = createCompare(sorting, getColumnCompare, function (row, columnName) {
        if (isGroupRow && isGroupRow(row)) {
            if (row.groupedBy === columnName) {
                return row.value;
            }
            return undefined;
        }
        return getCellValue(row, columnName);
    });
    return sortHierarchicalRows(rows, compare, getRowLevelKey);
};

var changeColumnFilter = function (filters, _a) {
    var columnName = _a.columnName, config = _a.config;
    var filterIndex = filters.findIndex(function (f) { return f.columnName === columnName; });
    var nextState = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(filters);
    if (config) {
        var filter = __assign({ columnName: columnName }, config);
        if (filterIndex > -1) {
            nextState.splice(filterIndex, 1, filter);
        }
        else {
            nextState.push(filter);
        }
    }
    else if (filterIndex > -1) {
        nextState.splice(filterIndex, 1);
    }
    return nextState;
};

var getColumnFilterConfig = function (filters, columnName) { return (filters.length && filters.filter(function (s) { return s.columnName === columnName; })[0] || null); };

var filterExpression = function (filters, expression) {
    // tslint:disable-next-line: no-object-literal-type-assertion
    var selfFilterExpr = { filters: filters, operator: 'and' };
    if (!expression) {
        return selfFilterExpr;
    }
    return {
        operator: 'and',
        filters: [expression, selfFilterExpr],
    };
};

var operators = {
    or: function (predicates) { return function (row) { return (predicates.reduce(function (acc, predicate) { return acc || predicate(row); }, false)); }; },
    and: function (predicates) { return function (row) { return (predicates.reduce(function (acc, predicate) { return acc && predicate(row); }, true)); }; },
};
var toLowerCase = function (value) { return String(value).toLowerCase(); };
var operationPredicates = {
    contains: function (value, filter) { return toLowerCase(value)
        .indexOf(toLowerCase(filter.value)) > -1; },
    notContains: function (value, filter) { return toLowerCase(value)
        .indexOf(toLowerCase(filter.value)) === -1; },
    startsWith: function (value, filter) { return toLowerCase(value)
        .startsWith(toLowerCase(filter.value)); },
    endsWith: function (value, filter) { return toLowerCase(value)
        .endsWith(toLowerCase(filter.value)); },
    equal: function (value, filter) { return String(value) === String(filter.value); },
    notEqual: function (value, filter) { return String(value) !== String(filter.value); },
    greaterThan: function (value, filter) { return value > filter.value; },
    greaterThanOrEqual: function (value, filter) { return value >= filter.value; },
    lessThan: function (value, filter) { return value < filter.value; },
    lessThanOrEqual: function (value, filter) { return value <= filter.value; },
};
var defaultFilterPredicate = function (value, filter) {
    var operation = filter.operation || 'contains';
    return operationPredicates[operation](value, filter);
};
var filterTree = function (tree, predicate) { return tree.reduce(function (acc, node) {
    if (node[NODE_CHECK]) {
        var filteredChildren = filterTree(node.children, predicate);
        if (filteredChildren.length > 0) {
            acc.push(__assign(__assign({}, node), { children: filteredChildren }));
            return acc;
        }
        if (predicate(node.root, true)) {
            acc.push(node.root);
            return acc;
        }
        return acc;
    }
    if (predicate(node)) {
        acc.push(node);
        return acc;
    }
    return acc;
}, []); };
var filterHierarchicalRows = function (rows, predicate, getRowLevelKey, getCollapsedRows) {
    var tree = rowsToTree(rows, getRowLevelKey);
    var collapsedRowsMeta = [];
    var filteredTree = filterTree(tree, function (row, isNode) {
        if (isNode) {
            var collapsedRows = getCollapsedRows && getCollapsedRows(row);
            if (collapsedRows && collapsedRows.length) {
                var filteredCollapsedRows = collapsedRows.filter(predicate);
                collapsedRowsMeta.push([row, filteredCollapsedRows]);
                return !!filteredCollapsedRows.length || predicate(row);
            }
            if (predicate(row)) {
                collapsedRowsMeta.push([row, []]);
                return true;
            }
            return false;
        }
        return predicate(row);
    });
    return { rows: treeToRows(filteredTree), collapsedRowsMeta: new Map(collapsedRowsMeta) };
};
var buildPredicate = function (initialFilterExpression, getCellValue, getColumnPredicate) {
    var getSimplePredicate = function (filter) {
        var columnName = filter.columnName;
        var customPredicate = getColumnPredicate && getColumnPredicate(columnName);
        var predicate = customPredicate || defaultFilterPredicate;
        return function (row) { return predicate(getCellValue(row, columnName), filter, row); };
    };
    var getOperatorPredicate = function (filterExpression) {
        var build = operators[toLowerCase(filterExpression.operator)];
        return build && build(filterExpression.filters.map(getPredicate));
    };
    var getPredicate = function (filterExpression) { return (getOperatorPredicate(filterExpression)
        || getSimplePredicate(filterExpression)); };
    return getPredicate(initialFilterExpression);
};
var filteredRows = function (rows, filterExpression, getCellValue, getColumnPredicate, getRowLevelKey, getCollapsedRows) {
    if (!(filterExpression && Object.keys(filterExpression).length && rows.length)) {
        // tslint:disable-next-line:no-object-literal-type-assertion
        return { rows: rows };
    }
    var predicate = buildPredicate(filterExpression, getCellValue, getColumnPredicate);
    return getRowLevelKey
        ? filterHierarchicalRows(rows, predicate, getRowLevelKey, getCollapsedRows)
        : { rows: rows.filter(predicate) };
};
var filteredCollapsedRowsGetter = function (_a) {
    var collapsedRowsMeta = _a.collapsedRowsMeta;
    return function (row) { return collapsedRowsMeta && collapsedRowsMeta.get(row); };
};
var unwrappedFilteredRows = function (_a) {
    var rows = _a.rows;
    return rows;
};

var GROUP_KEY_SEPARATOR = '|';

var applyColumnGrouping = function (grouping, _a) {
    var columnName = _a.columnName, groupIndex = _a.groupIndex;
    var nextGrouping = grouping;
    var groupingIndex = nextGrouping.findIndex(function (g) { return g.columnName === columnName; });
    var targetIndex = groupIndex;
    if (groupingIndex > -1) {
        nextGrouping = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(grouping);
        nextGrouping.splice(groupingIndex, 1);
    }
    else if (groupIndex === undefined) {
        targetIndex = nextGrouping.length;
    }
    if (targetIndex > -1) {
        nextGrouping = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(nextGrouping);
        nextGrouping.splice(targetIndex, 0, {
            columnName: columnName,
        });
    }
    return nextGrouping;
};
var changeColumnGrouping = function (_a, _b) {
    var grouping = _a.grouping, expandedGroups = _a.expandedGroups;
    var columnName = _b.columnName, groupIndex = _b.groupIndex;
    var nextGrouping = applyColumnGrouping(grouping, { columnName: columnName, groupIndex: groupIndex });
    var ungroupedColumnIndex = grouping.findIndex(function (group, index) { return !nextGrouping[index] || group.columnName !== nextGrouping[index].columnName; });
    if (ungroupedColumnIndex === -1) {
        return {
            grouping: nextGrouping,
        };
    }
    var filteredExpandedGroups = expandedGroups.filter(function (group) { return group.split(GROUP_KEY_SEPARATOR).length <= ungroupedColumnIndex; });
    if (filteredExpandedGroups.length === expandedGroups.length) {
        return {
            grouping: nextGrouping,
        };
    }
    return {
        grouping: nextGrouping,
        expandedGroups: filteredExpandedGroups,
    };
};
var toggleExpandedGroups = function (state, _a) {
    var groupKey = _a.groupKey;
    var expandedGroups = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(state.expandedGroups);
    var groupKeyIndex = expandedGroups.indexOf(groupKey);
    if (groupKeyIndex > -1) {
        expandedGroups.splice(groupKeyIndex, 1);
    }
    else {
        expandedGroups.push(groupKey);
    }
    return {
        expandedGroups: expandedGroups,
    };
};
var draftColumnGrouping = function (_a, _b) {
    var grouping = _a.grouping, draftGrouping = _a.draftGrouping;
    var columnName = _b.columnName, groupIndex = _b.groupIndex;
    return ({
        draftGrouping: applyColumnGrouping(draftGrouping || grouping, { columnName: columnName, groupIndex: groupIndex }),
    });
};
var cancelColumnGroupingDraft = function () { return ({
    draftGrouping: null,
}); };

var adjustSortIndex = function (groupingIndex, grouping, sorting) { return Math.max(grouping.slice(0, groupingIndex).reduce(function (acc, columnGrouping) {
    var columnSortingIndex = sorting.findIndex(function (columnSorting) { return columnSorting.columnName === columnGrouping.columnName; });
    return (columnSortingIndex === -1 ? acc - 1 : acc);
}, groupingIndex), 0); };

var defaultColumnCriteria = function (value) { return ({
    value: value,
    key: String(value),
}); };
var getGroupRows = function (rows, grouping, groupsGetter) {
    if (grouping.length === 0) {
        return rows;
    }
    var keyPrefixes = [{ prefix: '', level: 0, rows: rows }];
    var resultRows = [];
    var compoundKeys = {};
    var _loop_1 = function () {
        var _a = keyPrefixes.pop(), keyPrefix = _a.prefix, level = _a.level, currentRows = _a.rows;
        var currentCompoundKey = keyPrefix.slice(0, keyPrefix.length - 1);
        var groupIndex = (_a = compoundKeys[currentCompoundKey]) !== null && _a !== void 0 ? _a : -1;
        var groupRows = grouping[level] && currentRows.length
            ? groupsGetter(currentRows, grouping[level], keyPrefix)
                .map(function (_a, rowIndex) {
                var childRows = _a.childRows, params = __rest(_a, ["childRows"]);
                var compoundKey = params.compoundKey;
                compoundKeys[compoundKey] = groupIndex + rowIndex + 1;
                keyPrefixes.push({
                    prefix: "" + compoundKey + GROUP_KEY_SEPARATOR,
                    level: level + 1,
                    rows: childRows || [],
                });
                return params;
            })
            : currentRows;
        if (groupIndex > -1) {
            resultRows.splice.apply(resultRows, __spread([groupIndex + 1, 0], groupRows));
        }
        else {
            groupRows.forEach(function (row) { return resultRows.push(row); });
        }
    };
    while (keyPrefixes.length) {
        _loop_1();
    }
    return resultRows;
};
var getIntegratedGroups = function (rows, grouping, keyPrefix, getCellValue, getColumnCriteria) {
    var columnName = grouping.columnName;
    var groupCriteria = (getColumnCriteria && getColumnCriteria(columnName))
        || defaultColumnCriteria;
    var groups = new Map();
    rows.forEach(function (row) {
        var rawValue = getCellValue(row, columnName);
        var _a = groupCriteria(rawValue, row), key = _a.key, value = _a.value;
        var sameKeyItems = groups.get(key);
        if (!sameKeyItems) {
            var groupingValue = value === rawValue ? value : value || key;
            groups.set(key, [groupingValue, key, [row]]);
        }
        else {
            sameKeyItems[2].push(row);
        }
    });
    var groupedBy = columnName;
    return __spread(groups.values()).map(function (_a) {
        var _b;
        var _c = __read(_a, 3), value = _c[0], key = _c[1], childRows = _c[2];
        return (_b = {
                groupedBy: groupedBy,
                compoundKey: "" + keyPrefix + key,
                key: key,
                value: value
            },
            _b[GRID_GROUP_CHECK] = true,
            _b[GRID_GROUP_LEVEL_KEY] = GRID_GROUP_TYPE.toString() + "_" + groupedBy,
            _b.childRows = childRows,
            _b);
    });
};

var groupRowChecker = function (row) { return row[GRID_GROUP_CHECK]; };
var groupRowLevelKeyGetter = function (row) { return (row ? row[GRID_GROUP_LEVEL_KEY] : undefined); };
var groupedRows = function (rows, grouping, getCellValue, getColumnCriteria) {
    var groupsGetter = function (currentRows, currentGrouping, prefix) {
        return getIntegratedGroups(currentRows, currentGrouping, prefix, getCellValue, getColumnCriteria);
    };
    return getGroupRows(rows, grouping, groupsGetter);
};
var expandedGroupRows = function (rows, grouping, expandedGroups, isExporting) {
    if (!grouping.length)
        return rows;
    var groupingColumnNames = grouping.map(function (columnGrouping) { return columnGrouping.columnName; });
    var expandedGroupsSet = new Set(expandedGroups);
    var currentGroupExpanded = true;
    var currentGroupLevel = 0;
    return rows.reduce(function (acc, row) {
        var _a;
        if (!row[GRID_GROUP_CHECK]) {
            if (currentGroupExpanded) {
                acc.push(row);
            }
            else {
                acc[acc.length - 1][GRID_GROUP_COLLAPSED_ROWS].push(row);
            }
            return acc;
        }
        var groupLevel = groupingColumnNames.indexOf(row.groupedBy);
        if (groupLevel > currentGroupLevel && !currentGroupExpanded) {
            return acc;
        }
        currentGroupExpanded = expandedGroupsSet.has(row.compoundKey) || isExporting;
        currentGroupLevel = groupLevel;
        if (currentGroupExpanded) {
            acc.push(row);
        }
        else {
            acc.push(__assign(__assign({}, row), (_a = {}, _a[GRID_GROUP_COLLAPSED_ROWS] = [], _a)));
        }
        return acc;
    }, []);
};
var groupCollapsedRowsGetter = function (getCollapsedRows) { return function (row) { return (row[GRID_GROUP_COLLAPSED_ROWS] || (getCollapsedRows && getCollapsedRows(row))); }; };

var getCustomGroups = function (rows, grouping, keyPrefix, getChildGroups, rootRows) {
    var groupedBy = grouping.columnName;
    return getChildGroups(rows, grouping, rootRows)
        .map(function (_a) {
        var _b;
        var key = _a.key, _c = _a.value, value = _c === void 0 ? key : _c, childRows = _a.childRows;
        return (_b = {
                groupedBy: groupedBy,
                compoundKey: "" + keyPrefix + key,
                key: key,
                value: value
            },
            _b[GRID_GROUP_CHECK] = true,
            _b[GRID_GROUP_LEVEL_KEY] = GRID_GROUP_TYPE.toString() + "_" + groupedBy,
            _b.childRows = childRows,
            _b);
    });
};

var customGroupedRows = function (rows, grouping, getChildGroups, rootRows) {
    if (rootRows === void 0) { rootRows = rows; }
    var groupsGetter = function (currentRows, currentGrouping, prefix) {
        return getCustomGroups(currentRows, currentGrouping, prefix, getChildGroups, rootRows);
    };
    return getGroupRows(rows, grouping, groupsGetter);
};
var customGroupingRowIdGetter = function (getRowId, rows) {
    var firstRow = rows.find(function (row) { return !row[GRID_GROUP_CHECK]; });
    if (!firstRow || getRowId(firstRow) !== undefined) {
        return getRowId;
    }
    var map = new Map(rows
        .filter(function (row) { return !row[GRID_GROUP_CHECK]; })
        .map(function (row, rowIndex) { return [row, rowIndex]; }));
    return function (row) { return map.get(row); };
};

var groupingPanelItems = function (columns, grouping, draftGrouping) {
    var items = draftGrouping.map(function (_a) {
        var columnName = _a.columnName;
        return ({
            column: columns.find(function (c) { return c.name === columnName; }),
            draft: !grouping.some(function (columnGrouping) { return columnGrouping.columnName === columnName; }),
        });
    });
    grouping.forEach(function (_a, index) {
        var columnName = _a.columnName;
        if (draftGrouping.some(function (columnGrouping) { return columnGrouping.columnName === columnName; }))
            return;
        items.splice(index, 0, {
            column: columns.find(function (c) { return c.name === columnName; }),
            draft: true,
        });
    });
    return items;
};

var setCurrentPage = function (prevPage, page) { return page; };
var setPageSize = function (prevPageSize, size) { return size; };

var clamp = function (value, max) { return (Math.max(Math.min(value, max), 0)); };

// tslint:disable-next-line:max-line-length
var PAGE_HEADERS_OVERFLOW_ERROR = 'Max row level exceeds the page size. Consider increasing the page size.';
var paginatedRows = function (rows, pageSize, page) { return (pageSize
    ? rows.slice(pageSize * page, pageSize * (page + 1))
    : rows); };
var rowsWithPageHeaders = function (rows, pageSize, getRowLevelKey) {
    if (!pageSize || !getRowLevelKey)
        return rows;
    var result = rows.slice();
    var headerRows = [];
    var currentIndex = 0;
    var _loop_1 = function () {
        var row = result[currentIndex];
        var levelKey = getRowLevelKey(row);
        if (levelKey) {
            var headerIndex = headerRows.findIndex(function (headerRow) { return getRowLevelKey(headerRow) === levelKey; });
            // tslint:disable-next-line:prefer-conditional-expression
            if (headerIndex === -1) {
                headerRows = __spread(headerRows, [row]);
            }
            else {
                headerRows = __spread(headerRows.slice(0, headerIndex), [row]);
            }
            if (headerRows.length >= pageSize) {
                throw new Error(PAGE_HEADERS_OVERFLOW_ERROR);
            }
        }
        var indexInPage = currentIndex % pageSize;
        if (indexInPage < headerRows.length && row !== headerRows[indexInPage]) {
            result = __spread(result.slice(0, currentIndex), [
                headerRows[indexInPage]
            ], result.slice(currentIndex));
        }
        currentIndex += 1;
    };
    while (result.length > currentIndex) {
        _loop_1();
    }
    return result;
};
var rowCount = function (rows) { return rows.length; };
var pageCount = function (count, pageSize) { return (pageSize ? Math.ceil(count / pageSize) : 1); };
var currentPage = function (page, totalCount, pageSize, setCurrentPage) {
    var totalPages = pageCount(totalCount, pageSize);
    var adjustedCurrentPage = clamp(page, totalPages - 1);
    if (page !== adjustedCurrentPage) {
        setTimeout(function () { return setCurrentPage(adjustedCurrentPage); });
    }
    return adjustedCurrentPage;
};

var firstRowOnPage = function (currentPage, pageSize, totalCount) {
    if (totalCount === 0) {
        return 0;
    }
    return pageSize ? (currentPage * pageSize) + 1 : 1;
};
var lastRowOnPage = function (currentPage, pageSize, totalRowCount) {
    var result = totalRowCount;
    if (pageSize) {
        var index = (currentPage + 1) * pageSize;
        result = index > totalRowCount ? totalRowCount : index;
    }
    return result;
};
var calculateStartPage = function (currentPage, maxButtonCount, totalPageCount) { return (Math.max(Math.min(currentPage - Math.floor(maxButtonCount / 2), (totalPageCount - maxButtonCount) + 1), 1)); };

var toggle = function (source, items, state) {
    var itemsSet = new Set(items);
    var sourceState = state;
    if (sourceState === undefined) {
        var availableSelection = source.filter(function (item) { return itemsSet.has(item); });
        sourceState = availableSelection.length !== itemsSet.size;
    }
    if (sourceState) {
        var sourceSet_1 = new Set(source);
        return __spread(source, items.filter(function (item) { return !sourceSet_1.has(item); }));
    }
    return source.filter(function (item) { return !itemsSet.has(item); });
};

var toggleSelection = function (selection, _a) {
    var rowIds = _a.rowIds, state = _a.state;
    return toggle(selection, rowIds, state);
};

var rowsWithAvailableToSelect = function (rows, getRowId, isGroupRow) {
    var dataRows = rows;
    if (isGroupRow) {
        dataRows = dataRows.filter(function (row) { return !isGroupRow(row); });
    }
    return { rows: rows, availableToSelect: dataRows.map(function (row) { return getRowId(row); }) };
};
var someSelected = function (_a, selection) {
    var availableToSelect = _a.availableToSelect;
    var selectionSet = new Set(selection);
    return availableToSelect.length !== 0 && selectionSet.size !== 0
        && availableToSelect.some(function (elem) { return selectionSet.has(elem); })
        && availableToSelect.some(function (elem) { return !selectionSet.has(elem); });
};
var allSelected = function (_a, selection) {
    var availableToSelect = _a.availableToSelect;
    var selectionSet = new Set(selection);
    return selectionSet.size !== 0 && availableToSelect.length !== 0
        && !availableToSelect.some(function (elem) { return !selectionSet.has(elem); });
};
var unwrapSelectedRows = function (_a) {
    var rows = _a.rows;
    return rows;
};

var startEditRows = function (prevEditingRowIds, _a) {
    var rowIds = _a.rowIds;
    return __spread(prevEditingRowIds, rowIds);
};
var stopEditRows = function (prevEditingRowIds, _a) {
    var rowIds = _a.rowIds;
    var rowIdSet = new Set(rowIds);
    return prevEditingRowIds.filter(function (id) { return !rowIdSet.has(id); });
};
var startEditCells = function (prevEditingCells, _a) {
    var editingCells = _a.editingCells;
    return __spread(prevEditingCells, editingCells);
};
var stopEditCells = function (prevEditingCells, _a) {
    var editingCells = _a.editingCells;
    return prevEditingCells.filter(function (_a) {
        var rowId = _a.rowId, columnName = _a.columnName;
        return (!editingCells.some(function (_a) {
            var currentRowId = _a.rowId, currentColumnName = _a.columnName;
            return (currentRowId === rowId && currentColumnName === columnName);
        }));
    });
};
var addRow = function (addedRows, _a) {
    var _b = _a === void 0 ? { row: {} } : _a, row = _b.row;
    return __spread(addedRows, [row]);
};
var changeAddedRow = function (addedRows, _a) {
    var rowId = _a.rowId, change = _a.change;
    var result = addedRows.slice();
    result[rowId] = __assign(__assign({}, result[rowId]), change);
    return result;
};
var cancelAddedRows = function (addedRows, _a) {
    var rowIds = _a.rowIds;
    var result = [];
    var indexSet = new Set(rowIds);
    addedRows.forEach(function (row, index) {
        if (!indexSet.has(index)) {
            result.push(row);
        }
    });
    return result;
};
var changeRow = function (prevRowChanges, _a) {
    var _b;
    var rowId = _a.rowId, change = _a.change;
    var prevChange = prevRowChanges[rowId] || {};
    return __assign(__assign({}, prevRowChanges), (_b = {}, _b[rowId] = __assign(__assign({}, prevChange), change), _b));
};
var cancelChanges = function (prevRowChanges, _a) {
    var rowIds = _a.rowIds;
    var result = __assign({}, prevRowChanges);
    rowIds.forEach(function (rowId) {
        delete result[rowId];
    });
    return result;
};
var deleteRows = function (deletedRowIds, _a) {
    var rowIds = _a.rowIds;
    return __spread(deletedRowIds, rowIds);
};
var cancelDeletedRows = function (deletedRowIds, _a) {
    var rowIds = _a.rowIds;
    var rowIdSet = new Set(rowIds);
    return deletedRowIds.filter(function (rowId) { return !rowIdSet.has(rowId); });
};

var changedRowsByIds = function (changes, rowIds) {
    var result = {};
    rowIds.forEach(function (rowId) {
        result[rowId] = changes[rowId];
    });
    return result;
};
var addedRowsByIds = function (addedRows, rowIds) {
    var rowIdSet = new Set(rowIds);
    var result = [];
    addedRows.forEach(function (row, index) {
        if (rowIdSet.has(index)) {
            result.push(row);
        }
    });
    return result;
};
var defaultCreateRowChange = function (row, value, columnName) {
    var _a;
    return (_a = {}, _a[columnName] = value, _a);
};
var createRowChangeGetter = function (createRowChange, columnExtensions) {
    if (createRowChange === void 0) { createRowChange = defaultCreateRowChange; }
    if (columnExtensions === void 0) { columnExtensions = []; }
    var map = columnExtensions.reduce(function (acc, columnExtension) {
        if (columnExtension.createRowChange) {
            acc[columnExtension.columnName] = columnExtension.createRowChange;
        }
        return acc;
    }, {});
    return function (row, value, columnName) {
        if (map[columnName]) {
            return map[columnName](row, value, columnName);
        }
        return createRowChange(row, value, columnName);
    };
};

var getRowChange = function (rowChanges, rowId) { return rowChanges[rowId] || {}; };

var TABLE_REORDERING_TYPE = Symbol('reordering');

var changeColumnOrder = function (order, _a) {
    var sourceColumnName = _a.sourceColumnName, targetColumnName = _a.targetColumnName;
    var sourceColumnIndex = order.indexOf(sourceColumnName);
    var targetColumnIndex = order.indexOf(targetColumnName);
    var newOrder = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(order);
    newOrder.splice(sourceColumnIndex, 1);
    newOrder.splice(targetColumnIndex, 0, sourceColumnName);
    return newOrder;
};

var TABLE_DATA_TYPE = Symbol('data');
var TABLE_NODATA_TYPE = Symbol('nodata');
var TABLE_FLEX_TYPE = Symbol('flex');

var orderedColumns = function (tableColumns, order) {
    if (tableColumns === void 0) { tableColumns = []; }
    return mergeSort(tableColumns, function (a, b) {
        if (a.type !== TABLE_DATA_TYPE || b.type !== TABLE_DATA_TYPE)
            return 0;
        var aPos = order.indexOf(a.column.name);
        var bPos = order.indexOf(b.column.name);
        return aPos - bPos;
    });
};
var tableHeaderRowsWithReordering = function (tableHeaderRows) { return __spread(tableHeaderRows, [
    {
        key: TABLE_REORDERING_TYPE.toString(),
        type: TABLE_REORDERING_TYPE,
        height: 0,
    },
]); };
var draftOrder = function (order, sourceColumnIndex, targetColumnIndex) {
    if (sourceColumnIndex === -1
        || targetColumnIndex === -1
        || sourceColumnIndex === targetColumnIndex) {
        return order;
    }
    var result = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(order);
    var sourceColumn = order[sourceColumnIndex];
    result.splice(sourceColumnIndex, 1);
    result.splice(targetColumnIndex, 0, sourceColumn);
    return result;
};

var getColumnWidth = function (columnWidths, name, _a) {
    var columnName = _a.columnName, cachedWidths = _a.cachedWidths, shift = _a.shift, minColumnWidth = _a.minColumnWidth, maxColumnWidth = _a.maxColumnWidth, _b = _a.columnExtensions, columnExtensions = _b === void 0 ? [] : _b;
    var change = name === columnName ? shift : -shift;
    var column = columnWidths.find(function (elem) { return elem.columnName === name; });
    var extension = columnExtensions.find(function (elem) { return elem.columnName === name; });
    var width = typeof column.width === 'number'
        ? column.width
        : cachedWidths[name];
    var minWidth = extension && extension.minWidth >= 0
        ? extension.minWidth
        : minColumnWidth;
    var maxWidth = extension && extension.maxWidth >= 0
        ? extension.maxWidth
        : maxColumnWidth;
    var size = Math.max(minWidth, Math.min(width + change, maxWidth));
    return ({ width: width, size: size });
};
var getColumnSizes = function (columnWidths, payload) {
    var columnName = payload.columnName, nextColumnName = payload.nextColumnName, resizingMode = payload.resizingMode, shift = payload.shift;
    var _a = getColumnWidth(columnWidths, columnName, payload), width = _a.width, size = _a.size;
    if (resizingMode === 'nextColumn') {
        var _b = getColumnWidth(columnWidths, nextColumnName, payload), nextWidth = _b.width, nextSize = _b.size;
        if (size + nextSize !== width + nextWidth) {
            var moreThanLimit = size + nextSize > width + nextWidth;
            var columnExpand = shift > 0;
            if (moreThanLimit !== columnExpand) {
                return { size: size, nextSize: width + nextWidth - size };
            }
            return { size: width + nextWidth - nextSize, nextSize: nextSize };
        }
        return { size: size, nextSize: nextSize };
    }
    return { size: size };
};
var isValidValue = function (value, validUnits) {
    var numb = parseInt(value, 10);
    var unit = numb ? value.substr(numb.toString().length) : value;
    var sizeIsAuto = isNaN(numb) && unit === 'auto';
    var sizeIsValid = numb >= 0 && validUnits.some(function (validUnit) { return validUnit === unit; });
    return sizeIsAuto || sizeIsValid;
};
var convertWidth = function (value) {
    if (typeof value === 'string') {
        var numb = parseInt(value, 10);
        if (value.substr(numb.toString().length).length > 0) {
            return value;
        }
        return numb;
    }
    return value;
};

var VALID_UNITS = ['px', '%', 'em', 'rem', 'vm', 'vh', 'vmin', 'vmax', ''];
var NOT_FOR_WIDGET_UNITS = ['%'];
/* tslint:disable max-line-length */
var COLUMN_RESIZING_ERROR = 'The columnWidths property of the TableColumnResizing plugin is given an invalid value.';
var specifyWidths = function (tableColumns, widths, resizingMode, onError) {
    if (resizingMode !== 'widget' && resizingMode !== 'nextColumn') {
        onError();
    }
    if (!widths.length)
        return tableColumns;
    return tableColumns
        .reduce(function (acc, tableColumn) {
        if (tableColumn.type === TABLE_DATA_TYPE) {
            var columnName_1 = tableColumn.column.name;
            var column = widths.find(function (el) { return el.columnName === columnName_1; });
            var width = column && column.width;
            if (typeof width !== 'number') {
                if (width === undefined) {
                    onError();
                }
                else if (!isValidValue(width, VALID_UNITS)) {
                    onError();
                }
                else if (resizingMode === 'widget' && isValidValue(width, NOT_FOR_WIDGET_UNITS)) {
                    onError();
                }
            }
            else if (width < 0) {
                onError();
            }
            if (width === undefined) {
                acc.push(tableColumn);
            }
            else {
                acc.push(__assign(__assign({}, tableColumn), { width: convertWidth(width) }));
            }
        }
        else {
            acc.push(tableColumn);
        }
        return acc;
    }, []);
};
var tableColumnsWithWidths = function (tableColumns, columnWidths, resizingMode) { return specifyWidths(tableColumns, columnWidths, resizingMode, throwError); };
var tableColumnsWithDraftWidths = function (tableColumns, draftColumnWidths, resizingMode) { return specifyWidths(tableColumns, draftColumnWidths, resizingMode, function () { }); };
var throwError = function () {
    throw new Error(COLUMN_RESIZING_ERROR);
};

var changeTableColumnWidth = function (state, payload) {
    var columnWidths = state.columnWidths;
    var columnName = payload.columnName, nextColumnName = payload.nextColumnName, resizingMode = payload.resizingMode;
    var nextColumnWidth = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(columnWidths);
    var index = nextColumnWidth.findIndex(function (elem) { return elem.columnName === columnName; });
    var nextIndex = nextColumnWidth.findIndex(function (elem) { return elem.columnName === nextColumnName; });
    var _a = getColumnSizes(columnWidths, payload), size = _a.size, nextSize = _a.nextSize;
    nextColumnWidth.splice(index, 1, { columnName: columnName, width: size });
    if (resizingMode === 'nextColumn') {
        nextColumnWidth.splice(nextIndex, 1, { columnName: nextColumnName, width: nextSize });
    }
    return {
        columnWidths: nextColumnWidth,
    };
};
var draftTableColumnWidth = function (state, payload) {
    var columnWidths = state.columnWidths;
    var columnName = payload.columnName, nextColumnName = payload.nextColumnName, resizingMode = payload.resizingMode;
    var _a = getColumnSizes(columnWidths, payload), size = _a.size, nextSize = _a.nextSize;
    if (resizingMode === 'nextColumn') {
        return { draftColumnWidths: [
                { columnName: columnName, width: size }, { columnName: nextColumnName, width: nextSize },
            ] };
    }
    return { draftColumnWidths: [{ columnName: columnName, width: size }] };
};
var cancelTableColumnWidthDraft = function () { return ({
    draftColumnWidths: [],
}); };

var TABLE_EDIT_COMMAND_TYPE = Symbol('editCommand');

var TABLE_ADDED_TYPE = Symbol('added');
var TABLE_EDIT_TYPE = Symbol('edit');

var TABLE_HEADING_TYPE = Symbol('heading');

var isHeadingEditCommandsTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_HEADING_TYPE && tableColumn.type === TABLE_EDIT_COMMAND_TYPE; };
var isEditCommandsTableCell = function (tableRow, tableColumn) { return (tableRow.type === TABLE_DATA_TYPE || tableRow.type === TABLE_ADDED_TYPE
    || tableRow.type === TABLE_EDIT_TYPE) && tableColumn.type === TABLE_EDIT_COMMAND_TYPE; };

var tableColumnsWithEditing = function (tableColumns, width) { return __spread([
    { width: convertWidth(width),
        key: TABLE_EDIT_COMMAND_TYPE.toString(), type: TABLE_EDIT_COMMAND_TYPE }
], tableColumns); };

var isEditTableCell = function (tableRow, tableColumn) { return (tableRow.type === TABLE_ADDED_TYPE || tableRow.type === TABLE_EDIT_TYPE)
    && tableColumn.type === TABLE_DATA_TYPE; };
var isAddedTableRow = function (tableRow) { return tableRow.type === TABLE_ADDED_TYPE; };
var isEditTableRow = function (tableRow) { return tableRow.type === TABLE_EDIT_TYPE; };

var tableRowsWithEditing = function (tableRows, editingRowIds, addedRows, rowHeight) {
    var rowIds = new Set(editingRowIds);
    var editedTableRows = tableRows
        .map(function (tableRow) { return (tableRow.type === TABLE_DATA_TYPE && rowIds.has(tableRow.rowId)
        ? __assign(__assign({}, tableRow), { type: TABLE_EDIT_TYPE, height: rowHeight }) : tableRow); });
    var addedTableRows = addedRows
        .map(function (row, rowIndex) { return ({
        row: row,
        key: TABLE_ADDED_TYPE.toString() + "_" + rowIndex,
        type: TABLE_ADDED_TYPE,
        rowId: rowIndex,
        height: rowHeight,
    }); });
    return __spread((0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(addedTableRows).reverse(), editedTableRows);
};

var rowsWithEditingCells = function (tableBodyRows, editingCells) { return tableBodyRows.map(function (row) {
    var rowId = row.rowId, type = row.type;
    if (rowId !== undefined &&
        type === TABLE_DATA_TYPE &&
        editingCells.some(function (elem) { return elem.rowId === rowId; })) {
        return __assign(__assign({}, row), { hasEditCell: true });
    }
    return row;
}); };
var columnsWithEditingCells = function (tableColumns, editingCells) { return tableColumns.map(function (tableColumn) {
    var columnName = tableColumn.column ? tableColumn.column.name : undefined;
    if (columnName !== undefined && editingCells.some(function (elem) { return elem.columnName === columnName; })) {
        return __assign(__assign({}, tableColumn), { hasEditCell: true });
    }
    return tableColumn;
}); };

var TABLE_FILTER_TYPE = Symbol('filter');
var DEFAULT_FILTER_OPERATIONS = [
    'contains',
    'notContains',
    'startsWith',
    'endsWith',
    'equal',
    'notEqual',
];

var isFilterTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_FILTER_TYPE && tableColumn.type === TABLE_DATA_TYPE; };
var isFilterTableRow = function (tableRow) { return tableRow.type === TABLE_FILTER_TYPE; };
var getColumnFilterOperations = function (getAvailableFilterOperations, columnName) { return (getAvailableFilterOperations && getAvailableFilterOperations(columnName))
    || DEFAULT_FILTER_OPERATIONS; };
var isFilterValueEmpty = function (value) { return value === undefined || !String(value).length; };
var getSelectedFilterOperation = function (filterOperations, columnName, columnFilter, columnFilterOperations) {
    if (columnFilter && columnFilter.operation) {
        return columnFilter.operation;
    }
    if (filterOperations[columnName]) {
        return filterOperations[columnName];
    }
    return columnFilterOperations[0];
};

var tableHeaderRowsWithFilter = function (headerRows, rowHeight) { return __spread(headerRows, [
    { key: TABLE_FILTER_TYPE.toString(), type: TABLE_FILTER_TYPE, height: rowHeight }
]); };

var TABLE_GROUP_TYPE = Symbol('group');

var TABLE_STUB_TYPE = Symbol('stub');
var getVisibleBoundaryWithFixed = function (visibleBoundary, items) { return items.reduce(function (acc, item, index) {
    if (item.fixed && (index < visibleBoundary[0] || index > visibleBoundary[1])) {
        acc.push([index, index]);
    }
    return acc;
}, [visibleBoundary]); };
var getVisibleBoundary = function (items, viewportStart, viewportSize, getItemSize, offset, itemSize) {
    if (offset === void 0) { offset = 0; }
    if (itemSize === void 0) { itemSize = 0; }
    var start = null;
    var end = null;
    var index = 0;
    var beforePosition = offset * itemSize;
    var viewportEnd = viewportStart + viewportSize;
    while (end === null && index < items.length) {
        var item = items[index];
        var afterPosition = beforePosition + getItemSize(item);
        var isVisible = (beforePosition >= viewportStart && beforePosition < viewportEnd)
            || (afterPosition > viewportStart && afterPosition <= viewportEnd)
            || (beforePosition < viewportStart && afterPosition > viewportEnd);
        if (isVisible && start === null) {
            start = index;
        }
        if (!isVisible && start !== null) {
            end = index - 1;
            break;
        }
        index += 1;
        beforePosition = afterPosition;
    }
    if (start !== null && end === null) {
        end = index - 1;
    }
    start = start === null ? 0 : start;
    end = end === null ? 0 : end;
    return [start + offset, end + offset];
};
var getRenderBoundary = function (itemsCount, visibleBoundary, overscan) {
    var _a = __read(visibleBoundary, 2), start = _a[0], end = _a[1];
    start = Math.max(0, start - overscan);
    end = Math.min(itemsCount - 1, end + overscan);
    return [start, end];
};
var getColumnBoundaries = function (columns, left, width, getColumnWidth) { return (getVisibleBoundaryWithFixed(getColumnsRenderBoundary(columns.length, getVisibleBoundary(columns, left, width, getColumnWidth, 0)), columns)); };
var getRowsVisibleBoundary = function (rows, top, height, getRowHeight, offset, rowHeight, isDataRemote) {
    var beforePosition = offset * rowHeight;
    var noVisibleRowsLoaded = rowHeight > 0 &&
        beforePosition + rows.length * rowHeight < top ||
        top < beforePosition;
    var boundaries;
    if (isDataRemote && noVisibleRowsLoaded) {
        var topIndex = Math.round(top / rowHeight);
        boundaries = [topIndex, topIndex];
    }
    else {
        boundaries = getVisibleBoundary(rows, top, height, getRowHeight, offset, rowHeight);
    }
    return boundaries;
};
var getColumnsRenderBoundary = function (columnCount, visibleBoundary) { return getRenderBoundary(columnCount, visibleBoundary, 1); };
var getRowsRenderBoundary = function (rowsCount, visibleBoundary) { return getRenderBoundary(rowsCount, visibleBoundary, 3); };
var getSpanBoundary = function (items, visibleBoundaries, getItemSpan) { return visibleBoundaries
    .map(function (visibleBoundary) {
    var endIndex = Math.min(visibleBoundary[1], items.length - 1);
    var end = endIndex;
    var start = visibleBoundary[0] <= end ? visibleBoundary[0] : 0;
    for (var index = 0; index <= endIndex; index += 1) {
        var span = getItemSpan(items[index]);
        if (index < visibleBoundary[0] && index + span > visibleBoundary[0]) {
            start = index;
        }
        if (index + (span - 1) > visibleBoundary[1]) {
            end = index + (span - 1);
        }
    }
    return [start, end];
}); };
var collapseBoundaries = function (itemsCount, visibleBoundaries, spanBoundaries) {
    var breakpoints = new Set([0, itemsCount]);
    spanBoundaries.forEach(function (rowBoundaries) { return rowBoundaries
        .forEach(function (boundary) {
        breakpoints.add(boundary[0]);
        // next interval starts after span end point
        breakpoints.add(Math.min(boundary[1] + 1, itemsCount));
    }); });
    visibleBoundaries
        .filter(function (boundary) { return boundary.every(function (bound) { return 0 <= bound && bound < itemsCount; }); })
        .forEach(function (boundary) {
        for (var point = boundary[0]; point <= boundary[1]; point += 1) {
            breakpoints.add(point);
        }
        if (boundary[1] + 1 < itemsCount) {
            // close last visible point
            breakpoints.add(boundary[1] + 1);
        }
    });
    var bp = __spread(breakpoints).sort(function (a, b) { return a - b; });
    var bounds = [];
    for (var i = 0; i < bp.length - 1; i += 1) {
        bounds.push([
            bp[i],
            bp[i + 1] - 1,
        ]);
    }
    return bounds;
};
var getColumnsSize = function (columns, startIndex, endIndex, getColumnSize) {
    var size = 0;
    for (var i = startIndex; i <= endIndex; i += 1) {
        size += getColumnSize(columns[i], 0) || 0;
    }
    return size;
};
var getCollapsedColumns = function (columns, visibleBoundaries, boundaries, getColumnWidth) {
    var collapsedColumns = [];
    boundaries.forEach(function (boundary) {
        var isVisible = visibleBoundaries.reduce(function (acc, visibleBoundary) { return (acc || (visibleBoundary[0] <= boundary[0] && boundary[1] <= visibleBoundary[1])); }, false);
        if (isVisible) {
            var column = columns[boundary[0]];
            collapsedColumns.push(__assign(__assign({}, column), { width: getColumnWidth(column) }));
        }
        else {
            collapsedColumns.push({
                key: TABLE_STUB_TYPE.toString() + "_" + boundary[0] + "_" + boundary[1],
                type: TABLE_STUB_TYPE,
                width: getColumnsSize(columns, boundary[0], boundary[1], getColumnWidth),
            });
        }
    });
    return collapsedColumns;
};
var getCollapsedRows = function (rows, visibleBoundary, boundaries, getRowHeight, getCells, offset) {
    var collapsedRows = [];
    boundaries.forEach(function (boundary) {
        var isVisible = visibleBoundary[0] <= boundary[0] && boundary[1] <= visibleBoundary[1];
        if (isVisible) {
            var row = rows[boundary[0] - offset];
            collapsedRows.push({
                row: row,
                cells: getCells(row),
            });
        }
        else {
            var row = {};
            collapsedRows.push({
                row: {
                    key: TABLE_STUB_TYPE.toString() + "_" + boundary[0] + "_" + boundary[1],
                    type: TABLE_STUB_TYPE,
                    height: getColumnsSize(rows, boundary[0], boundary[1], getRowHeight),
                },
                cells: getCells(row),
            });
        }
    });
    return collapsedRows;
};
var getCollapsedCells = function (columns, spanBoundaries, boundaries, getColSpan) {
    var collapsedCells = [];
    var index = 0;
    var _loop_1 = function () {
        var boundary = boundaries[index];
        var isSpan = spanBoundaries.reduce(function (acc, spanBoundary) { return (acc || (spanBoundary[0] <= boundary[0] && boundary[1] <= spanBoundary[1])); }, false);
        if (isSpan) {
            var column = columns[boundary[0]];
            var realColSpan = getColSpan(column);
            var realColSpanEnd_1 = (realColSpan + boundary[0]) - 1;
            var colSpanEnd = boundaries.findIndex(function (colSpanBoundary) { return colSpanBoundary[0]
                <= realColSpanEnd_1 && realColSpanEnd_1
                <= colSpanBoundary[1]; });
            collapsedCells.push({
                column: column,
                colSpan: (colSpanEnd - index) + 1,
            });
            index += 1;
        }
        else {
            collapsedCells.push({
                column: {
                    key: TABLE_STUB_TYPE.toString() + "_" + boundary[0] + "_" + boundary[1],
                    type: TABLE_STUB_TYPE,
                },
                colSpan: 1,
            });
            index += 1;
        }
    };
    while (index < boundaries.length) {
        _loop_1();
    }
    return collapsedCells;
};
var getCollapsedGrid = function (_a) {
    var rows = _a.rows, columns = _a.columns, rowsVisibleBoundary = _a.rowsVisibleBoundary, columnsVisibleBoundary = _a.columnsVisibleBoundary, _b = _a.getColumnWidth, getColumnWidth = _b === void 0 ? function (column) { return column.width; } : _b, _c = _a.getRowHeight, getRowHeight = _c === void 0 ? function (row) { return row.height; } : _c, _d = _a.getColSpan, getColSpan = _d === void 0 ? function () { return 1; } : _d, totalRowCount = _a.totalRowCount, offset = _a.offset;
    if (!columns.length) {
        return {
            columns: [],
            rows: [],
        };
    }
    var boundaries = rowsVisibleBoundary || [0, rows.length - 1 || 1];
    var rowSpanBoundaries = rows
        .slice(boundaries[0], boundaries[1])
        .map(function (row) { return getSpanBoundary(columns, columnsVisibleBoundary, function (column) { return getColSpan(row, column); }); });
    var columnBoundaries = collapseBoundaries(columns.length, columnsVisibleBoundary, rowSpanBoundaries);
    var rowBoundaries = collapseBoundaries(totalRowCount, [boundaries], []);
    return {
        columns: getCollapsedColumns(columns, columnsVisibleBoundary, columnBoundaries, getColumnWidth),
        rows: getCollapsedRows(rows, boundaries, rowBoundaries, getRowHeight, function (row) { return getCollapsedCells(columns, getSpanBoundary(columns, columnsVisibleBoundary, function (column) { return getColSpan(row, column); }), columnBoundaries, function (column) { return getColSpan(row, column); }); }, offset),
    };
};
var getColumnWidthGetter = function (tableColumns, tableWidth, minColumnWidth) {
    var colsHavingWidth = tableColumns.filter(function (col) { return typeof col.width === 'number'; });
    var columnsWidth = colsHavingWidth.reduce(function (acc, col) { return (acc + col.width); }, 0);
    var autoWidth = (tableWidth - columnsWidth) / (tableColumns.length - colsHavingWidth.length);
    var autoColWidth = Math.max(autoWidth, minColumnWidth);
    return function (column) { return (column.type === TABLE_FLEX_TYPE
        ? null
        : typeof column.width === 'number' ? column.width : autoColWidth); };
};
var getCollapsedGrids = function (_a) {
    var _b = _a.headerRows, headerRows = _b === void 0 ? [] : _b, _c = _a.bodyRows, bodyRows = _c === void 0 ? [] : _c, _d = _a.footerRows, footerRows = _d === void 0 ? [] : _d, columns = _a.columns, loadedRowsStart = _a.loadedRowsStart, totalRowCount = _a.totalRowCount, getCellColSpan = _a.getCellColSpan, viewport = _a.viewport, getRowHeight = _a.getRowHeight, getColumnWidth = _a.getColumnWidth;
    var getColSpan = function (tableRow, tableColumn) { return getCellColSpan({ tableRow: tableRow, tableColumn: tableColumn, tableColumns: columns }); };
    var getCollapsedGridBlock = function (rows, rowsVisibleBoundary, rowCount, offset) {
        if (rowCount === void 0) { rowCount = rows.length; }
        if (offset === void 0) { offset = 0; }
        return getCollapsedGrid({
            rows: rows,
            columns: columns,
            rowsVisibleBoundary: rowsVisibleBoundary,
            columnsVisibleBoundary: viewport.columns,
            getColumnWidth: getColumnWidth,
            getRowHeight: getRowHeight,
            getColSpan: getColSpan,
            totalRowCount: rowCount,
            offset: offset,
        });
    };
    var headerGrid = getCollapsedGridBlock(headerRows, getRenderRowBounds(viewport.headerRows, headerRows.length));
    var bodyGrid = getCollapsedGridBlock(bodyRows, adjustedRenderRowBounds(viewport.rows, bodyRows.length, loadedRowsStart), totalRowCount || 1, loadedRowsStart);
    var footerGrid = getCollapsedGridBlock(footerRows, getRenderRowBounds(viewport.footerRows, footerRows.length));
    return {
        headerGrid: headerGrid,
        bodyGrid: bodyGrid,
        footerGrid: footerGrid,
    };
};
var getRenderRowBounds = function (visibleBounds, rowCount) { return getRowsRenderBoundary(rowCount, visibleBounds); };
var adjustedRenderRowBounds = function (visibleBounds, rowCount, loadedRowsStart) {
    var renderRowBoundaries = getRenderRowBounds(visibleBounds, loadedRowsStart + rowCount);
    var adjustedInterval = intervalUtil.intersect({ start: renderRowBoundaries[0], end: renderRowBoundaries[1] }, { start: loadedRowsStart, end: loadedRowsStart + rowCount });
    return [adjustedInterval.start, adjustedInterval.end];
};

var getGroupIndexByColumn = function (grouping, tableColumn) { return grouping.findIndex(function (columnGrouping) { return !!tableColumn.column && columnGrouping.columnName === tableColumn.column.name; }); };
var isIndentCell = function (tableRow, tableColumn, grouping) {
    if (tableColumn.column && tableRow.row.groupedBy === tableColumn.column.name)
        return false;
    var rowGroupIndex = grouping.findIndex(function (columnGrouping) { return columnGrouping.columnName === tableRow.row.groupedBy; });
    var columnGroupIndex = getGroupIndexByColumn(grouping, tableColumn);
    return columnGroupIndex < rowGroupIndex;
};
var isGroupTableCell = function (tableRow, tableColumn) { return !!(tableRow.type === TABLE_GROUP_TYPE && tableColumn.type === TABLE_GROUP_TYPE
    && tableColumn.column
    && tableColumn.column.name === tableRow.row.groupedBy); };
var isGroupIndentTableCell = function (tableRow, tableColumn, grouping) { return (tableRow.type === TABLE_GROUP_TYPE && tableColumn.type === TABLE_GROUP_TYPE &&
    isIndentCell(tableRow, tableColumn, grouping)); };
var isGroupIndentStubTableCell = function (tableRow, tableColumn, grouping) { return ((tableRow.type === TABLE_GROUP_TYPE && tableColumn.type === TABLE_STUB_TYPE &&
    isIndentCell(tableRow, tableColumn, grouping))); };
var isGroupTableRow = function (tableRow) { return tableRow.type === TABLE_GROUP_TYPE; };
var isGroupRowOrdinaryCell = function (tableRow, tableColumn) { return (isGroupTableRow(tableRow) && !isGroupTableCell(tableRow, tableColumn)); };
var columnHasGroupRowSummary = function (tableColumn, groupSummaryItems) { return (!!(groupSummaryItems && groupSummaryItems
    .some(function (item) { return ((!item.showInGroupFooter && item.alignByColumn)
    && item.columnName === (tableColumn.column && tableColumn.column.name)); }))); };
var isRowSummaryCell = function (tableRow, tableColumn, grouping, groupSummaryItems) { return (columnHasGroupRowSummary(tableColumn, groupSummaryItems)
    && !isGroupIndentTableCell(tableRow, tableColumn, grouping)); };
var isPreviousCellContainSummary = function (tableRow, tableColumn, tableColumns, grouping, groupSummaryItems) {
    var columnIndex = tableColumns.indexOf(tableColumn);
    return columnIndex > 0 && isRowSummaryCell(tableRow, tableColumns[columnIndex - 1], grouping, groupSummaryItems);
};
var calculateGroupCellIndent = function (tableColumn, grouping, indentWidth) { return (indentWidth * getGroupIndexByColumn(grouping, tableColumn)); };
var sortAndSpliceColumns = function (tableColumns, firstVisibleColumnIndex) {
    var groupColumns = tableColumns.filter(function (col) { return col.type === TABLE_GROUP_TYPE; });
    var dataColumns = tableColumns.filter(function (col) { return col.type === TABLE_DATA_TYPE; });
    var flexColumns = tableColumns.filter(function (col) { return col.type === TABLE_FLEX_TYPE; });
    var otherColumns = tableColumns.filter(function (col) {
        return col.type !== TABLE_DATA_TYPE &&
            col.type !== TABLE_GROUP_TYPE &&
            col.type !== TABLE_FLEX_TYPE;
    });
    if (firstVisibleColumnIndex) {
        var firstGroupIndex = tableColumns.indexOf(groupColumns[0]);
        otherColumns.splice(0, Math.min(firstVisibleColumnIndex, firstGroupIndex));
    }
    return __spread(groupColumns, otherColumns, dataColumns, flexColumns);
};

var tableColumnsWithDraftGrouping = function (tableColumns, grouping, draftGrouping, showColumnWhenGrouped) { return tableColumns
    .reduce(function (acc, tableColumn) {
    if (tableColumn.type !== TABLE_DATA_TYPE) {
        acc.push(tableColumn);
        return acc;
    }
    var columnName = tableColumn.column && tableColumn.column.name || '';
    var columnGroupingExists = grouping
        .some(function (columnGrouping) { return columnGrouping.columnName === columnName; });
    var columnDraftGroupingExists = draftGrouping
        .some(function (columnGrouping) { return columnGrouping.columnName === columnName; });
    if ((!columnGroupingExists && !columnDraftGroupingExists)
        || showColumnWhenGrouped(columnName)) {
        acc.push(tableColumn);
    }
    else if ((!columnGroupingExists && columnDraftGroupingExists)
        || (columnGroupingExists && !columnDraftGroupingExists)) {
        acc.push(__assign(__assign({}, tableColumn), { draft: true }));
    }
    return acc;
    // tslint:disable-next-line: prefer-array-literal
}, []); };
var tableColumnsWithGrouping = function (columns, tableColumns, grouping, draftGrouping, indentColumnWidth, showColumnWhenGrouped) { return __spread(grouping.map(function (columnGrouping) {
    var groupedColumn = columns.find(function (column) { return column.name === columnGrouping.columnName; });
    return {
        key: TABLE_GROUP_TYPE.toString() + "_" + groupedColumn.name,
        type: TABLE_GROUP_TYPE,
        column: groupedColumn,
        width: indentColumnWidth,
    };
}), tableColumnsWithDraftGrouping(tableColumns, grouping, draftGrouping, showColumnWhenGrouped)); };
var tableRowsWithGrouping = function (tableRows, isGroupRow) { return tableRows.map(function (tableRow) {
    if (tableRow.type !== TABLE_DATA_TYPE || !isGroupRow(tableRow.row)) {
        return tableRow;
    }
    return __assign(__assign({}, tableRow), { key: TABLE_GROUP_TYPE.toString() + "_" + tableRow.row.compoundKey, type: TABLE_GROUP_TYPE });
}); };
var isRowLevelSummary = function (groupSummaryItems, colName) { return (groupSummaryItems.some(function (item) { return (!item.showInGroupFooter && item.alignByColumn && item.columnName === colName); })); };
var groupSummaryChains = function (tableRow, tableColumns, groupSummaryItems, firstVisibleColumnIndex) {
    var captionStarted = false;
    return sortAndSpliceColumns(tableColumns, firstVisibleColumnIndex)
        .reduce(function (acc, col) {
        var colName = (col.column && col.column.name);
        var isStartOfGroupCaption = col.type === TABLE_GROUP_TYPE
            && tableRow.row.groupedBy === colName;
        var isIndentColumn = col.type === TABLE_GROUP_TYPE
            && tableRow.row.groupedBy !== colName && !captionStarted;
        if (isStartOfGroupCaption) {
            captionStarted = true;
        }
        if (isStartOfGroupCaption || isIndentColumn) {
            acc.push([colName]);
        }
        else if (groupSummaryItems && isRowLevelSummary(groupSummaryItems, colName)) {
            acc.push([colName]);
            acc.push([]);
        }
        else {
            acc[acc.length - 1].push(colName);
        }
        return acc;
    }, [[]]);
};
var tableGroupCellColSpanGetter = function (getTableCellColSpan, groupSummaryItems, firstVisibleColumnIndex) { return function (params) {
    var _a;
    var tableRow = params.tableRow, tableColumns = params.tableColumns, tableColumn = params.tableColumn;
    if (tableRow.type === TABLE_GROUP_TYPE) {
        var colName_1 = (_a = tableColumn.column) === null || _a === void 0 ? void 0 : _a.name;
        var dataColumnGroupedBy_1 = tableRow.row.groupedBy === colName_1 && tableColumn.type !== TABLE_GROUP_TYPE;
        var chains = groupSummaryChains(tableRow, tableColumns, groupSummaryItems, firstVisibleColumnIndex);
        var chain = chains.find(function (ch) { return !dataColumnGroupedBy_1 && ch[0] === colName_1; });
        if (chain) {
            return chain.length;
        }
    }
    return getTableCellColSpan(params);
}; };

var isHeadingTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_HEADING_TYPE && tableColumn.type === TABLE_DATA_TYPE; };
var isHeadingTableRow = function (tableRow) { return (tableRow.type === TABLE_HEADING_TYPE); };
var findChainByColumnIndex = function (chains, columnIndex) { return (chains.find(function (chain) { return (chain.start <= columnIndex && columnIndex < chain.start + chain.columns.length); })); };
var splitHeaderColumnChains = function (tableColumnChains, tableColumns, shouldSplitChain, extendChainProps) { return (tableColumnChains.map(function (row, rowIndex) { return row
    .reduce(function (acc, chain) {
    var currentChain = null;
    chain.columns.forEach(function (col) {
        var column = tableColumns.find(function (c) { return c.key === col.key; });
        var isNewGroup = shouldSplitChain(currentChain, column, rowIndex);
        if (isNewGroup) {
            var start = currentChain
                ? (currentChain.start + currentChain.columns.length)
                : chain.start;
            acc.push(__assign(__assign(__assign({}, chain), extendChainProps(column)), { start: start, columns: [] }));
            currentChain = acc[acc.length - 1];
        }
        currentChain.columns.push(column);
    });
    return acc;
}, []); })); };
var generateSimpleChains = function (rows, columns) { return (rows.map(function () { return ([{
        columns: columns,
        start: 0,
    }]); })); };
var nextColumnName = function (tableColumns, index) {
    var isNextColumnHasName = index < tableColumns.length - 1 && tableColumns[index + 1].column;
    return isNextColumnHasName
        ? tableColumns[index + 1].column.name
        : undefined;
};
var getNextColumnName = function (tableColumns, columnName) {
    var index = tableColumns.findIndex(function (elem) {
        return elem.column && elem.column.name === columnName;
    });
    return index >= 0
        ? nextColumnName(tableColumns, index)
        : undefined;
};

var tableRowsWithHeading = function (headerRows) { return __spread([
    { key: TABLE_HEADING_TYPE.toString(), type: TABLE_HEADING_TYPE }
], headerRows); };

var TABLE_BAND_TYPE = Symbol('band');
var BAND_GROUP_CELL = 'bandGroupCell';
var BAND_HEADER_CELL = 'bandHeaderCell';
var BAND_EMPTY_CELL = 'bandEmptyCell';
var BAND_DUPLICATE_RENDER = 'bandDuplicateRender';
var BAND_FILL_LEVEL_CELL = 'bandFillLevelCell';

var isBandedTableRow = function (tableRow) { return (tableRow.type === TABLE_BAND_TYPE); };
var isBandedOrHeaderRow = function (tableRow) { return isBandedTableRow(tableRow)
    || tableRow.type === TABLE_HEADING_TYPE; };
var isNoDataColumn = function (columnType) { return columnType !== TABLE_DATA_TYPE; };
var getColumnMeta = function (columnName, bands, tableRowLevel, key, level, title, result) {
    if (key === void 0) { key = ''; }
    if (level === void 0) { level = 0; }
    if (title === void 0) { title = null; }
    if (result === void 0) { result = null; }
    return bands.reduce(function (acc, band) {
        if (band.columnName === columnName) {
            return __assign(__assign({}, acc), { title: title, level: level, key: key });
        }
        if (band.children !== undefined) {
            var rowLevelPassed = level > tableRowLevel;
            var bandTitle = rowLevelPassed ? title : band.title;
            var bandKey = rowLevelPassed ? key : key + "_" + bandTitle;
            return getColumnMeta(columnName, band.children, tableRowLevel, bandKey, level + 1, bandTitle, acc);
        }
        return acc;
    }, result || { level: level, title: title, key: title });
};
var calculateBand = function (visibleBound, headerChain) {
    if (visibleBound) {
        var bandStart = Math.max(visibleBound[0], headerChain.start);
        var bandEnd = Math.min(visibleBound[1] + 1, headerChain.start + headerChain.columns.length);
        return [bandStart, bandEnd];
    }
    return [headerChain.start, headerChain.start + headerChain.columns.length];
};
var getBandComponent = function (_a, tableHeaderRows, tableColumns, columnBands, tableHeaderColumnChains, columnVisibleIntervals, bandLevelsVisibility) {
    var currentTableColumn = _a.tableColumn, tableRow = _a.tableRow, rowSpan = _a.rowSpan;
    if (rowSpan)
        return { type: BAND_DUPLICATE_RENDER, payload: null };
    var maxLevel = tableHeaderRows.filter(function (column) { return column.type === TABLE_BAND_TYPE; }).length + 1;
    var level = tableRow.level;
    var currentRowLevel = level === undefined
        ? maxLevel - 1 : level;
    var currentColumnMeta = currentTableColumn.type === TABLE_DATA_TYPE
        ? getColumnMeta(currentTableColumn.column.name, columnBands, currentRowLevel)
        : { level: 0, title: '' };
    var currentColumnIndex = tableColumns
        .findIndex(function (column) { return column.key === currentTableColumn.key; });
    var levelsCount = bandLevelsVisibility.length;
    var visibleLevelsCount = bandLevelsVisibility.filter(Boolean).length;
    if (currentColumnMeta.level < currentRowLevel) {
        var shouldFillLevel = currentRowLevel > 0 && visibleLevelsCount < levelsCount
            && !bandLevelsVisibility[currentRowLevel] && currentTableColumn.type === TABLE_STUB_TYPE;
        if (shouldFillLevel) {
            return { type: BAND_FILL_LEVEL_CELL, payload: null };
        }
        return { type: BAND_EMPTY_CELL, payload: null };
    }
    var previousTableColumn = tableColumns[currentColumnIndex - 1];
    var beforeBorder = false;
    if (currentColumnIndex > 0 && currentTableColumn.type === TABLE_DATA_TYPE
        && isNoDataColumn(previousTableColumn.type)) {
        beforeBorder = true;
    }
    var isStubColumn = currentTableColumn.type === TABLE_STUB_TYPE;
    var isColumnVisible = currentColumnIndex >= 0;
    if (currentColumnMeta.level === currentRowLevel) {
        if (isStubColumn) {
            var cellRowSpan = visibleLevelsCount < levelsCount
                ? visibleLevelsCount || 1
                : maxLevel;
            return {
                type: BAND_FILL_LEVEL_CELL,
                payload: {
                    rowSpan: cellRowSpan,
                },
            };
        }
        if (isColumnVisible) {
            return {
                type: BAND_HEADER_CELL,
                payload: __assign({ tableRow: tableHeaderRows.find(function (row) { return row.type === TABLE_HEADING_TYPE; }), rowSpan: maxLevel - currentRowLevel }, beforeBorder && { beforeBorder: beforeBorder }),
            };
        }
    }
    if (!isColumnVisible)
        return { type: BAND_EMPTY_CELL, payload: null };
    var currentColumnChain = findChainByColumnIndex(tableHeaderColumnChains[currentRowLevel], currentColumnIndex);
    var columnVisibleBoundary = columnVisibleIntervals.find(function (_a) {
        var _b = __read(_a, 2), start = _b[0], end = _b[1];
        return (start <= currentColumnIndex && currentColumnIndex <= end);
    });
    var _b = __read(calculateBand(columnVisibleBoundary, currentColumnChain), 2), bandStart = _b[0], bandEnd = _b[1];
    if (bandStart < currentColumnIndex) {
        return { type: null, payload: null };
    }
    return {
        type: BAND_GROUP_CELL,
        payload: __assign({ colSpan: bandEnd - bandStart, value: currentColumnMeta.title, column: currentColumnMeta }, beforeBorder && { beforeBorder: beforeBorder }),
    };
};

var emptyVirtualRows = {
    skip: Number.POSITIVE_INFINITY,
    rows: [],
};
var pluckSubarray = function (source, sourceStart, left, right) { return (source.slice(left - sourceStart, right - sourceStart)); };
var mergeRows = function (rowsInterval, cacheInterval, rows, cacheRows, rowsStart, cacheStart) {
    var breakpoints = [
        rowsInterval.start, rowsInterval.end,
        cacheInterval.start, cacheInterval.end,
    ]
        .filter(function (i) { return 0 <= i && i < Number.POSITIVE_INFINITY; })
        .sort(function (a, b) { return a - b; });
    var result = [];
    if (breakpoints.length > 1) {
        for (var i = 0; i < breakpoints.length - 1; i += 1) {
            var left = breakpoints[i];
            var right = breakpoints[i + 1];
            var chunk = rowsInterval.start <= left && right <= rowsInterval.end
                ? pluckSubarray(rows, rowsStart, left, right) // rows have higher priority
                : pluckSubarray(cacheRows, cacheStart, left, right);
            result = result.concat(chunk);
        }
    }
    return {
        skip: breakpoints[0],
        rows: result,
    };
};
var correctRequestedRange = function (calculatedRange, referenceIndex, pageSize) {
    var start = calculatedRange.start, end = calculatedRange.end;
    if (start - referenceIndex > pageSize / 2) {
        return { start: start - pageSize, end: start };
    }
    return { start: start, end: end };
};
var calculateRequestedRange = function (virtualRows, newRange, pageSize, referenceIndex, isInfiniteScroll) {
    var loadedInterval = intervalUtil.getRowsInterval(virtualRows);
    var isAdjacentPage = Math.abs(loadedInterval.start - newRange.start) < 2 * pageSize;
    if (isAdjacentPage) {
        var calculatedRange = intervalUtil.difference(newRange, loadedInterval);
        if (isInfiniteScroll && calculatedRange !== intervalUtil.empty) {
            return correctRequestedRange(calculatedRange, referenceIndex, pageSize);
        }
        return calculatedRange;
    }
    // load 3 pages at once because a missing page will be loaded anyway
    return newRange;
};
var rowToPageIndex = function (rowIndex, pageSize) { return Math.floor(rowIndex / pageSize); };
var recalculateBounds = function (middleIndex, pageSize, totalCount) {
    var currentPageIndex = rowToPageIndex(middleIndex, pageSize);
    var prevPageIndex = currentPageIndex - 1;
    var nextPageIndex = currentPageIndex + 2;
    var start = Math.max(0, prevPageIndex * pageSize);
    var end = Math.min(nextPageIndex * pageSize, totalCount);
    return {
        start: start,
        end: end,
    };
};
var trimRowsToInterval = function (virtualRows, targetInterval) {
    var rowsInterval = intervalUtil.getRowsInterval(virtualRows);
    var intersection = intervalUtil.intersect(rowsInterval, targetInterval);
    if (intervalUtil.empty === intersection) {
        return emptyVirtualRows;
    }
    var rows = pluckSubarray(virtualRows.rows, virtualRows.skip, intersection.start, intersection.end);
    return {
        rows: rows,
        skip: intersection.start,
    };
};
var getAvailableRowCount = function (isInfiniteScroll, newRowCount, lastRowCount, totalRowCount) {
    return (isInfiniteScroll
        ? Math.min(Math.max(newRowCount, lastRowCount), totalRowCount)
        : totalRowCount);
};
var getForceReloadInterval = function (virtualRows, pageSize, totalRowCount) {
    var _a = intervalUtil.getRowsInterval(virtualRows), start = _a.start, intervalEnd = _a.end;
    var end = Math.min(Math.max(start + pageSize * 2, intervalEnd), Math.max(start + pageSize * 2, totalRowCount));
    return {
        start: start,
        end: end,
    };
};
var getRequestMeta = function (referenceIndex, virtualRows, pageSize, totalRowCount, forceReload, isInfiniteScroll) {
    var actualBounds = forceReload
        ? getForceReloadInterval(virtualRows, pageSize, totalRowCount)
        : recalculateBounds(referenceIndex, pageSize, totalRowCount);
    var requestedRange = forceReload
        ? actualBounds
        : calculateRequestedRange(virtualRows, actualBounds, pageSize, referenceIndex, isInfiniteScroll);
    return { requestedRange: requestedRange, actualBounds: actualBounds };
};
var needFetchMorePages = function (virtualRows, referenceIndex, pageSize) {
    var _a = intervalUtil.getRowsInterval(virtualRows), start = _a.start, end = _a.end;
    var loadCount = end - start;
    var topTriggerIndex = start > 0 ? start + pageSize : 0;
    var bottomTriggerIndex = Math.max(topTriggerIndex + pageSize, end - pageSize * 1.5);
    if (loadCount <= 0) {
        return false;
    }
    return (referenceIndex < topTriggerIndex || bottomTriggerIndex < referenceIndex);
};
var getReferenceIndex = function (_a) {
    var _b = __read(_a.rows, 2), top = _b[0], bottom = _b[1];
    return ((top + bottom) / 2);
};
var shouldSendRequest = function (_a, requestedPageIndex) {
    var start = _a.start, end = _a.end;
    var newPageIndex = start;
    var loadCount = (end - start);
    return newPageIndex !== requestedPageIndex && loadCount > 0;
};

var empty = {
    start: Number.POSITIVE_INFINITY,
    end: Number.NEGATIVE_INFINITY,
};
var getRowsInterval = function (r) { return (r === emptyVirtualRows
    ? empty
    : {
        start: r.skip,
        end: r.skip + r.rows.length,
    }); };
var getLength = function (a) { return a.end - a.start; };
var intersect = function (a, b) {
    if (a.end < b.start || b.end < a.start) {
        return empty;
    }
    return {
        start: Math.max(a.start, b.start),
        end: Math.min(a.end, b.end),
    };
};
var difference = function (a, b) {
    if (empty === intervalUtil.intersect(a, b)) {
        return a;
    }
    if (b.end < a.end) {
        return {
            start: b.end,
            end: a.end,
        };
    }
    if (a.start < b.start) {
        return {
            start: a.start,
            end: b.start,
        };
    }
    return empty;
};
var intervalUtil = {
    empty: empty,
    getRowsInterval: getRowsInterval,
    getLength: getLength,
    intersect: intersect,
    difference: difference,
};

var tableRowsWithBands = function (tableHeaderRows, columnBands, tableColumns) {
    var tableDataColumns = tableColumns.filter(function (column) { return column.type === TABLE_DATA_TYPE; });
    var getMaxNestedLevel = function (bands, level, result) {
        if (level === void 0) { level = 0; }
        if (result === void 0) { result = null; }
        return (bands.reduce(function (acc, column) {
            if (column.children !== undefined) {
                return getMaxNestedLevel(column.children, level + 1, acc);
            }
            var isDataColumn = tableDataColumns.findIndex(function (dataColumn) { return !!dataColumn.column && dataColumn.column.name === column.columnName; }) > -1;
            if (level > acc.level && isDataColumn) {
                return __assign(__assign({}, acc), { level: level });
            }
            return acc;
        }, result || { level: 0 }));
    };
    var tableBandHeaders = Array.from({
        length: getMaxNestedLevel(columnBands, 0).level,
    })
        .map(function (row, index) { return ({
        key: TABLE_BAND_TYPE.toString() + "_" + index,
        type: TABLE_BAND_TYPE,
        level: index,
    }); });
    return __spread(tableBandHeaders, tableHeaderRows);
};
var tableHeaderColumnChainsWithBands = function (tableHeaderRows, tableColumns, bands) {
    var chains = generateSimpleChains(tableHeaderRows, tableColumns);
    var maxBandRowIndex = tableHeaderRows
        .filter(function (row) { return row.type === TABLE_BAND_TYPE; })
        .length;
    var rawBandChains = chains.slice(0, maxBandRowIndex);
    var currentBand = null;
    var shouldSplitChain = function (chain, column, rowIndex) {
        if (rowIndex > maxBandRowIndex)
            return false;
        var columnName = column.column && column.column.name || '';
        currentBand = getColumnMeta(columnName, bands, rowIndex);
        return !chain
            || chain.key !== currentBand.key;
    };
    var extendChainProps = function () { return ({
        bandTitle: currentBand === null || currentBand === void 0 ? void 0 : currentBand.title,
        key: currentBand === null || currentBand === void 0 ? void 0 : currentBand.key,
    }); };
    var bandChains = splitHeaderColumnChains(rawBandChains, tableColumns, shouldSplitChain, extendChainProps);
    return __spread(bandChains, chains.slice(maxBandRowIndex));
};
var getBandLevels = function (columnsBands, levels, level) {
    if (levels === void 0) { levels = {}; }
    if (level === void 0) { level = 0; }
    columnsBands.forEach(function (band) {
        if (band.title) {
            levels[band.title] = level;
        }
        if (band.children) {
            getBandLevels(band.children, levels, level + 1);
        }
    });
    return levels;
};
var columnBandLevels = function (columnsBands) { return (getBandLevels(columnsBands)); };
var bandLevelsVisibility = function (columnIntervals, tableHeaderColumnChains, bandLevels) {
    var rowsWithBands = tableHeaderColumnChains
        .filter(function (r) { return r.filter(function (ch) { return !!ch.bandTitle; }).length; });
    var visibleIntervals = columnIntervals.map(function (_a) {
        var _b = __read(_a, 2), start = _b[0], end = _b[1];
        return ({ start: start, end: end });
    });
    var isBandChainVisible = function (chain) { return (visibleIntervals.some(function (interval) { return (intervalUtil.intersect(interval, { start: chain.start, end: chain.start + chain.columns.length - 1 }) !== intervalUtil.empty); })); };
    var getVisibleBandsByLevel = function (level) { return (
    // Note: a visible band level always matches with it's row
    rowsWithBands[level]
        ? rowsWithBands[level].filter(function (chain) { return (bandLevels[chain.bandTitle] === level && isBandChainVisible(chain)); })
        : []); };
    return rowsWithBands.reduce(function (acc, _, index) {
        var rowBands = getVisibleBandsByLevel(index);
        return __spread(acc, [!!rowBands.length]);
    }, []);
};
var columnVisibleIntervals = function (viewport, tableColumns) { return (viewport ? viewport.columns : [[0, tableColumns.length]]); };

var toggleDetailRowExpanded = function (prevExpanded, _a) {
    var rowId = _a.rowId, state = _a.state;
    return toggle(prevExpanded, [rowId], state);
};

var TABLE_DETAIL_TYPE = Symbol('detail');

var isDetailRowExpanded = function (expandedDetailRowIds, rowId) { return expandedDetailRowIds.indexOf(rowId) > -1; };
var isDetailToggleTableCell = function (tableRow, tableColumn) { return tableColumn.type === TABLE_DETAIL_TYPE && tableRow.type === TABLE_DATA_TYPE; };
var isDetailTableRow = function (tableRow) { return tableRow.type === TABLE_DETAIL_TYPE; };
var isDetailTableCell = function (tableColumn, tableColumns) { return tableColumns.indexOf(tableColumn) === 0; };

var tableRowsWithExpandedDetail = function (tableRows, expandedDetailRowIds, rowHeight) {
    var result = tableRows;
    expandedDetailRowIds
        .forEach(function (expandedRowId) {
        var rowIndex = result.findIndex(function (tableRow) { return tableRow.type === TABLE_DATA_TYPE && tableRow.rowId === expandedRowId; });
        if (rowIndex === -1)
            return;
        var insertIndex = rowIndex + 1;
        var _a = result[rowIndex], row = _a.row, rowId = _a.rowId;
        result = __spread(result.slice(0, insertIndex), [
            {
                rowId: rowId,
                row: row,
                key: TABLE_DETAIL_TYPE.toString() + "_" + rowId,
                type: TABLE_DETAIL_TYPE,
                height: rowHeight,
            }
        ], result.slice(insertIndex));
    });
    return result;
};
var tableColumnsWithDetail = function (tableColumns, toggleColumnWidth) { return __spread([
    { key: TABLE_DETAIL_TYPE.toString(), type: TABLE_DETAIL_TYPE, width: toggleColumnWidth }
], tableColumns); };
var tableDetailCellColSpanGetter = function (getTableCellColSpan) { return function (params) {
    var tableRow = params.tableRow, tableColumns = params.tableColumns, tableColumn = params.tableColumn;
    if (tableRow.type === TABLE_DETAIL_TYPE && tableColumns.indexOf(tableColumn) === 0) {
        return tableColumns.length;
    }
    return getTableCellColSpan(params);
}; };

var TABLE_SELECT_TYPE = Symbol('select');

var isSelectTableCell = function (tableRow, tableColumn) { return tableColumn.type === TABLE_SELECT_TYPE && tableRow.type === TABLE_DATA_TYPE; };
var isSelectAllTableCell = function (tableRow, tableColumn) { return tableColumn.type === TABLE_SELECT_TYPE && tableRow.type === TABLE_HEADING_TYPE; };
var isRowHighlighted = function (highlightRow, selection, tableRow) { return (highlightRow && selection && selection.includes(tableRow.rowId)); };

var tableColumnsWithSelection = function (tableColumns, selectionColumnWidth) { return __spread([
    { key: TABLE_SELECT_TYPE.toString(), type: TABLE_SELECT_TYPE, width: selectionColumnWidth }
], tableColumns); };

var VALID_UNITS$1 = ['px', '%', 'em', 'rem', 'vm', 'vh', 'vmin', 'vmax', ''];
var TABLE_ERROR = 'The columnExtension property of the Table plugin is given an invalid value.';
var isDataTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_DATA_TYPE && tableColumn.type === TABLE_DATA_TYPE; };
var isHeaderStubTableCell = function (tableRow, headerRows) { return headerRows.indexOf(tableRow) > -1; };
var isDataTableRow = function (tableRow) { return tableRow.type === TABLE_DATA_TYPE; };
var isNoDataTableRow = function (tableRow) { return tableRow.type === TABLE_NODATA_TYPE; };
var isNoDataTableCell = function (tableColumn, tableColumns) { return tableColumns.indexOf(tableColumn) === 0; };
var isStubTableCell = function (tableRow) { return (tableRow.type === TABLE_STUB_TYPE); };
var checkTableColumnExtensions = function (columnExtensions) {
    if (columnExtensions) {
        columnExtensions.map(function (column) {
            var width = column.width;
            if (typeof width === 'string') {
                if (!isValidValue(width, VALID_UNITS$1)) {
                    throw new Error(TABLE_ERROR);
                }
            }
        });
    }
};

var getColumnExtension = function (columnExtensions, columnName) {
    if (!columnExtensions) {
        // tslint:disable-next-line:no-object-literal-type-assertion
        return {};
    }
    var columnExtension = columnExtensions.find(function (extension) { return extension.columnName === columnName; });
    if (!columnExtension) {
        // tslint:disable-next-line:no-object-literal-type-assertion
        return {};
    }
    return columnExtension;
};
var getColumnExtensionValueGetter = function (columnExtensions, extensionName, defaultValue) { return function (columnName) {
    if (columnExtensions) {
        var columnExtension = getColumnExtension(columnExtensions, columnName);
        var extensionValue = columnExtension[extensionName];
        return extensionValue !== undefined ? extensionValue : defaultValue;
    }
    return defaultValue;
}; };

var tableColumnsWithDataRows = function (columns, columnExtensions) { return columns.map(function (column) {
    var name = column.name;
    var columnExtension = getColumnExtension(columnExtensions, name);
    var width = convertWidth(columnExtension.width);
    return {
        column: column,
        key: TABLE_DATA_TYPE.toString() + "_" + name,
        type: TABLE_DATA_TYPE,
        width: width,
        align: columnExtension.align,
        wordWrapEnabled: columnExtension.wordWrapEnabled,
    };
}); };
var tableRowsWithDataRows = function (rows, getRowId, isRemoteRowsLoading) { return (!rows.length && !isRemoteRowsLoading
    ? [{ key: TABLE_NODATA_TYPE.toString(), type: TABLE_NODATA_TYPE }]
    : rows.map(function (row, dataIndex) {
        var rowId = getRowId(row);
        return {
            row: row,
            // dataIndex,
            rowId: rowId,
            type: TABLE_DATA_TYPE,
            key: TABLE_DATA_TYPE.toString() + "_" + rowId,
        };
    })); };
var tableCellColSpanGetter = function (params) {
    var tableRow = params.tableRow, tableColumns = params.tableColumns, tableColumn = params.tableColumn;
    if (tableRow.type === TABLE_NODATA_TYPE && tableColumns.indexOf(tableColumn) === 0) {
        return tableColumns.length;
    }
    return 1;
};

var visibleTableColumns = function (tableColumns, hiddenColumnNames) {
    if (tableColumns === void 0) { tableColumns = []; }
    return tableColumns.filter(function (tableColumn) { return tableColumn.type !== TABLE_DATA_TYPE
        || hiddenColumnNames.indexOf(tableColumn.column.name) === -1; });
};

var tableDataColumnsExist = function (tableColumns) { return tableColumns.some(function (column) { return column.type === TABLE_DATA_TYPE; }); };

var columnChooserItems = function (columns, hiddenColumnNames) { return columns.map(function (column) { return ({
    column: column,
    hidden: hiddenColumnNames.indexOf(column.name) !== -1,
}); }); };

var toggleColumn = function (hiddenColumnNames, columnName) { return (hiddenColumnNames.indexOf(columnName) === -1
    ? __spread(hiddenColumnNames, [columnName]) : hiddenColumnNames.filter(function (hiddenColumn) { return hiddenColumn !== columnName; })); };

var toggleRowExpanded = function (prevExpanded, _a) {
    var rowId = _a.rowId, state = _a.state;
    return toggle(prevExpanded, [rowId], state);
};

var GRID_TREE_NODE_TYPE = Symbol('treeNode');

var customTreeRowsWithMeta = function (rows, getChildRows) {
    var rowsToProcess = [{ row: null, level: -1 }];
    var treeRows = [];
    var _loop_1 = function () {
        var _a = rowsToProcess.shift(), currentRow = _a.row, level = _a.level;
        var rowIndex = treeRows.findIndex(function (_a) {
            var row = _a.row;
            return row === currentRow;
        });
        var nestedRows = (_a = getChildRows(currentRow, rows)) === null || _a === void 0 ? void 0 : _a.map(function (childRow) { return ({
            row: childRow,
            level: level + 1,
            leaf: !getChildRows(childRow, rows),
        }); });
        if (nestedRows) {
            if (rowIndex > -1) {
                treeRows.splice.apply(treeRows, __spread([rowIndex + 1, 0], nestedRows));
            }
            else {
                treeRows.push.apply(treeRows, __spread(nestedRows));
            }
            rowsToProcess.push.apply(rowsToProcess, __spread(nestedRows));
        }
    };
    while (rowsToProcess === null || rowsToProcess === void 0 ? void 0 : rowsToProcess.length) {
        _loop_1();
    }
    var result = treeRows.reduce(function (acc, _a) {
        var row = _a.row, level = _a.level, leaf = _a.leaf;
        acc.rows.push(row);
        acc.treeMeta.push([row, { level: level, leaf: leaf }]);
        return acc;
    }, { rows: [], treeMeta: [] });
    return {
        rows: result.rows,
        treeMeta: new Map(result.treeMeta),
    };
};
var customTreeRowIdGetter = function (getRowId, _a) {
    var rows = _a.rows, treeMeta = _a.treeMeta;
    var firstNestedRowIndex = rows.findIndex(function (row) { return treeMeta.get(row).level > 0; });
    if (firstNestedRowIndex === -1 || getRowId(rows[firstNestedRowIndex]) !== undefined) {
        return getRowId;
    }
    var map = new Map(rows
        .map(function (row, rowIndex) { return [row, rowIndex]; }));
    return function (row) { return map.get(row); };
};
var customTreeRowLevelKeyGetter = function (getRowLevelKey, _a) {
    var treeMeta = _a.treeMeta;
    return function (row) {
        var rowMeta = treeMeta.get(row);
        if (rowMeta !== undefined) {
            return GRID_TREE_NODE_TYPE.toString() + "_" + rowMeta.level;
        }
        return getRowLevelKey && getRowLevelKey();
    };
};
var expandedTreeRows = function (_a, getRowId, expandedRowIds) {
    var rows = _a.rows, treeMeta = _a.treeMeta;
    var expandedRowIdsSet = new Set(expandedRowIds);
    var currentExpanded = true;
    var currentLevel = 0;
    var collapsedRowsMeta = new Map();
    var resultRows = [];
    rows.forEach(function (row) {
        var rowMeta = treeMeta.get(row);
        var level = rowMeta && rowMeta.level;
        if (level === undefined && currentExpanded) {
            resultRows.push(row);
        }
        else if (!currentExpanded && (level === undefined || level > currentLevel)) {
            var lastRow = resultRows[resultRows.length - 1];
            var collapsedItems = collapsedRowsMeta.get(lastRow);
            if (!collapsedItems) {
                collapsedItems = [];
                collapsedRowsMeta.set(lastRow, collapsedItems);
            }
            collapsedItems.push(row);
        }
        else {
            currentExpanded = expandedRowIdsSet.has(getRowId(row));
            currentLevel = level;
            resultRows.push(row);
        }
    });
    return {
        treeMeta: treeMeta,
        collapsedRowsMeta: collapsedRowsMeta,
        rows: resultRows,
    };
};
var collapsedTreeRowsGetter = function (getCollapsedRows, _a) {
    var collapsedRowsMeta = _a.collapsedRowsMeta;
    return function (row) { return collapsedRowsMeta.get(row) || (getCollapsedRows && getCollapsedRows(row)); };
};
var isTreeRowLeafGetter = function (_a) {
    var treeMeta = _a.treeMeta;
    return function (row) {
        var rowMeta = treeMeta.get(row);
        return rowMeta && rowMeta.leaf;
    };
};
var getTreeRowLevelGetter = function (_a) {
    var treeMeta = _a.treeMeta;
    return function (row) {
        var rowMeta = treeMeta.get(row);
        return (rowMeta && rowMeta.level);
    };
};
var unwrappedCustomTreeRows = function (_a) {
    var rows = _a.rows;
    return rows;
};

var isTreeTableCell = function (tableRow, tableColumn, forColumnName) { return tableRow.type === TABLE_DATA_TYPE && tableColumn.type === TABLE_DATA_TYPE
    && tableColumn.column.name === forColumnName; };

var changeSearchValue = function (prevSearchValue, searchValue) { return searchValue; };

var searchFilterExpression = function (searchValue, columns, filterExpression) {
    var filters = columns.map(function (_a) {
        var name = _a.name;
        return ({ columnName: name, value: searchValue });
    });
    var selfFilterExpression = { filters: filters, operator: 'or' };
    if (!filterExpression) {
        return selfFilterExpression;
    }
    return {
        operator: 'and',
        filters: [filterExpression, selfFilterExpression],
    };
};

var getAvailableFilterOperationsGetter = function (getAvailableFilterOperations, availableFilterOperations, columnNames) { return function (columnName) { return (columnNames.indexOf(columnName) > -1 && availableFilterOperations)
    // tslint:disable-next-line: max-line-length
    || (typeof getAvailableFilterOperations === 'function' && getAvailableFilterOperations(columnName))
    || undefined; }; };

var FIXED_COLUMN_LEFT_SIDE = 'left';
var FIXED_COLUMN_RIGHT_SIDE = 'right';
var TABLE_FIXED_TYPE = Symbol('fixed');

var getFixedColumnKeys = function (tableColumns, fixedNames) { return tableColumns
    .filter(function (tableColumn) { return ((tableColumn.type === TABLE_DATA_TYPE && fixedNames.indexOf(tableColumn.column.name) !== -1)
    || fixedNames.indexOf(tableColumn.type) !== -1); })
    .map(function (_a) {
    var key = _a.key;
    return key;
}); };
var isFixedTableRow = function (tableRow) { return tableRow.type === TABLE_FIXED_TYPE; };
var calculatePosition = function (array, index, tableColumnDimensions) { return (index === 0
    ? 0
    : array
        .slice(0, index)
        .reduce(function (acc, target) { return acc + tableColumnDimensions[target] || 0; }, 0)); };
var calculateFixedColumnProps = function (_a, _b, tableColumns, tableColumnDimensions, tableHeaderColumnChains) {
    var tableColumn = _a.tableColumn;
    var leftColumns = _b.leftColumns, rightColumns = _b.rightColumns;
    var side = tableColumn.fixed;
    var targetArray = side === FIXED_COLUMN_LEFT_SIDE
        ? getFixedColumnKeys(tableColumns, leftColumns)
        : (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .slice */ .tP)(getFixedColumnKeys(tableColumns, rightColumns)).reverse();
    var index = tableColumns.findIndex(function (_a) {
        var key = _a.key;
        return key === tableColumn.key;
    });
    var fixedIndex = targetArray.indexOf(tableColumn.key);
    var columnChain = findChainByColumnIndex(tableHeaderColumnChains[0], index);
    var showLeftDivider = columnChain.start === index && index !== 0;
    var showRightDivider = columnChain.start + columnChain.columns.length - 1 === index
        && index < tableColumns.length - 1;
    var position = calculatePosition(targetArray, fixedIndex, tableColumnDimensions);
    return {
        showRightDivider: showRightDivider,
        showLeftDivider: showLeftDivider,
        position: position,
        side: side,
    };
};

var tableColumnsWithFixed = function (tableColumns, leftColumns, rightColumns) { return tableColumns
    .map(function (tableColumn) {
    var fixed;
    if ((tableColumn.type === TABLE_DATA_TYPE
        && leftColumns.indexOf(tableColumn.column.name) !== -1)
        || leftColumns.indexOf(tableColumn.type) !== -1) {
        fixed = FIXED_COLUMN_LEFT_SIDE;
    }
    if ((tableColumn.type === TABLE_DATA_TYPE
        && rightColumns.indexOf(tableColumn.column.name) !== -1)
        || rightColumns.indexOf(tableColumn.type) !== -1) {
        fixed = FIXED_COLUMN_RIGHT_SIDE;
    }
    return fixed ? __assign(__assign({}, tableColumn), { fixed: fixed }) : tableColumn;
}); };
var tableHeaderRowsWithFixed = function (tableHeaderRows) { return __spread(tableHeaderRows, [
    { key: TABLE_FIXED_TYPE.toString(), type: TABLE_FIXED_TYPE, height: 0 },
]); };
var tableHeaderColumnChainsWithFixed = function (tableHeaderColumnChains, tableHeaderRows, tableColumns) {
    var chains = tableHeaderColumnChains
        || generateSimpleChains(tableHeaderRows, tableColumns);
    var shouldSplitChain = function (currentGroup, column) { return (!currentGroup || currentGroup.fixed !== column.fixed); };
    var extendChainProps = function (column) { return ({
        fixed: column.fixed,
    }); };
    return splitHeaderColumnChains(chains, tableColumns, shouldSplitChain, extendChainProps);
};

var defaultSummaryCalculators = {
    count: function (rows) { return rows.length; },
    sum: function (rows, getValue) { return rows.reduce(function (acc, row) { return acc + getValue(row); }, 0); },
    max: function (rows, getValue) { return (rows.length
        ? rows.reduce(function (acc, row) { return Math.max(acc, getValue(row)); }, -Infinity)
        : null); },
    min: function (rows, getValue) { return (rows.length
        ? rows.reduce(function (acc, row) { return Math.min(acc, getValue(row)); }, Infinity)
        : null); },
    avg: function (rows, getValue) { return (rows.length
        ? rows.reduce(function (acc, row) { return acc + getValue(row); }, 0) / rows.length
        : null); },
};
var defaultSummaryCalculator = function (type, rows, getValue) {
    var summaryCalculator = defaultSummaryCalculators[type];
    if (!summaryCalculator) {
        throw new Error("The summary type '" + type + "' is not defined");
    }
    return summaryCalculator(rows, getValue);
};
var rowsSummary = function (rows, summaryItems, getCellValue, calculator) { return summaryItems
    .reduce(function (acc, _a) {
    var type = _a.type, columnName = _a.columnName;
    var getValue = function (row) { return getCellValue(row, columnName); };
    acc.push(calculator(type, rows, getValue));
    return acc;
}, []); };
var expandRows = function (rows, getRowLevelKey, getCollapsedRows, isGroupRow, includeGroupRow) {
    if (includeGroupRow === void 0) { includeGroupRow = false; }
    var shouldIncludeRow = includeGroupRow || !isGroupRow
        ? function () { return true; }
        : function (row) { return !isGroupRow(row); };
    return rows
        .reduce(function (acc, row) {
        if (getRowLevelKey && getRowLevelKey(row)) {
            if (shouldIncludeRow(row)) {
                acc.push(row);
            }
            var collapsedRows = getCollapsedRows && getCollapsedRows(row);
            if (collapsedRows) {
                acc.push.apply(acc, __spread(collapsedRows));
            }
            return acc;
        }
        acc.push(row);
        return acc;
    }, []);
};
var totalSummaryValues = function (rows, summaryItems, getCellValue, getRowLevelKey, isGroupRow, getCollapsedRows, calculator) {
    if (calculator === void 0) { calculator = defaultSummaryCalculator; }
    var plainRows = expandRows(rows, getRowLevelKey, getCollapsedRows, isGroupRow);
    return rowsSummary(plainRows, summaryItems, getCellValue, calculator);
};
var groupSummaryValues = function (rows, summaryItems, getCellValue, getRowLevelKey, isGroupRow, getCollapsedRows, calculator) {
    if (calculator === void 0) { calculator = defaultSummaryCalculator; }
    var levels = [];
    var getLevelIndex = function (levelKey) { return (levels.findIndex(function (level) { return level.levelKey === levelKey; })); };
    var summaries = {};
    var anyRowLevelSummaryExist = summaryItems.some(function (item) { return (!item.showInGroupFooter); });
    var expandedRows = anyRowLevelSummaryExist
        ? expandRows(rows, getRowLevelKey, getCollapsedRows, isGroupRow, true)
        : rows;
    expandedRows.forEach(function (row) {
        var levelKey = getRowLevelKey(row);
        var collapsedRows = getCollapsedRows && getCollapsedRows(row);
        var levelIndex = getLevelIndex(levelKey);
        if (levelIndex > -1) {
            levels.forEach(function (level) {
                summaries[level.row.compoundKey] = rowsSummary(level.rows, summaryItems, getCellValue, calculator);
            });
            levels = levels.slice(0, levelIndex);
        }
        if (isGroupRow(row)) {
            levels.push({
                levelKey: levelKey,
                row: row,
                rows: [],
            });
            levelIndex = getLevelIndex(levelKey);
        }
        // when row level summary exists, these rows had already been expanded earlier
        var isCollapsedNestedGroupRow = collapsedRows && levelIndex > 0 && !anyRowLevelSummaryExist;
        var rowsToAppend = !levelKey ? [row] : collapsedRows;
        if (!levelKey || isCollapsedNestedGroupRow) {
            levels.forEach(function (level) {
                var _a;
                (_a = level.rows).push.apply(_a, __spread(rowsToAppend));
            });
        }
    }, {});
    levels.forEach(function (level) {
        summaries[level.row.compoundKey] = rowsSummary(level.rows, summaryItems, getCellValue, calculator);
    });
    return summaries;
};
var treeSummaryValues = function (rows, summaryItems, getCellValue, getRowLevelKey, isGroupRow, getRowId, calculator) {
    if (calculator === void 0) { calculator = defaultSummaryCalculator; }
    var levels = [];
    var summaries = {};
    rows.forEach(function (row) {
        var levelKey = getRowLevelKey(row);
        if (!levelKey) {
            levels[levels.length - 1].rows.push(row);
            return;
        }
        var levelIndex = levels.findIndex(function (level) { return level.levelKey === levelKey; });
        if (levelIndex > -1) {
            levels.slice(levelIndex).forEach(function (level) {
                if (level.rows.length) {
                    summaries[getRowId(level.row)] = rowsSummary(level.rows, summaryItems, getCellValue, calculator);
                }
            });
            levels = levels.slice(0, levelIndex);
        }
        if (!isGroupRow || !isGroupRow(row)) {
            if (levels.length) {
                levels[levels.length - 1].rows.push(row);
            }
            levels.push({
                levelKey: levelKey,
                row: row,
                rows: [],
            });
        }
    }, {});
    levels.forEach(function (level) {
        if (level.rows.length) {
            summaries[getRowId(level.row)] = rowsSummary(level.rows, summaryItems, getCellValue, calculator);
        }
    });
    return summaries;
};

var TABLE_TOTAL_SUMMARY_TYPE = Symbol('totalSummary');
var TABLE_GROUP_SUMMARY_TYPE = Symbol('groupSummary');
var TABLE_TREE_SUMMARY_TYPE = Symbol('treeSummary');
var defaultFormatlessSummaries = ['count'];

var isTotalSummaryTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_TOTAL_SUMMARY_TYPE && tableColumn.type === TABLE_DATA_TYPE; };
var isGroupSummaryTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_GROUP_SUMMARY_TYPE && tableColumn.type === TABLE_DATA_TYPE; };
var isTreeSummaryTableCell = function (tableRow, tableColumn) { return tableRow.type === TABLE_TREE_SUMMARY_TYPE && tableColumn.type === TABLE_DATA_TYPE; };
var isTotalSummaryTableRow = function (tableRow) { return (tableRow.type === TABLE_TOTAL_SUMMARY_TYPE); };
var isGroupSummaryTableRow = function (tableRow) { return (tableRow.type === TABLE_GROUP_SUMMARY_TYPE); };
var isTreeSummaryTableRow = function (tableRow) { return (tableRow.type === TABLE_TREE_SUMMARY_TYPE); };
var getColumnSummaries = function (summaryItems, columnName, summaryValues, predicate) {
    if (predicate === void 0) { predicate = function () { return true; }; }
    return summaryItems
        .map(function (item, index) { return [item, index]; })
        .filter(function (_a) {
        var _b = __read(_a, 1), item = _b[0];
        return item.columnName === columnName && predicate(item);
    })
        .map(function (_a) {
        var _b = __read(_a, 2), item = _b[0], index = _b[1];
        return ({
            type: item.type,
            value: summaryValues[index],
        });
    });
};
var isFooterSummary = function (summaryItem) { return (summaryItem.showInGroupFooter); };
var isInlineGroupCaptionSummary = function (summaryItem) { return (!(summaryItem.showInGroupFooter ||
    summaryItem.alignByColumn)); };
var groupFooterSummaryExists = function (groupSummaryItems) { return groupSummaryItems === null || groupSummaryItems === void 0 ? void 0 : groupSummaryItems.some(isFooterSummary); };
var getGroupInlineSummaries = function (summaryItems, columns, summaryValues) {
    if (!summaryItems.some(isInlineGroupCaptionSummary)) {
        return [];
    }
    return columns.reduce(function (acc, column) {
        var colName = column.name;
        var summaries = getColumnSummaries(summaryItems, colName, summaryValues, isInlineGroupCaptionSummary);
        if (summaries.length) {
            acc.push({
                column: column,
                summaries: summaries,
            });
        }
        return acc;
    }, []);
};

var tableRowsWithTotalSummaries = function (footerRows) { return __spread([
    { key: TABLE_TOTAL_SUMMARY_TYPE.toString(), type: TABLE_TOTAL_SUMMARY_TYPE }
], footerRows); };
var tableRowsWithSummaries = function (tableRows, groupSummaryItems, treeSummaryItems, getRowLevelKey, isGroupRow, getRowId) {
    var hasGroupFooterSummary = groupFooterSummaryExists(groupSummaryItems);
    if (!getRowLevelKey || !(hasGroupFooterSummary || treeSummaryItems.length))
        return tableRows;
    var result = [];
    var closeLevel = function (level) {
        if (!level.opened)
            return;
        if (hasGroupFooterSummary && isGroupRow && isGroupRow(level.row)) {
            var compoundKey = level.row.compoundKey;
            result.push({
                key: TABLE_GROUP_SUMMARY_TYPE.toString() + "_" + compoundKey,
                type: TABLE_GROUP_SUMMARY_TYPE,
                row: level.row,
            });
        }
        else if (treeSummaryItems.length) {
            var rowId = getRowId(level.row);
            result.push({
                key: TABLE_TREE_SUMMARY_TYPE.toString() + "_" + rowId,
                type: TABLE_TREE_SUMMARY_TYPE,
                row: level.row,
            });
        }
    };
    var levels = [];
    tableRows.forEach(function (tableRow) {
        var row = tableRow.row;
        var levelKey = getRowLevelKey(row);
        if (levelKey) {
            var levelIndex = levels.findIndex(function (level) { return level.levelKey === levelKey; });
            if (levelIndex > -1) {
                levels.slice(levelIndex).reverse().forEach(closeLevel);
                levels = levels.slice(0, levelIndex);
            }
            if (!isGroupRow || !isGroupRow(row)) {
                levels = levels.map(function (level) { return (__assign(__assign({}, level), { opened: true })); });
            }
            levels.push({
                levelKey: levelKey,
                row: row,
                opened: false,
            });
        }
        else {
            levels = levels.map(function (level) { return (__assign(__assign({}, level), { opened: true })); });
        }
        result.push(tableRow);
    });
    levels.slice().reverse().forEach(closeLevel);
    return result;
};

var prepareGroupSummaryItems = function (items) { return (!!items
    ? items.map(function (item) { return (__assign(__assign({}, item), { showInGroupFooter: (item.showInGroupFooter === undefined && !item.alignByColumn)
            ? true
            : item.showInGroupFooter })); })
    : items); };

var getTargetColumnGeometries = function (columnGeometries, sourceIndex) {
    var sourceWidth = columnGeometries[sourceIndex].right - columnGeometries[sourceIndex].left;
    var getWidthDifference = function (index) { return columnGeometries[index].right
        - columnGeometries[index].left
        - sourceWidth; };
    return columnGeometries
        .map(function (_a, targetIndex) {
        var top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
        var leftBorder = left;
        if (targetIndex > 0 && targetIndex <= sourceIndex) {
            leftBorder = Math.min(leftBorder, leftBorder - getWidthDifference(targetIndex - 1));
        }
        if (targetIndex > sourceIndex) {
            leftBorder = Math.max(leftBorder, leftBorder + getWidthDifference(targetIndex));
        }
        var rightBorder = right;
        if (targetIndex < columnGeometries.length - 1 && targetIndex >= sourceIndex) {
            rightBorder = Math.max(rightBorder, rightBorder + getWidthDifference(targetIndex + 1));
        }
        if (targetIndex < sourceIndex) {
            rightBorder = Math.min(rightBorder, rightBorder - getWidthDifference(targetIndex));
        }
        return {
            top: top,
            bottom: bottom,
            right: rightBorder,
            left: leftBorder,
        };
    });
};
var getCellGeometries = function (node) {
    var _a, _b;
    var _c = node.getBoundingClientRect(), left = _c.left, right = _c.right, width = _c.width;
    var styleLeft = parseInt((_a = node.style.left) === null || _a === void 0 ? void 0 : _a.toString().replace('px', ''), 10);
    var styleRight = parseInt((_b = node.style.right) === null || _b === void 0 ? void 0 : _b.toString().replace('px', ''), 10);
    if (!isNaN(styleLeft)) {
        var calculatedLeft = Math.max(styleLeft, left);
        return {
            left: calculatedLeft,
            right: calculatedLeft + width,
            isFixed: true,
        };
    }
    if (!isNaN(styleRight)) {
        // NOTE: get tableContainer (parent of first DIV element) to calculate 'right' value
        var tableContainer = node;
        while (tableContainer && tableContainer.nodeName !== 'DIV') {
            tableContainer = tableContainer.parentNode;
        }
        tableContainer = tableContainer === null || tableContainer === void 0 ? void 0 : tableContainer.parentNode;
        if (tableContainer) {
            var tableWidth = tableContainer.getBoundingClientRect().width;
            var calculatedRight = Math.min(tableWidth - styleRight, right);
            return {
                left: calculatedRight - width,
                right: calculatedRight,
                isFixed: true,
            };
        }
    }
    return { left: left, right: right };
};

var getTableColumnGeometries = function (columns, tableWidth) {
    var columnWidths = columns
        .map(function (column) { return column.width; });
    var freeSpace = tableWidth;
    var restrictedSpace = columnWidths
        .reduce(function (accum, width) { return accum + (typeof width === 'number' ? width : 0); }, 0);
    var freeSpacePortions = columnWidths
        .reduce(function (accum, width) { return accum + (typeof width !== 'number' ? 1 : 0); }, 0);
    var freeSpacePortion = (freeSpace - restrictedSpace) / freeSpacePortions;
    var lastRightPosition = 0;
    return columnWidths
        .map(function (width) { return (typeof width !== 'number' ? freeSpacePortion : width); })
        .map(function (width) {
        lastRightPosition += width;
        return {
            left: lastRightPosition - width,
            right: lastRightPosition,
        };
    });
};
var getTableTargetColumnIndex = function (columnGeometries, offset) {
    var indexes = columnGeometries.reduce(function (acc, _a, index) {
        var left = _a.left, right = _a.right;
        if (offset > left && offset < right) {
            acc.push(index);
        }
        return acc;
    }, []);
    if (indexes.length === 2) {
        return indexes.find(function (index) { return columnGeometries[index].isFixed; });
    }
    if (indexes.length === 1) {
        return indexes[0];
    }
    return -1;
};
var ANIMATION_DURATION = 200;
var getAnimationProgress = function (animation) { return (new Date().getTime() - animation.startTime) / ANIMATION_DURATION; };
var getAnimations = function (prevColumns, nextColumns, tableWidth, prevAnimations) {
    var resizing = prevColumns.map(function (column) { return column.key; }).join()
        === nextColumns.map(function (column) { return column.key; }).join();
    var prevColumnGeometries = new Map(getTableColumnGeometries(prevColumns, tableWidth)
        .map(function (geometry, index) { return [prevColumns[index].key, geometry]; })
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], geometry = _b[1];
        var animation = prevAnimations.get(key);
        if (!animation)
            return [key, geometry];
        var progress = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .easeOutCubic */ .w2)(getAnimationProgress(animation));
        var _c = animation.left, to = _c.to, from = _c.from;
        var left = ((to - from) * progress) + from;
        return [key, {
                left: left,
                right: geometry.right - (geometry.left - left),
            }];
        // tslint:disable-next-line:array-type
    }));
    var nextColumnGeometries = new Map(getTableColumnGeometries(nextColumns, tableWidth)
        // tslint:disable-next-line:array-type
        .map(function (geometry, index) { return [nextColumns[index].key, geometry]; }));
    return new Map(__spread(nextColumnGeometries.keys()).map(function (key) {
        var prev = prevColumnGeometries.get(key);
        var next = nextColumnGeometries.get(key);
        var result = { startTime: new Date().getTime(), style: {} };
        var takePrevColumnIntoAccount = !!prevAnimations.get(key) || (prev && !resizing);
        if (Math.abs((takePrevColumnIntoAccount ? prev.left : next.left) - next.left) > 1) {
            result.left = { from: prev.left, to: next.left };
        }
        return [key, result];
    })
        .filter(function (animation) { return animation[1].left; }));
};
var filterActiveAnimations = function (animations) { return new Map(__spread(animations.entries()).filter(function (_a) {
    var _b = __read(_a, 2), animation = _b[1];
    return getAnimationProgress(animation) < 1;
})); };
var evalAnimations = function (animations) { return new Map(__spread(animations.entries()).map(function (_a) {
    var _b = __read(_a, 2), key = _b[0], animation = _b[1];
    var progress = (0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_0__/* .easeOutCubic */ .w2)(getAnimationProgress(animation));
    var result = __assign({}, animation.style);
    if (animation.left) {
        var offset = (animation.left.to - animation.left.from) * (progress - 1);
        result.transform = "translateX(" + offset + "px)";
    }
    return [key, result];
})); };

var isOnTheSameLine = function (geometry, y) { return (y >= geometry.top && y <= geometry.bottom); };
var rectToObject = function (_a) {
    var top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    return ({
        top: top, right: right, bottom: bottom, left: left,
    });
};
var collapseGapsBetweenItems = function (geometries) { return (geometries.map(function (geometry, index) {
    if (index !== geometries.length - 1 && geometry.top === geometries[index + 1].top) {
        return __assign(__assign({}, geometry), { right: geometries[index + 1].left });
    }
    return geometry;
})); };
var getGroupCellTargetIndex = function (geometries, sourceIndex, _a) {
    var x = _a.x, y = _a.y;
    if (geometries.length === 0)
        return 0;
    var targetGeometries = sourceIndex !== -1
        ? getTargetColumnGeometries(geometries, sourceIndex)
        : geometries.map(rectToObject);
    var targetIndex = collapseGapsBetweenItems(targetGeometries)
        .findIndex(function (geometry, index) {
        var inVerticalBounds = isOnTheSameLine(geometry, y);
        var inHorizontalBounds = x >= geometry.left && x <= geometry.right;
        var shouldGoFirst = index === 0 && x < geometry.left;
        var shouldGoOnLineBreak = !inVerticalBounds
            && !!geometries[index - 1]
            && isOnTheSameLine(geometries[index - 1], y);
        return (inVerticalBounds && inHorizontalBounds)
            || shouldGoFirst
            || shouldGoOnLineBreak;
    });
    return targetIndex === -1 ? geometries.length : targetIndex;
};

/** @internal */
var arraysEqual = function (arrA, arrB, comparator) {
    if (comparator === void 0) { comparator = function (a, b) { return a === b; }; }
    if (arrA.length !== arrB.length) {
        return false;
    }
    for (var i = 0; i < arrA.length; i += 1) {
        if (!comparator(arrA[i], arrB[i])) {
            return false;
        }
    }
    return true;
};

/** @internal */
var emptyViewport = {
    columns: [[0, 0]],
    rows: [0, 0],
    headerRows: [0, 0],
    footerRows: [0, 0],
    top: 0,
    left: 0,
    width: 800,
    height: 600,
};
var TOP_POSITION = Symbol('top');
var BOTTOM_POSITION = Symbol('bottom');

var VALID_UNITS$2 = ['px', ''];
/* tslint:disable max-line-length */
var VIRTUAL_TABLE_ERROR = 'The columnExtension property of the VirtualTable plugin is given an invalid value.';
var getViewport = function (state, getters, estimatedRowHeight, getRowHeight, getColumnWidth) {
    var viewportTop = state.viewportTop, viewportLeft = state.viewportLeft, containerWidth = state.containerWidth, containerHeight = state.containerHeight, headerHeight = state.headerHeight, footerHeight = state.footerHeight;
    var loadedRowsStart = getters.loadedRowsStart, tableBodyRows = getters.bodyRows, tableColumns = getters.columns, _a = getters.headerRows, tableHeaderRows = _a === void 0 ? [] : _a, _b = getters.footerRows, tableFooterRows = _b === void 0 ? [] : _b, isDataRemote = getters.isDataRemote, viewport = getters.viewport;
    var rows = getRowsVisibleBoundary(tableBodyRows, viewportTop, containerHeight - headerHeight - footerHeight, getRowHeight, loadedRowsStart, estimatedRowHeight, isDataRemote);
    var headerRows = getRowsVisibleBoundary(tableHeaderRows, 0, headerHeight, getRowHeight, 0, estimatedRowHeight, false);
    var footerRows = getRowsVisibleBoundary(tableFooterRows, 0, footerHeight, getRowHeight, 0, estimatedRowHeight, false);
    var columns = getColumnBoundaries(tableColumns, viewportLeft, containerWidth, getColumnWidth);
    // NOTE: prevent unnecessary updates
    // e.g. when rows changed but bounds remain the same.
    var result = viewport;
    if (viewportTop !== viewport.top) {
        result = __assign(__assign({}, result), { top: viewportTop });
    }
    if (viewportLeft !== viewport.left) {
        result = __assign(__assign({}, result), { left: viewportLeft });
    }
    if (containerWidth !== viewport.width) {
        result = __assign(__assign({}, result), { width: containerWidth });
    }
    if (containerHeight !== viewport.height) {
        result = __assign(__assign({}, result), { height: containerHeight });
    }
    if (!arraysEqual(rows, viewport.rows)) {
        result = __assign(__assign({}, result), { rows: rows });
    }
    if (!arraysEqual(headerRows, viewport.headerRows)) {
        result = __assign(__assign({}, result), { headerRows: headerRows });
    }
    if (!arraysEqual(footerRows, viewport.footerRows)) {
        result = __assign(__assign({}, result), { footerRows: footerRows });
    }
    if (!arraysEqual(columns, viewport.columns, arraysEqual)) {
        result = __assign(__assign({}, result), { columns: columns });
    }
    return result;
};
var checkColumnWidths = function (tableColumns) {
    return tableColumns.reduce(function (acc, tableColumn) {
        var width = tableColumn.width;
        if (typeof width === 'string') {
            var numb = parseInt(width, 10);
            var unit_1 = numb ? width.substr(numb.toString().length) : width;
            var isValidUnit = VALID_UNITS$2.some(function (validUnit) { return validUnit === unit_1; });
            if (!isValidUnit) {
                throw new Error(VIRTUAL_TABLE_ERROR);
            }
            acc.push(__assign(__assign({}, tableColumn), { width: numb }));
        }
        else {
            acc.push(tableColumn);
        }
        return acc;
    }, []);
};
var calculateScrollHeight = function (rowHeight, index) {
    return index > -1 ? rowHeight * index : undefined;
};
var getScrollTop = function (rows, rowsCount, rowId, rowHeight, isDataRemote) {
    if (rowId === TOP_POSITION) {
        return 0;
    }
    if (rowId === BOTTOM_POSITION) {
        return rowsCount * rowHeight;
    }
    var searchIndexRequired = !isDataRemote && rowId !== undefined;
    var indexById = searchIndexRequired
        ? rows.findIndex(function (row) { return row.rowId === rowId; })
        : undefined;
    return calculateScrollHeight(rowHeight, indexById);
};
var getTopRowId = function (viewport, tableBodyRows, isDataRemote) {
    var hasViewportRows = viewport && viewport.rows;
    var hasBodyRows = tableBodyRows && tableBodyRows.length;
    if (hasViewportRows && hasBodyRows && !isDataRemote) {
        var index = viewport.rows[0];
        return index < tableBodyRows.length ? tableBodyRows[index].rowId : undefined;
    }
    return undefined;
};

var virtualRowsWithCache = function (skip, rows, cache) {
    var rowsInterval = intervalUtil.getRowsInterval({ skip: skip, rows: rows });
    var cacheInterval = intervalUtil.getRowsInterval(cache);
    return mergeRows(rowsInterval, cacheInterval, rows, cache.rows, skip, cache.skip);
};
var plainRows = function (virtualRows, availableRowCount) {
    return virtualRows.rows.length > availableRowCount
        ? virtualRows.rows.slice(0, availableRowCount)
        : virtualRows.rows;
};
var loadedRowsStart = function (virtualRows) { return virtualRows.skip; };

var ROOT_GROUP = '__root__';
var DEFAULT_COLUMN_WIDTH = 150;

var exportHeader = function (worksheet, columns) {
    var cols = columns
        .map(function (_a) {
        var column = _a.column, width = _a.width;
        return ({
            width: (width || DEFAULT_COLUMN_WIDTH) / 8,
            key: column === null || column === void 0 ? void 0 : column.name,
        });
    });
    worksheet.columns = cols;
    var headerRow = columns.reduce(function (acc, _a) {
        var _b;
        var _c = _a.column, _d = _c === void 0 ? {} : _c, name = _d.name, title = _d.title;
        return (__assign(__assign({}, acc), (_b = {}, _b[name] = title, _b)));
    }, {});
    worksheet.addRow(headerRow);
    worksheet.views.push({
        state: 'frozen',
        ySplit: worksheet.lastRow.number,
    });
};
var findRanges = function (groupTree, compoundKey, level, maxLevel, result) {
    if (result === void 0) { result = []; }
    if (level !== maxLevel) {
        var ranges = groupTree[compoundKey].reduce(function (acc, groupKey) { return (__spread(acc, findRanges(groupTree, groupKey, level + 1, maxLevel, result))); }, []);
        return __spread(result, ranges);
    }
    return __spread(result, [groupTree[compoundKey]]);
};
var exportRows = function (worksheet, allRows, dataColumns, columns, isGroupRow, outlineLevels, rowsOffset, getCellValue, getCloseGroup, customizeCell) {
    var currentLevel = 0;
    var openGroups = [];
    var closeGroup = getCloseGroup(rowsOffset);
    allRows.forEach(function (row) {
        var _a;
        var _b;
        var excelRow;
        if (isGroupRow && isGroupRow(row)) {
            currentLevel = outlineLevels[row.groupedBy];
            // close nested groups first
            openGroups.slice(currentLevel).reverse().forEach(closeGroup);
            openGroups = openGroups.slice(0, currentLevel);
            openGroups[currentLevel] = { groupedBy: row.groupedBy, compoundKey: row.compoundKey };
            // add group row
            var title = (_b = dataColumns.find(function (_a) {
                var name = _a.name;
                return name === row.groupedBy;
            })) === null || _b === void 0 ? void 0 : _b.title;
            excelRow = (_a = {}, _a[columns[0].column.name] = title + ": " + row.value, _a);
            worksheet.addRow(excelRow);
            var lastIndex = worksheet.lastRow.number;
            // merge into single cell
            worksheet.mergeCells(lastIndex, 1, lastIndex, columns.length);
            worksheet.lastRow.getCell(1).font = { bold: true };
            if (currentLevel > 0) {
                worksheet.lastRow.outlineLevel = currentLevel;
            }
            currentLevel += 1;
        }
        else {
            excelRow = columns.reduce(function (acc, _a) {
                var _b;
                var column = _a.column;
                return (__assign(__assign({}, acc), (column ? (_b = {}, _b[column.name] = getCellValue(row, column.name), _b) : null)));
            }, {});
            worksheet.addRow(excelRow);
            worksheet.lastRow.outlineLevel = currentLevel;
        }
        worksheet.lastRow.eachCell(function (cell, colNumber) {
            customizeCell(cell, row, columns[colNumber - 1].column);
        });
    });
    openGroups.reverse().forEach(closeGroup);
};
var closeSheet = function (worksheet, groupTree, maxGroupLevel, rowsOffset, totalSummaryItems, exportSummary) {
    exportSummaryItems(worksheet, groupTree, totalSummaryItems, ROOT_GROUP, -1, rowsOffset, maxGroupLevel, exportSummary);
};
var normalizeRanges = function (ranges, offset) { return (ranges.map(function (range) { return range.map(function (index) { return +index + offset; }); })); };
var exportSummaryItems = function (worksheet, groupTree, summaryItems, groupKey, groupLevel, rowsOffset, maxGroupLevel, exportSummary) {
    if (!summaryItems)
        return;
    worksheet.addRow({});
    var ranges = normalizeRanges(findRanges(groupTree, groupKey, groupLevel, maxGroupLevel), rowsOffset);
    summaryItems.forEach(function (s) {
        exportSummary(s, ranges);
    });
};
var removeEmptyGroups = function (rows, grouping, isGroupRow) {
    if (!grouping)
        return rows;
    var groupingColumns = grouping.map(function (_a) {
        var columnName = _a.columnName;
        return columnName;
    });
    var result = [];
    var groupChain = [];
    rows.forEach(function (row) {
        if (isGroupRow(row)) {
            var level = groupingColumns.indexOf(row.groupedBy);
            if (level === groupChain.length) {
                groupChain.push(row);
            }
            else {
                groupChain = __spread(groupChain.slice(0, level), [row]);
            }
        }
        else {
            if (groupChain.length > 0) {
                result.push.apply(result, __spread(groupChain));
                groupChain = Array.from({ length: groupChain.length });
            }
            result.push(row);
        }
    });
    return result.filter(function (row) { return !!row; });
};

var groupOutlineLevels = function (grouping) { return ((grouping === null || grouping === void 0 ? void 0 : grouping.reduce(function (acc, _a, index) {
    var _b;
    var columnName = _a.columnName;
    return (__assign(__assign({}, acc), (_b = {}, _b[columnName] = index, _b)));
}, {})) || {}); };
var filterSelectedRows = function (rows, selection, getRowId, isGroupRow) {
    var selectionSet = new Set(selection);
    return rows.filter(function (row) { return (isGroupRow && isGroupRow(row)) || selectionSet.has(getRowId(row)); });
};
var rowsToExport = function (rows, selection, grouping, getCollapsedRows, getRowId, isGroupRow) {
    var expandRows = function (collapsedRows) { return (collapsedRows.reduce(function (acc, row) { return (__spread(acc, [row], (expandRows(getCollapsedRows(row) || [])))); }, [])); };
    var expandedRows = getCollapsedRows ? expandRows(rows) : rows;
    if (!selection) {
        return expandedRows;
    }
    var filteredRows = filterSelectedRows(expandedRows, selection, getRowId, isGroupRow);
    return removeEmptyGroups(filteredRows, grouping, isGroupRow);
};
var buildGroupTree = function (rows, outlineLevels, grouping, isGroupRow, groupSummaryItems) {
    var _a;
    var groupTree = (_a = {}, _a[ROOT_GROUP] = [], _a);
    if (!(grouping === null || grouping === void 0 ? void 0 : grouping.length)) {
        groupTree[ROOT_GROUP] = [0, rows.length - 1];
        return groupTree;
    }
    var maxLevel = Object.keys(outlineLevels).length - 1;
    var groupSummaryExists = !!groupSummaryItems;
    var parentChain = { '-1': ROOT_GROUP };
    var lastDataIndex = 0;
    var openGroup = '';
    var index = 0;
    var level = 0;
    var prevLevel = 0;
    rows.forEach(function (row) {
        var groupedBy = row.groupedBy, compoundKey = row.compoundKey;
        if (isGroupRow(row)) {
            level = outlineLevels[groupedBy];
            groupTree[compoundKey] = [];
            parentChain[level] = compoundKey;
            if (level <= maxLevel) {
                groupTree[parentChain[level - 1]].push(compoundKey);
            }
            if (level === maxLevel) {
                if (openGroup) {
                    // close previous group
                    groupTree[openGroup].push(lastDataIndex);
                }
                openGroup = compoundKey;
                if (groupSummaryExists && lastDataIndex > 0) {
                    index += 1;
                }
                groupTree[compoundKey].push(index + 1); // first row index
            }
            else if (groupSummaryExists && level < prevLevel) {
                // jump over summary rows
                index += maxLevel - level;
            }
            prevLevel = level;
        }
        else {
            lastDataIndex = index;
        }
        index += 1;
    });
    if (openGroup) {
        groupTree[openGroup].push(lastDataIndex);
    }
    return groupTree;
};
var operations = {
    count: 'COUNTA',
};
var exportSummaryGetter = function (worksheet, tableColumns, customizeSummaryCell, defaultSummaryMessages) { return function (_a, ranges) {
    var columnName = _a.columnName, type = _a.type;
    var column = (tableColumns.find(function (_a) {
        var dataColumn = _a.column, columnType = _a.type;
        return (columnType === TABLE_DATA_TYPE && dataColumn && dataColumn.name === columnName);
    }) || {}).column;
    // NOTE: column is hidden or the grid grouped by this column
    if (!column) {
        return;
    }
    var row = worksheet.lastRow;
    var letter = worksheet.getColumn(columnName).letter;
    var operation = operations[type] || type.toUpperCase();
    var rangesStr = ranges.map(function (range) { return (range
        .map(function (r) { return "" + letter + r; })
        .filter(function (val, index, arr) { return arr.indexOf(val) === index; })
        .join(':')); }).join(',');
    var cell = row.getCell(columnName);
    cell.value = {
        formula: operation + "(" + rangesStr + ")",
        date1904: false,
    };
    cell.numFmt = "\"" + defaultSummaryMessages[type] + ":\" 0";
    var summary = {
        type: type,
        ranges: ranges,
    };
    customizeSummaryCell(cell, column, summary);
}; };
var closeGroupGetter = function (worksheet, groupTree, outlineLevels, maxGroupLevel, groupSummaryItems, exportSummary) { return function (rowsOffset) { return function (group) {
    var groupedBy = group.groupedBy, compoundKey = group.compoundKey;
    exportSummaryItems(worksheet, groupTree, groupSummaryItems, compoundKey, outlineLevels[groupedBy], rowsOffset, maxGroupLevel, exportSummary);
}; }; };
var maximumGroupLevel = function (grouping) { return ((grouping || []).length - 1); };


//# sourceMappingURL=dx-grid-core.es.js.map


/***/ }),

/***/ 3998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ connectProps; },
/* harmony export */   "Ej": function() { return /* binding */ DragSource; },
/* harmony export */   "GR": function() { return /* binding */ DropTarget; },
/* harmony export */   "RJ": function() { return /* binding */ PluginHost; },
/* harmony export */   "Sy": function() { return /* binding */ Plugin; },
/* harmony export */   "TY": function() { return /* binding */ RefHolder; },
/* harmony export */   "YS": function() { return /* binding */ Template; },
/* harmony export */   "_l": function() { return /* binding */ Draggable; },
/* harmony export */   "aD": function() { return /* binding */ Getter; },
/* harmony export */   "aU": function() { return /* binding */ Action; },
/* harmony export */   "eT": function() { return /* binding */ TemplateConnector; },
/* harmony export */   "jf": function() { return /* binding */ TemplatePlaceholder; },
/* harmony export */   "ne": function() { return /* binding */ Sizer; },
/* harmony export */   "qN": function() { return /* binding */ createStateHelper; },
/* harmony export */   "we": function() { return /* binding */ withComponents; },
/* harmony export */   "wz": function() { return /* binding */ DragDropProvider; }
/* harmony export */ });
/* unused harmony exports RefType, clearSelection */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _devexpress_dx_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94201);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/**
 * Bundle of @devexpress/dx-react-core
 * Generated: 2021-06-24
 * Version: 2.7.6
 * License: https://js.devexpress.com/Licensing
 */






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @internal */
var PluginHostContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/** @internal */
var PositionContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(function () { return []; });
/** @internal */
var TemplateHostContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

/** @internal */
var PluginIndexer = /*#__PURE__*/ (function (_super) {
    __extends(PluginIndexer, _super);
    function PluginIndexer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.indexes = {};
        _this.memoize = function (index, positionContext) {
            if (_this.indexes[index])
                return _this.indexes[index];
            var fn = function () {
                var calculatedPosition = positionContext();
                return __spread(calculatedPosition, [index]);
            };
            _this.indexes[index] = fn;
            return fn;
        };
        return _this;
    }
    PluginIndexer.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PositionContext.Consumer, null, function (positionContext) { return (react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child, index) {
            if (!child || !child.type)
                return child;
            var childPosition = _this.memoize(index, positionContext);
            return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PositionContext.Provider, { key: String(index), value: childPosition }, child));
        })); }));
    };
    return PluginIndexer;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));

/** @internal */
var PLUGIN_HOST_CONTEXT = 'dxcore_pluginHost_context';
/** @internal */
var POSITION_CONTEXT = 'dxcore_position_context';
/** @internal */
var TEMPLATE_HOST_CONTEXT = 'dxcore_templateHost_context';
/** @internal */
var RERENDER_TEMPLATE_EVENT = Symbol('rerenderTemplate');
/** @internal */
var RERENDER_TEMPLATE_SCOPE_EVENT = Symbol('rerenderTemplateScope');
/** @internal */
var UPDATE_CONNECTION_EVENT = Symbol('updateConnection');

/** @internal */
var withContext = function (Context, name) { return function (Component) { return function (props) { return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Context.Consumer, null, function (context) {
    var _a;
    return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Component, __assign({}, props, (_a = {}, _a[name] = context, _a))));
})); }; }; };
/** @internal */
var withHostAndPosition = function (Component) { return withContext(PluginHostContext, PLUGIN_HOST_CONTEXT)(withContext(PositionContext, POSITION_CONTEXT)(Component)); };

/** @internal */
var PluginBase = /*#__PURE__*/ (function (_super) {
    __extends(PluginBase, _super);
    function PluginBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PluginBase.prototype.componentDidMount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b], _c = POSITION_CONTEXT, position = _a[_c];
        var _d = this.props, name = _d.name, dependencies = _d.dependencies;
        this.plugin = {
            position: position,
            name: name,
            dependencies: dependencies,
            container: true,
        };
        pluginHost.registerPlugin(this.plugin);
        pluginHost.ensureDependencies();
    };
    PluginBase.prototype.componentDidUpdate = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.ensureDependencies();
    };
    PluginBase.prototype.componentWillUnmount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.unregisterPlugin(this.plugin);
    };
    PluginBase.prototype.render = function () {
        var children = this.props.children;
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PluginIndexer, null, children));
    };
    return PluginBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
var Plugin = withHostAndPosition(PluginBase);

var getRenderingData = function (props) {
    var name = props.name, params = props.params;
    if (name) {
        var _a = props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        return {
            params: params,
            templates: pluginHost.collect(name + "Template")
                .filter(function (template) { return template.predicate(params); })
                .reverse(),
        };
    }
    var _c = props, _d = TEMPLATE_HOST_CONTEXT, templateHost = _c[_d];
    return {
        params: params || templateHost.params(),
        templates: templateHost.templates(),
    };
};
var TemplatePlaceholderBase = /*#__PURE__*/ (function (_super) {
    __extends(TemplatePlaceholderBase, _super);
    function TemplatePlaceholderBase() {
        var _a;
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscription = (_a = {},
            _a[RERENDER_TEMPLATE_EVENT] = function (id) {
                if (_this.template && _this.template.id === id) {
                    _this.forceUpdate();
                }
            },
            _a[RERENDER_TEMPLATE_SCOPE_EVENT] = function (name) {
                var propsName = _this.props.name;
                if (propsName === name) {
                    _this.forceUpdate();
                }
            },
            _a);
        _this.template = null;
        _this.params = {};
        return _this;
    }
    TemplatePlaceholderBase.prototype.componentDidMount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.registerSubscription(this.subscription);
    };
    TemplatePlaceholderBase.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = getRenderingData(nextProps), params = _a.params, templates = _a.templates;
        var children = this.props.children;
        var _b = __read(templates, 1), template = _b[0];
        return children !== nextProps.children || this.template !== template
            || !(0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(this.params, params);
    };
    TemplatePlaceholderBase.prototype.componentWillUnmount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.unregisterSubscription(this.subscription);
    };
    TemplatePlaceholderBase.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = getRenderingData(this.props), params = _b.params, templates = _b.templates;
        this.params = params;
        _a = __read(templates, 1), this.template = _a[0];
        var restTemplates = templates.slice(1);
        var content = null;
        if (this.template) {
            var templateContent = this.template.children;
            content = templateContent() || null;
            if (content && typeof content === 'function') {
                content = content(params);
            }
        }
        var templatePlaceholder = this.props.children;
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(TemplateHostContext.Provider, { value: {
                templates: function () { return restTemplates; },
                params: function () { return _this.params; },
            } }, templatePlaceholder ? templatePlaceholder(content) : content));
    };
    return TemplatePlaceholderBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
/** A React component to which a related Template is rendered. */
var TemplatePlaceholder = withContext(PluginHostContext, PLUGIN_HOST_CONTEXT)(withContext(TemplateHostContext, TEMPLATE_HOST_CONTEXT)(TemplatePlaceholderBase));

/** @internal */
var PluginHostBase = /*#__PURE__*/ (function (_super) {
    __extends(PluginHostBase, _super);
    function PluginHostBase(props) {
        var _this = _super.call(this, props) || this;
        _this.host = new _devexpress_dx_core__WEBPACK_IMPORTED_MODULE_2__/* .PluginHost */ .RJ();
        return _this;
    }
    PluginHostBase.prototype.render = function () {
        var children = this.props.children;
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PluginHostContext.Provider, { value: this.host },
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(PluginIndexer, null, children),
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(TemplatePlaceholder, { name: "root" })));
    };
    return PluginHostBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
var PluginHost = PluginHostBase;

/** @internal */
var getAvailableGetters = function (pluginHost, getGetterValue) {
    if (getGetterValue === void 0) { getGetterValue = function (getterName) { return pluginHost.get(getterName + "Getter"); }; }
    var trackedDependencies = {};
    var getters;
    if (typeof Proxy !== 'undefined') {
        getters = new Proxy({}, {
            get: function (target, prop) {
                if (typeof prop !== 'string')
                    return undefined;
                var result = getGetterValue(prop);
                trackedDependencies[prop] = result;
                return result;
            },
            getOwnPropertyDescriptor: function (target, prop) {
                return {
                    configurable: true,
                    enumerable: true,
                    value: this.get(target, prop, undefined),
                };
            },
            ownKeys: function () {
                return pluginHost.knownKeys('Getter');
            },
        });
    }
    else {
        getters = pluginHost.knownKeys('Getter')
            .reduce(function (acc, getterName) {
            Object.defineProperty(acc, getterName, {
                get: function () {
                    var result = getGetterValue(getterName);
                    trackedDependencies[getterName] = result;
                    return result;
                },
            });
            return acc;
        }, {});
    }
    return { getters: getters, trackedDependencies: trackedDependencies };
};
/** @internal */
var isTrackedDependenciesChanged = function (pluginHost, prevTrackedDependencies, getGetterValue) {
    if (getGetterValue === void 0) { getGetterValue = function (getterName) { return pluginHost.get(getterName + "Getter"); }; }
    var trackedDependencies = Object.keys(prevTrackedDependencies)
        // tslint:disable-next-line: prefer-object-spread
        .reduce(function (acc, getterName) {
        var _a;
        return Object.assign(acc, (_a = {},
            _a[getterName] = getGetterValue(getterName),
            _a));
    }, {});
    return !(0,_devexpress_dx_core__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(prevTrackedDependencies, trackedDependencies);
};
/** @internal */
var getAvailableActions = function (pluginHost, getAction) {
    if (getAction === void 0) { getAction = function (actionName) { return pluginHost.collect(actionName + "Action").slice().reverse()[0]; }; }
    var actions;
    if (typeof Proxy !== 'undefined') {
        actions = new Proxy({}, {
            get: function (target, prop) {
                if (typeof prop !== 'string')
                    return undefined;
                return getAction(prop);
            },
            getOwnPropertyDescriptor: function (target, prop) {
                return {
                    configurable: true,
                    enumerable: true,
                    value: this.get(target, prop, undefined),
                };
            },
            ownKeys: function () {
                return pluginHost.knownKeys('Action');
            },
        });
    }
    else {
        actions = pluginHost.knownKeys('Action')
            .reduce(function (acc, actionName) {
            Object.defineProperty(acc, actionName, {
                get: function () { return getAction(actionName); },
            });
            return acc;
        }, {});
    }
    return actions;
};

var ActionBase = /*#__PURE__*/ (function (_super) {
    __extends(ActionBase, _super);
    function ActionBase(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        var _b = props, _c = PLUGIN_HOST_CONTEXT, pluginHost = _b[_c], _d = POSITION_CONTEXT, positionContext = _b[_d];
        var name = props.name;
        _this.plugin = (_a = {
                position: function () { return positionContext(); }
            },
            _a[name + "Action"] = function (params) {
                var action = _this.props.action;
                var getters = getAvailableGetters(pluginHost, function (getterName) { return pluginHost.get(getterName + "Getter", _this.plugin); }).getters;
                var nextParams = params;
                var actions = getAvailableActions(pluginHost, function (actionName) { return (actionName === name
                    ? function (newParams) { nextParams = newParams; }
                    : pluginHost.collect(actionName + "Action", _this.plugin).slice().reverse()[0]); });
                action(params, getters, actions);
                var nextAction = pluginHost.collect(name + "Action", _this.plugin).slice().reverse()[0];
                if (nextAction) {
                    nextAction(nextParams);
                }
            },
            _a);
        pluginHost.registerPlugin(_this.plugin);
        return _this;
    }
    ActionBase.prototype.componentWillUnmount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.unregisterPlugin(this.plugin);
    };
    ActionBase.prototype.render = function () {
        return null;
    };
    return ActionBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
var Action = withHostAndPosition(ActionBase);

var GetterBase = /*#__PURE__*/ (function (_super) {
    __extends(GetterBase, _super);
    function GetterBase(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        var _b = props, _c = PLUGIN_HOST_CONTEXT, pluginHost = _b[_c], _d = POSITION_CONTEXT, positionContext = _b[_d];
        var name = props.name;
        var lastComputed;
        var lastTrackedDependencies = {};
        var lastResult;
        _this.plugin = (_a = {
                position: function () { return positionContext(); }
            },
            _a[name + "Getter"] = function (original) {
                var _a = _this.props, value = _a.value, computed = _a.computed;
                if (computed === undefined)
                    return value;
                var getGetterValue = function (getterName) { return ((getterName === name)
                    ? original
                    : pluginHost.get(getterName + "Getter", _this.plugin)); };
                if (computed === lastComputed
                    && !isTrackedDependenciesChanged(pluginHost, lastTrackedDependencies, getGetterValue)) {
                    return lastResult;
                }
                var _b = getAvailableGetters(pluginHost, getGetterValue), getters = _b.getters, trackedDependencies = _b.trackedDependencies;
                var actions = getAvailableActions(pluginHost);
                lastComputed = computed;
                lastTrackedDependencies = trackedDependencies;
                lastResult = computed(getters, actions);
                return lastResult;
            },
            _a);
        pluginHost.registerPlugin(_this.plugin);
        return _this;
    }
    GetterBase.prototype.componentDidUpdate = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.broadcast(UPDATE_CONNECTION_EVENT);
    };
    GetterBase.prototype.componentWillUnmount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.unregisterPlugin(this.plugin);
    };
    GetterBase.prototype.render = function () {
        return null;
    };
    return GetterBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
var Getter = withHostAndPosition(GetterBase);

var globalTemplateId = 0;
/** @internal */
var TemplateBase = /*#__PURE__*/ (function (_super) {
    __extends(TemplateBase, _super);
    function TemplateBase(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.children = function () { return void 0; };
        globalTemplateId += 1;
        _this.id = globalTemplateId;
        var _b = props, _c = PLUGIN_HOST_CONTEXT, pluginHost = _b[_c], _d = POSITION_CONTEXT, positionContext = _b[_d];
        var name = props.name, predicate = props.predicate;
        _this.plugin = (_a = {
                position: function () { return positionContext(); }
            },
            _a[name + "Template"] = {
                id: _this.id,
                predicate: function (params) { return (predicate ? predicate(params) : true); },
                children: function () {
                    var children = _this.props.children;
                    return children;
                },
            },
            _a);
        pluginHost.registerPlugin(_this.plugin);
        pluginHost.broadcast(RERENDER_TEMPLATE_SCOPE_EVENT, name);
        return _this;
    }
    TemplateBase.prototype.componentDidUpdate = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        pluginHost.broadcast(RERENDER_TEMPLATE_EVENT, this.id);
    };
    TemplateBase.prototype.componentWillUnmount = function () {
        var _a = this.props, _b = PLUGIN_HOST_CONTEXT, pluginHost = _a[_b];
        var name = this.props.name;
        pluginHost.unregisterPlugin(this.plugin);
        pluginHost.broadcast(RERENDER_TEMPLATE_SCOPE_EVENT, name);
    };
    TemplateBase.prototype.render = function () {
        return null;
    };
    return TemplateBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
/*** A React component that defines a markup that is rendered
 * as the corresponding TemplatePlaceholder.
 */
var Template = withHostAndPosition(TemplateBase);

/** @internal */
var TemplateConnectorBase = /*#__PURE__*/ (function (_super) {
    __extends(TemplateConnectorBase, _super);
    function TemplateConnectorBase(props, context) {
        var _a;
        var _this = _super.call(this, props, context) || this;
        _this.trackedDependencies = {};
        _this.subscription = (_a = {},
            _a[UPDATE_CONNECTION_EVENT] = function () { return _this.updateConnection(); },
            _a);
        return _this;
    }
    TemplateConnectorBase.prototype.componentDidMount = function () {
        var pluginHost = this.context;
        pluginHost.registerSubscription(this.subscription);
    };
    TemplateConnectorBase.prototype.componentWillUnmount = function () {
        var pluginHost = this.context;
        pluginHost.unregisterSubscription(this.subscription);
    };
    TemplateConnectorBase.prototype.updateConnection = function () {
        var pluginHost = this.context;
        if (isTrackedDependenciesChanged(pluginHost, this.trackedDependencies)) {
            this.forceUpdate();
        }
    };
    TemplateConnectorBase.prototype.render = function () {
        var pluginHost = this.context;
        var children = this.props.children;
        var _a = getAvailableGetters(pluginHost), getters = _a.getters, trackedDependencies = _a.trackedDependencies;
        this.trackedDependencies = trackedDependencies;
        var actions = getAvailableActions(pluginHost);
        return children(getters, actions);
    };
    return TemplateConnectorBase;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
TemplateConnectorBase.contextType = PluginHostContext;
/** A React component that provides access to Getters and Actions within a Template. */
var TemplateConnector = TemplateConnectorBase;

var TIMEOUT = 180;
/** @internal */
var TouchStrategy = /*#__PURE__*/ (function () {
    function TouchStrategy(delegate) {
        this.delegate = delegate;
        this.touchStartTimeout = null;
        this.dragging = false;
    }
    TouchStrategy.prototype.isDragging = function () {
        return this.dragging;
    };
    TouchStrategy.prototype.isWaiting = function () {
        return !!this.touchStartTimeout;
    };
    TouchStrategy.prototype.cancelWaiting = function () {
        clearTimeout(this.touchStartTimeout);
        this.touchStartTimeout = undefined;
    };
    TouchStrategy.prototype.start = function (e) {
        var _this = this;
        var _a = e.touches[0], x = _a.clientX, y = _a.clientY;
        this.touchStartTimeout = setTimeout(function () {
            _this.delegate.onStart({ x: x, y: y });
            _this.dragging = true;
        }, TIMEOUT);
    };
    TouchStrategy.prototype.move = function (e) {
        this.cancelWaiting();
        if (this.dragging) {
            var _a = e.touches[0], clientX = _a.clientX, clientY = _a.clientY;
            e.preventDefault();
            this.delegate.onMove({ x: clientX, y: clientY });
        }
    };
    TouchStrategy.prototype.end = function (e) {
        this.cancelWaiting();
        if (this.dragging) {
            var _a = e.changedTouches[0], clientX = _a.clientX, clientY = _a.clientY;
            this.delegate.onEnd({ x: clientX, y: clientY });
        }
        this.mouseInitialOffset = null;
        this.dragging = false;
    };
    return TouchStrategy;
}());

/* globals document:true */
var gestureCover;
/** @internal */
var toggleGestureCover = function (toggle, cursor) {
    var style = {
        pointerEvents: toggle ? 'all' : 'none',
    };
    if (toggle && cursor) {
        style = __assign(__assign({}, style), { cursor: cursor });
    }
    if (!gestureCover) {
        style = __assign(__assign({}, style), { position: 'fixed', top: 0, right: 0, left: 0, bottom: 0, opacity: 0, zIndex: 2147483647 });
        gestureCover = document.createElement('div');
        document.body.appendChild(gestureCover);
    }
    Object.keys(style).forEach(function (key) { gestureCover.style[key] = style[key]; });
};

/* globals document:true window:true */
/** @internal */
var clear = function () {
    var selection = window.getSelection && window.getSelection();
    if (selection) {
        if (selection.empty) {
            selection.empty();
        }
        else if (selection.removeAllRanges) {
            selection.removeAllRanges();
        }
    }
};

/* globals window:true document:true */
var BOUNDARY = 10;
var clamp = function (value, min, max) { return Math.max(Math.min(value, max), min); };
var isBoundExceeded = function (_a, _b) {
    var initialX = _a.x, initialY = _a.y;
    var x = _b.x, y = _b.y;
    return clamp(x, initialX - BOUNDARY, initialX + BOUNDARY) !== x
        || clamp(y, initialY - BOUNDARY, initialY + BOUNDARY) !== y;
};
/** @internal */
var MouseStrategy = /*#__PURE__*/ (function () {
    function MouseStrategy(delegate) {
        this.delegate = delegate;
        this.mouseInitialOffset = null;
        this.dragging = false;
    }
    MouseStrategy.prototype.isDragging = function () {
        return this.dragging;
    };
    MouseStrategy.prototype.start = function (e) {
        var x = e.clientX, y = e.clientY;
        this.e = e;
        this.mouseInitialOffset = { x: x, y: y };
    };
    MouseStrategy.prototype.move = function (e) {
        var x = e.clientX, y = e.clientY;
        var dragStarted = false;
        if (!this.dragging && this.mouseInitialOffset) {
            if (isBoundExceeded(this.mouseInitialOffset, { x: x, y: y })) {
                this.delegate.onStart(this.mouseInitialOffset);
                clear();
                dragStarted = true;
                this.dragging = true;
            }
        }
        if (this.dragging) {
            e.preventDefault();
            this.delegate.onMove({ x: x, y: y });
        }
        if (dragStarted) {
            var element = document.elementFromPoint(x, y);
            var cursor = element ? window.getComputedStyle(element).cursor : null;
            toggleGestureCover(true, cursor);
        }
    };
    MouseStrategy.prototype.end = function (e) {
        if (this.dragging) {
            var x = e.clientX, y = e.clientY;
            toggleGestureCover(false);
            this.delegate.onEnd({ x: x, y: y });
        }
        this.mouseInitialOffset = null;
        this.dragging = false;
    };
    return MouseStrategy;
}());

/* globals window:true */
var eventEmitter;
/** @internal */
var getSharedEventEmitter = function () {
    if (!eventEmitter) {
        eventEmitter = new _devexpress_dx_core__WEBPACK_IMPORTED_MODULE_2__/* .EventEmitter */ .vp();
        ['mousemove', 'mouseup', 'touchmove', 'touchend', 'touchcancel']
            .forEach(function (name) { return window.addEventListener(name, function (e) { return eventEmitter.emit([name, e]); }, { passive: false }); });
    }
    return eventEmitter;
};

var draggingHandled = Symbol('draggingHandled');
/** @internal */
var Draggable = /*#__PURE__*/ (function (_super) {
    __extends(Draggable, _super);
    function Draggable(props, context) {
        var _this = _super.call(this, props, context) || this;
        var delegate = {
            onStart: function (_a) {
                var x = _a.x, y = _a.y;
                var onStart = _this.props.onStart;
                if (!onStart)
                    return;
                (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates)(function () {
                    onStart({ x: x, y: y });
                });
            },
            onMove: function (_a) {
                var x = _a.x, y = _a.y;
                var onUpdate = _this.props.onUpdate;
                if (!onUpdate)
                    return;
                (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates)(function () {
                    onUpdate({ x: x, y: y });
                });
            },
            onEnd: function (_a) {
                var x = _a.x, y = _a.y;
                var onEnd = _this.props.onEnd;
                if (!onEnd)
                    return;
                (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates)(function () {
                    onEnd({ x: x, y: y });
                });
            },
        };
        _this.mouseStrategy = new MouseStrategy(delegate);
        _this.touchStrategy = new TouchStrategy(delegate);
        _this.mouseDownListener = _this.mouseDownListener.bind(_this);
        _this.touchStartListener = _this.touchStartListener.bind(_this);
        _this.globalListener = _this.globalListener.bind(_this);
        return _this;
    }
    Draggable.prototype.componentDidMount = function () {
        getSharedEventEmitter().subscribe(this.globalListener);
        this.setupNodeSubscription();
    };
    Draggable.prototype.shouldComponentUpdate = function (nextProps) {
        var children = this.props.children;
        return nextProps.children !== children;
    };
    Draggable.prototype.componentDidUpdate = function () {
        this.setupNodeSubscription();
    };
    Draggable.prototype.componentWillUnmount = function () {
        getSharedEventEmitter().unsubscribe(this.globalListener);
    };
    Draggable.prototype.setupNodeSubscription = function () {
        var node = (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(this);
        if (!node)
            return;
        node.removeEventListener('mousedown', this.mouseDownListener);
        node.removeEventListener('touchstart', this.touchStartListener);
        node.addEventListener('mousedown', this.mouseDownListener);
        node.addEventListener('touchstart', this.touchStartListener, { passive: true });
    };
    Draggable.prototype.mouseDownListener = function (e) {
        if (this.touchStrategy.isWaiting() || e[draggingHandled])
            return;
        e.preventDefault();
        this.mouseStrategy.start(e);
        e[draggingHandled] = true;
    };
    Draggable.prototype.touchStartListener = function (e) {
        if (e[draggingHandled])
            return;
        this.touchStrategy.start(e);
        e[draggingHandled] = true;
    };
    Draggable.prototype.globalListener = function (_a) {
        var _b = __read(_a, 2), name = _b[0], e = _b[1];
        switch (name) {
            case 'mousemove':
                this.mouseStrategy.move(e);
                break;
            case 'mouseup':
                this.mouseStrategy.end(e);
                break;
            case 'touchmove': {
                this.touchStrategy.move(e);
                break;
            }
            case 'touchend':
            case 'touchcancel': {
                this.touchStrategy.end(e);
                break;
            }
        }
        if (this.mouseStrategy.isDragging() || this.touchStrategy.isDragging()) {
            clear();
        }
    };
    Draggable.prototype.render = function () {
        var children = this.props.children;
        return children;
    };
    return Draggable;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));

/** @internal */
var DragDropContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

/** @internal */
var DragDropProviderCore = /*#__PURE__*/ (function () {
    function DragDropProviderCore() {
        this.payload = null;
        this.dragEmitter = new _devexpress_dx_core__WEBPACK_IMPORTED_MODULE_2__/* .EventEmitter */ .vp();
    }
    DragDropProviderCore.prototype.start = function (payload, clientOffset) {
        this.payload = payload;
        this.dragEmitter.emit({ clientOffset: clientOffset, payload: this.payload });
    };
    DragDropProviderCore.prototype.update = function (clientOffset) {
        this.dragEmitter.emit({ clientOffset: clientOffset, payload: this.payload });
    };
    DragDropProviderCore.prototype.end = function (clientOffset) {
        this.dragEmitter.emit({ clientOffset: clientOffset, payload: this.payload, end: true });
        this.payload = null;
    };
    return DragDropProviderCore;
}());
var defaultProps = {
    onChange: function (_a) {
        var payload = _a.payload, clientOffset = _a.clientOffset;
    },
};
/** @internal */
// tslint:disable-next-line: max-classes-per-file
var DragDropProvider = /*#__PURE__*/ (function (_super) {
    __extends(DragDropProvider, _super);
    function DragDropProvider(props) {
        var _this = _super.call(this, props) || this;
        var onChange = _this.props.onChange;
        _this.dragDropProvider = new DragDropProviderCore();
        _this.dragDropProvider.dragEmitter.subscribe(function (_a) {
            var payload = _a.payload, clientOffset = _a.clientOffset, end = _a.end;
            onChange({
                payload: end ? null : payload,
                clientOffset: end ? null : clientOffset,
            });
        });
        return _this;
    }
    DragDropProvider.prototype.shouldComponentUpdate = function (nextProps) {
        var children = this.props.children;
        return nextProps.children !== children;
    };
    DragDropProvider.prototype.render = function () {
        var children = this.props.children;
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(DragDropContext.Provider, { value: this.dragDropProvider }, children));
    };
    DragDropProvider.defaultProps = defaultProps;
    return DragDropProvider;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));

var defaultProps$1 = {
    onStart: function (_a) {
        var clientOffset = _a.clientOffset;
    },
    onUpdate: function (_a) {
        var clientOffset = _a.clientOffset;
    },
    onEnd: function (_a) {
        var clientOffset = _a.clientOffset;
    },
};
/** @internal */
var DragSource = /*#__PURE__*/ (function (_super) {
    __extends(DragSource, _super);
    function DragSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DragSource.prototype.shouldComponentUpdate = function (nextProps) {
        var children = this.props.children;
        return nextProps.children !== children;
    };
    DragSource.prototype.render = function () {
        var dragDropProvider = this.context;
        var _a = this.props, onStart = _a.onStart, onUpdate = _a.onUpdate, onEnd = _a.onEnd, payload = _a.payload, children = _a.children;
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Draggable, { onStart: function (_a) {
                var x = _a.x, y = _a.y;
                dragDropProvider.start(payload, { x: x, y: y });
                onStart({ clientOffset: { x: x, y: y } });
            }, onUpdate: function (_a) {
                var x = _a.x, y = _a.y;
                dragDropProvider.update({ x: x, y: y });
                onUpdate({ clientOffset: { x: x, y: y } });
            }, onEnd: function (_a) {
                var x = _a.x, y = _a.y;
                dragDropProvider.end({ x: x, y: y });
                onEnd({ clientOffset: { x: x, y: y } });
            } }, children));
    };
    DragSource.defaultProps = defaultProps$1;
    return DragSource;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
DragSource.contextType = DragDropContext;

var clamp$1 = function (value, min, max) { return Math.max(Math.min(value, max), min); };
var defaultProps$2 = {
    onEnter: function (args) { },
    onOver: function (args) { },
    onLeave: function (args) { },
    onDrop: function (args) { },
};
/** @internal */
var DropTarget = /*#__PURE__*/ (function (_super) {
    __extends(DropTarget, _super);
    function DropTarget(props) {
        var _this = _super.call(this, props) || this;
        _this.isOver = false;
        _this.handleDrag = _this.handleDrag.bind(_this);
        return _this;
    }
    DropTarget.prototype.componentDidMount = function () {
        var dragEmitter = this.context.dragEmitter;
        dragEmitter.subscribe(this.handleDrag);
    };
    DropTarget.prototype.shouldComponentUpdate = function (nextProps) {
        var children = this.props.children;
        return nextProps.children !== children;
    };
    DropTarget.prototype.componentWillUnmount = function () {
        var dragEmitter = this.context.dragEmitter;
        dragEmitter.unsubscribe(this.handleDrag);
    };
    DropTarget.prototype.handleDrag = function (_a) {
        var payload = _a.payload, clientOffset = _a.clientOffset, end = _a.end;
        var _b = (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(this).getBoundingClientRect(), left = _b.left, top = _b.top, right = _b.right, bottom = _b.bottom;
        var _c = this.props, onDrop = _c.onDrop, onEnter = _c.onEnter, onLeave = _c.onLeave, onOver = _c.onOver;
        var isOver = clientOffset
            && clamp$1(clientOffset.x, left, right) === clientOffset.x
            && clamp$1(clientOffset.y, top, bottom) === clientOffset.y;
        if (!this.isOver && isOver)
            onEnter({ payload: payload, clientOffset: clientOffset });
        if (this.isOver && isOver)
            onOver({ payload: payload, clientOffset: clientOffset });
        if (this.isOver && !isOver)
            onLeave({ payload: payload, clientOffset: clientOffset });
        if (isOver && end)
            onDrop({ payload: payload, clientOffset: clientOffset });
        this.isOver = isOver && !end;
    };
    DropTarget.prototype.render = function () {
        var children = this.props.children;
        return react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children);
    };
    DropTarget.defaultProps = defaultProps$2;
    return DropTarget;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));
DropTarget.contextType = DragDropContext;

/** @internal */
var RefHolder = /*#__PURE__*/ (function (_super) {
    __extends(RefHolder, _super);
    function RefHolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RefHolder.prototype.render = function () {
        var children = this.props.children;
        return children;
    };
    return RefHolder;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));

/* globals document:true */
var styles = {
    root: {
        position: 'relative',
    },
    triggersRoot: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        zIndex: -1,
        visibility: 'hidden',
        opacity: 0,
    },
    expandTrigger: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        overflow: 'auto',
    },
    contractTrigger: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        overflow: 'auto',
        minHeight: '1px',
        minWidth: '1px',
    },
    contractNotifier: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '200%',
        height: '200%',
        minHeight: '2px',
        minWidth: '2px',
    },
};
/** @internal */
var Sizer = /*#__PURE__*/ (function (_super) {
    __extends(Sizer, _super);
    function Sizer(props) {
        var _this = _super.call(this, props) || this;
        _this.getSize = function () { return ({ height: _this.rootNode.clientHeight, width: _this.rootNode.clientWidth }); };
        _this.setupListeners = _this.setupListeners.bind(_this);
        _this.rootRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)();
        return _this;
    }
    Sizer.prototype.componentDidMount = function () {
        this.createListeners();
        this.setupListeners();
    };
    Sizer.prototype.componentDidUpdate = function () {
        // We can scroll the VirtualTable manually only by changing
        // containter's (rootNode) scrollTop property.
        // Viewport changes its own properties automatically.
        var scrollTop = this.props.scrollTop;
        if (scrollTop > -1) {
            this.rootNode.scrollTop = scrollTop;
        }
    };
    // There is no need to remove listeners as divs are removed from DOM when component is unmount.
    // But there is a little chance that component unmounting and 'scroll' event happen roughly
    // at the same time so that `setupListeners` is called after component is unmount.
    Sizer.prototype.componentWillUnmount = function () {
        this.expandTrigger.removeEventListener('scroll', this.setupListeners);
        this.contractTrigger.removeEventListener('scroll', this.setupListeners);
    };
    Sizer.prototype.setupListeners = function () {
        var size = this.getSize();
        var width = size.width, height = size.height;
        this.contractTrigger.scrollTop = height;
        this.contractTrigger.scrollLeft = width;
        var scrollOffset = 2;
        this.expandNotifier.style.width = width + scrollOffset + "px";
        this.expandNotifier.style.height = height + scrollOffset + "px";
        this.expandTrigger.scrollTop = scrollOffset;
        this.expandTrigger.scrollLeft = scrollOffset;
        var onSizeChange = this.props.onSizeChange;
        onSizeChange(size);
    };
    Sizer.prototype.createListeners = function () {
        this.rootNode = (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(this.rootRef.current);
        this.triggersRoot = document.createElement('div');
        Object.assign(this.triggersRoot.style, styles.triggersRoot);
        this.rootNode.appendChild(this.triggersRoot);
        this.expandTrigger = document.createElement('div');
        Object.assign(this.expandTrigger.style, styles.expandTrigger);
        this.expandTrigger.addEventListener('scroll', this.setupListeners);
        this.triggersRoot.appendChild(this.expandTrigger);
        this.expandNotifier = document.createElement('div');
        this.expandTrigger.appendChild(this.expandNotifier);
        this.contractTrigger = document.createElement('div');
        Object.assign(this.contractTrigger.style, styles.contractTrigger);
        this.contractTrigger.addEventListener('scroll', this.setupListeners);
        this.triggersRoot.appendChild(this.contractTrigger);
        this.contractNotifier = document.createElement('div');
        Object.assign(this.contractNotifier.style, styles.contractNotifier);
        this.contractTrigger.appendChild(this.contractNotifier);
    };
    Sizer.prototype.render = function () {
        var _a = this.props, onSizeChange = _a.onSizeChange, Container = _a.containerComponent, style = _a.style, scrollTop = _a.scrollTop, restProps = __rest(_a, ["onSizeChange", "containerComponent", "style", "scrollTop"]);
        return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(RefHolder, { ref: this.rootRef },
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Container // NOTE: should have `position: relative`
            , __assign({ style: style ? __assign(__assign({}, styles.root), style) : styles.root }, restProps))));
    };
    Sizer.defaultProps = {
        containerComponent: 'div',
    };
    return Sizer;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));

/*** A function that creates a new component that allows you to pass additional properties
 * to the wrapped component.
 */
var connectProps = function (WrappedComponent, getAdditionalProps) {
    var storedAdditionalProps = getAdditionalProps();
    var components = new Set();
    var RenderComponent = /*#__PURE__*/ (function (_super) {
        __extends(RenderComponent, _super);
        function RenderComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        RenderComponent.prototype.componentDidMount = function () {
            components.add(this);
        };
        RenderComponent.prototype.componentWillUnmount = function () {
            components.delete(this);
        };
        RenderComponent.prototype.render = function () {
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, __assign({}, this.props, storedAdditionalProps));
        };
        return RenderComponent;
    }(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
    RenderComponent.update = function () {
        storedAdditionalProps = getAdditionalProps();
        Array.from(components.values()).forEach(function (component) { return component.forceUpdate(); });
    };
    return RenderComponent;
};

/** @internal */
var createStateHelper = function (component, controlledStateProperties) {
    if (controlledStateProperties === void 0) { controlledStateProperties = {}; }
    var notifyStateChange = function (nextState, state) {
        Object.keys(controlledStateProperties).forEach(function (propertyName) {
            var changeEvent = controlledStateProperties[propertyName]();
            if (changeEvent && nextState[propertyName] !== state[propertyName]) {
                changeEvent(nextState[propertyName]);
            }
        });
    };
    var lastStateUpdater;
    var initialState = null;
    var lastInitialState = null;
    var newState = null;
    var shouldNotify = false;
    var applyReducer = function (reduce, payload, callback) {
        var stateUpdater = function (prevState) {
            if (initialState === null) {
                initialState = prevState;
            }
            var stateChange = reduce(__assign({}, prevState), payload);
            var state = __assign(__assign({}, prevState), stateChange);
            if (typeof callback === 'function') {
                callback(state, prevState);
            }
            if (stateUpdater === lastStateUpdater) {
                if (lastInitialState !== initialState) {
                    newState = state;
                    if (!shouldNotify) {
                        lastInitialState = initialState;
                        shouldNotify = true;
                    }
                }
                initialState = null;
            }
            return stateChange;
        };
        lastStateUpdater = stateUpdater;
        component.setState(stateUpdater, function () {
            if (shouldNotify) {
                notifyStateChange(newState, lastInitialState);
                shouldNotify = false;
            }
        });
    };
    var applyFieldReducer = function (field, reduce, payload) {
        applyReducer(function (state) {
            var _a;
            return (_a = {},
                _a[field] = reduce(state[field], payload),
                _a);
        });
    };
    return {
        applyReducer: applyReducer,
        applyFieldReducer: applyFieldReducer,
    };
};

var makeBoundComponent = function (Target, components, exposed) {
    var Component = /*#__PURE__*/ (function (_super) {
        __extends(Component, _super);
        function Component() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Component.prototype.render = function () {
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Target, __assign({}, components, this.props));
        };
        return Component;
    }(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent));
    Component.components = Target.components;
    Object.assign(Component, exposed);
    return Component;
};
// type ITargetComponentStatic = new() => ITargetComponent;
/** @internal */
var withComponents = function (components) { return function (Target) {
    var props = {};
    var exposed = {};
    var targetComponents = Target.components;
    Object.entries(targetComponents).forEach(function (_a) {
        var _b = __read(_a, 2), fieldName = _b[0], componentName = _b[1];
        var component = components[componentName];
        if (component && component !== Target[componentName]) {
            props[fieldName] = component;
        }
        exposed[componentName] = component || Target[componentName];
    });
    return Object.keys(props).length > 0
        ? makeBoundComponent(Target, props, exposed) : Target;
}; };

/* globals Element */
/** @internal */
var RefType = (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
    current: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.instanceOf)((typeof Element !== 'undefined') ? Element : Object),
});


//# sourceMappingURL=dx-react-core.es.js.map


/***/ }),

/***/ 13716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rj": function() { return /* binding */ Grid; },
  "cO": function() { return /* binding */ Table$1; },
  "ad": function() { return /* binding */ TableColumnResizing; },
  "KA": function() { return /* binding */ TableHeaderRow; },
  "WI": function() { return /* binding */ TableInlineCellEditing; }
});

// UNUSED EXPORTS: ColumnChooser, DragDropProvider, ExportPanel, GroupingPanel, PagingPanel, SearchPanel, TableBandHeader, TableColumnReordering, TableColumnVisibility, TableEditColumn, TableEditRow, TableFilterRow, TableFixedColumns, TableGroupRow, TableRowDetail, TableSelection, TableSummaryRow, TableTreeColumn, Toolbar, VirtualTable

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@devexpress/dx-react-grid/dist/dx-react-grid.es.js
var dx_react_grid_es = __webpack_require__(48994);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@devexpress/dx-react-core/dist/dx-react-core.es.js
var dx_react_core_es = __webpack_require__(3998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(52387);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(38799);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 4 modules
var Select = __webpack_require__(94924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronLeft.js
var ChevronLeft = __webpack_require__(89875);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronRight.js
var ChevronRight = __webpack_require__(66735);
// EXTERNAL MODULE: ./node_modules/@devexpress/dx-grid-core/dist/dx-grid-core.es.js
var dx_grid_core_es = __webpack_require__(47855);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/ArrowDownward.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var ArrowDownward = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableSortLabel/TableSortLabel.js









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:focus': {
        color: theme.palette.text.secondary
      },
      '&:hover': {
        color: theme.palette.text.secondary,
        '& $icon': {
          opacity: 0.5
        }
      },
      '&$active': {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        '&& $icon': {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the icon component. */
    icon: {
      fontSize: 18,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none'
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

var TableSortLabel = /*#__PURE__*/react.forwardRef(function TableSortLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'asc' : _props$direction,
      _props$hideSortIcon = props.hideSortIcon,
      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDownward : _props$IconComponent,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);

  return /*#__PURE__*/react.createElement(ButtonBase/* default */.Z, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref: ref
  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/react.createElement(IconComponent, {
    className: (0,clsx_m/* default */.Z)(classes.icon, classes["iconDirection".concat((0,capitalize/* default */.Z)(direction))])
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var TableSortLabel_TableSortLabel = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/TableContext.js

/**
 * @ignore - internal component.
 */

var TableContext = react.createContext();

if (false) {}

/* harmony default export */ var Table_TableContext = (TableContext);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/Tablelvl2Context.js

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = react.createContext();

if (false) {}

/* harmony default export */ var Table_Tablelvl2Context = (Tablelvl2Context);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js











var TableCell_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0,colorManipulator/* lighten */.$n)((0,colorManipulator/* alpha */.Fq)(theme.palette.divider, 1), 0.88) : (0,colorManipulator/* darken */._j)((0,colorManipulator/* alpha */.Fq)(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/react.forwardRef(function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = react.useContext(Table_TableContext);
  var tablelvl2 = react.useContext(Table_Tablelvl2Context);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0,capitalize/* default */.Z)(align))], padding !== 'normal' && classes["padding".concat((0,capitalize/* default */.Z)(padding))], size !== 'medium' && classes["size".concat((0,capitalize/* default */.Z)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableCell_TableCell = ((0,withStyles/* default */.Z)(TableCell_styles, {
  name: 'MuiTableCell'
})(TableCell));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js








var TableRow_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/react.forwardRef(function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = react.useContext(Table_Tablelvl2Context);
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent ? null : 'row'
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableRow_TableRow = ((0,withStyles/* default */.Z)(TableRow_styles, {
  name: 'MuiTableRow'
})(TableRow));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/colorManipulator.js
var styles_colorManipulator = __webpack_require__(59114);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js







var TableBody_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var TableBody_defaultComponent = 'tbody';
var TableBody = /*#__PURE__*/react.forwardRef(function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableBody_defaultComponent : _props$component,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react.createElement(Table_Tablelvl2Context.Provider, {
    value: tablelvl2
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref,
    role: Component === TableBody_defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var TableBody_TableBody = ((0,withStyles/* default */.Z)(TableBody_styles, {
  name: 'MuiTableBody'
})(TableBody));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableHead/TableHead.js







var TableHead_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var TableHead_tablelvl2 = {
  variant: 'head'
};
var TableHead_defaultComponent = 'thead';
var TableHead = /*#__PURE__*/react.forwardRef(function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableHead_defaultComponent : _props$component,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react.createElement(Table_Tablelvl2Context.Provider, {
    value: TableHead_tablelvl2
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref,
    role: Component === TableHead_defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var TableHead_TableHead = ((0,withStyles/* default */.Z)(TableHead_styles, {
  name: 'MuiTableHead'
})(TableHead));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableFooter/TableFooter.js







var TableFooter_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
var TableFooter_tablelvl2 = {
  variant: 'footer'
};
var TableFooter_defaultComponent = 'tfoot';
var TableFooter = /*#__PURE__*/react.forwardRef(function TableFooter(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableFooter_defaultComponent : _props$component,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react.createElement(Table_Tablelvl2Context.Provider, {
    value: TableFooter_tablelvl2
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref,
    role: Component === TableFooter_defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var TableFooter_TableFooter = ((0,withStyles/* default */.Z)(TableFooter_styles, {
  name: 'MuiTableFooter'
})(TableFooter));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js








var Table_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var Table_defaultComponent = 'table';
var Table = /*#__PURE__*/react.forwardRef(function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? Table_defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'normal' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = react.useMemo(function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/react.createElement(Table_TableContext.Provider, {
    value: table
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    role: Component === Table_defaultComponent ? null : 'table',
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var Table_Table = ((0,withStyles/* default */.Z)(Table_styles, {
  name: 'MuiTable'
})(Table));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu_Menu = __webpack_require__(38396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(62087);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/List.js
var icons_List = __webpack_require__(24960);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(66283);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Save.js
var Save = __webpack_require__(53375);
;// CONCATENATED MODULE: ./node_modules/@devexpress/dx-react-grid-material-ui/dist/dx-react-grid-material-ui.es.js
/**
 * Bundle of @devexpress/dx-react-grid-material-ui
 * Generated: 2021-06-24
 * Version: 2.7.6
 * License: https://js.devexpress.com/Licensing
 */










































function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["children", "classes", "className"];
var dx_react_grid_material_ui_es_styles = {
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
};

var RootBase = function RootBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, restProps), children);
};

 false ? 0 : void 0;
RootBase.defaultProps = {
  className: undefined
};
var Root = (0,withStyles/* default */.Z)(dx_react_grid_material_ui_es_styles)(RootBase);

var _excluded$1 = ["children"];
var Grid = function Grid(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* Grid */.rj, _extends({
    rootComponent: Root
  }, props), children);
};
Grid.Root = Root;
 false ? 0 : void 0;

var _excluded$2 = ["visible", "onHide", "children", "target"];
var Overlay = function Overlay(_ref) {
  var visible = _ref.visible,
      onHide = _ref.onHide,
      children = _ref.children,
      target = _ref.target,
      restProps = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/(0,react.createElement)(Popover/* default */.ZP, _extends({
    open: visible,
    anchorEl: target,
    onClose: onHide,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, restProps), children);
};
 false ? 0 : void 0;
Overlay.defaultProps = {
  visible: false,
  target: null
};

var _excluded$3 = ["children"];
var Container = function Container(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/(0,react.createElement)(List/* default */.Z, _extends({
    dense: true
  }, restProps), children);
};
 false ? 0 : void 0;

var _excluded$4 = ["onToggle", "getMessage", "buttonRef", "active"];
var ToggleButton = function ToggleButton(_ref) {
  var onToggle = _ref.onToggle,
      getMessage = _ref.getMessage,
      buttonRef = _ref.buttonRef,
      active = _ref.active,
      restProps = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/(0,react.createElement)(Tooltip/* default */.ZP, {
    title: getMessage('showColumnChooser'),
    placement: "bottom",
    enterDelay: 300
  }, /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, _extends({
    onClick: onToggle,
    buttonRef: buttonRef
  }, restProps), /*#__PURE__*/(0,react.createElement)(VisibilityOff/* default */.Z, null)));
};
 false ? 0 : void 0;
ToggleButton.defaultProps = {
  active: false
};

var _excluded$5 = ["item", "disabled", "onToggle", "classes"];

var styles$1 = function styles(theme) {
  return {
    checkbox: {
      padding: 0
    },
    itemText: {
      paddingLeft: theme.spacing(1)
    }
  };
};

var ItemBase = function ItemBase(_ref) {
  var _ref$item = _ref.item,
      column = _ref$item.column,
      hidden = _ref$item.hidden,
      disabled = _ref.disabled,
      onToggle = _ref.onToggle,
      classes = _ref.classes,
      restProps = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/(0,react.createElement)(ListItem/* default */.Z, _extends({
    key: column.name,
    button: !disabled,
    component: "li",
    disabled: disabled,
    onClick: !disabled ? onToggle : null
  }, restProps), /*#__PURE__*/(0,react.createElement)(Checkbox/* default */.Z, {
    checked: !hidden,
    tabIndex: -1,
    disableRipple: true,
    disabled: disabled,
    className: classes.checkbox
  }), /*#__PURE__*/(0,react.createElement)(ListItemText/* default */.Z, {
    className: classes.itemText,
    primary: column.title || column.name
  }));
};

 false ? 0 : void 0;
ItemBase.defaultProps = {
  onToggle: function onToggle() {},
  disabled: false
};
var Item = (0,withStyles/* default */.Z)(styles$1, {
  name: 'Item'
})(ItemBase);

var withPatchedProps = function withPatchedProps(patchProps) {
  return function (Target) {
    var Patched = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(Patched, _React$PureComponent);

      var _super = _createSuper(Patched);

      function Patched() {
        _classCallCheck(this, Patched);

        return _super.apply(this, arguments);
      }

      _createClass(Patched, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/(0,react.createElement)(Target, patchProps(this.props));
        }
      }]);

      return Patched;
    }(react.PureComponent);

    return Patched;
  };
};

var _excluded$6 = ["messages"];
var defaultMessages = {
  showColumnChooser: 'Show Column Chooser'
};
var ColumnChooserWithMessages = withPatchedProps(function (_ref) {
  var messages = _ref.messages,
      restProps = _objectWithoutProperties(_ref, _excluded$6);

  return _objectSpread2({
    messages: _objectSpread2(_objectSpread2({}, defaultMessages), messages)
  }, restProps);
})(dx_react_grid_es/* ColumnChooser */.kU);
ColumnChooserWithMessages.propTypes = {
  messages: (0,prop_types.shape)({
    hiddenColumnNames: prop_types.string
  })
};
ColumnChooserWithMessages.defaultProps = {
  messages: {}
};
ColumnChooserWithMessages.components = dx_react_grid_es/* ColumnChooser.components */.kU.components;
var ColumnChooser = (0,dx_react_core_es/* withComponents */.we)({
  Container: Container,
  Item: Item,
  Overlay: Overlay,
  ToggleButton: ToggleButton
})(ColumnChooserWithMessages);

var _excluded$7 = ["clientOffset", "classes", "style", "className", "children"],
    _excluded2 = ["column", "classes", "className"];

var styles$2 = function styles(theme) {
  return {
    container: {
      position: 'fixed',
      zIndex: 1000,
      left: 0,
      top: 0,
      display: 'inline-block'
    },
    column: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      float: 'right',
      cursor: 'move'
    }
  };
};

var ContainerBase = function ContainerBase(_ref) {
  var clientOffset = _ref.clientOffset,
      classes = _ref.classes,
      style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.container, className),
    style: _objectSpread2({
      transform: "translate(calc(".concat(clientOffset.x, "px - 50%), calc(").concat(clientOffset.y, "px - 50%))"),
      msTransform: "translateX(".concat(clientOffset.x, "px) translateX(-50%) translateY(").concat(clientOffset.y, "px) translateY(-50%)")
    }, style)
  }, restProps), children);
};

 false ? 0 : void 0;
ContainerBase.defaultProps = {
  style: null,
  className: undefined,
  children: undefined
};
var Container$1 = (0,withStyles/* default */.Z)(styles$2, {
  name: 'DragDrop'
})(ContainerBase);
var ColumnBase = /*#__PURE__*/(0,react.memo)(function (_ref2) {
  var column = _ref2.column,
      classes = _ref2.classes,
      className = _ref2.className,
      restProps = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/(0,react.createElement)(Chip/* default */.Z, _extends({
    className: (0,clsx_m/* default */.Z)(classes.column, className),
    label: column.title
  }, restProps));
});
ColumnBase.propTypes = {
  column: prop_types.object.isRequired,
  classes: prop_types.object.isRequired,
  className: prop_types.string
};
ColumnBase.defaultProps = {
  className: undefined
};
var Column = (0,withStyles/* default */.Z)(styles$2, {
  name: 'DragDrop'
})(ColumnBase);

var DragDropProvider = (0,dx_react_core_es/* withComponents */.we)({
  Container: Container$1,
  Column: Column
})(dx_react_grid_es/* DragDropProvider */.wz);

var IS_LEGACY_EDGE_MEDIA_QUERY = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)';

var styles$3 = function styles(theme) {
  return {
    pageSizeSelector: _objectSpread2(_objectSpread2({}, theme.typography.caption), {}, {
      paddingRight: theme.spacing(5),
      // NOTE: fixes vertical alignment in FF
      display: 'flex',
      alignItems: 'center'
    }),
    label: {
      paddingRight: theme.spacing(3)
    },
    pageSizeTitle: {
      width: 'auto',
      marginRight: theme.spacing(2)
    },
    inputRoot: {
      fontSize: theme.spacing(1.75),
      textAlign: 'right'
    },
    selectIcon: {
      top: 2
    },
    selectMenu: _defineProperty({}, "".concat(IS_LEGACY_EDGE_MEDIA_QUERY), {
      position: 'absolute !important'
    }),
    '@media (max-width: 768px)': {
      label: {
        display: 'none'
      },
      pageSizeSelector: {
        paddingRight: theme.spacing(2)
      }
    }
  };
};

var PageSizeSelectorBase = function PageSizeSelectorBase(_ref) {
  var pageSize = _ref.pageSize,
      onPageSizeChange = _ref.onPageSizeChange,
      pageSizes = _ref.pageSizes,
      getMessage = _ref.getMessage,
      classes = _ref.classes;
  var showAll = getMessage('showAll');
  return /*#__PURE__*/(0,react.createElement)("div", {
    className: classes.pageSizeSelector
  }, /*#__PURE__*/(0,react.createElement)("span", {
    className: classes.label
  }, getMessage('rowsPerPage')), /*#__PURE__*/(0,react.createElement)(Select/* default */.Z, {
    value: pageSize,
    onChange: function onChange(event) {
      return onPageSizeChange(event.target.value);
    },
    classes: {
      icon: classes.selectIcon
    },
    MenuProps: {
      className: classes.selectMenu
    },
    input: /*#__PURE__*/(0,react.createElement)(Input/* default */.Z, {
      disableUnderline: true,
      classes: {
        root: classes.inputRoot
      }
    })
  }, pageSizes.map(function (item) {
    return /*#__PURE__*/(0,react.createElement)(MenuItem/* default */.Z, {
      key: item,
      value: item
    }, item !== 0 ? item : showAll);
  })));
};

 false ? 0 : void 0;
var PageSizeSelector = (0,withStyles/* default */.Z)(styles$3, {
  name: 'PageSizeSelector'
})(PageSizeSelectorBase);

var styles$4 = function styles(theme) {
  return {
    pagination: {
      margin: 0
    },
    rowsLabel: _objectSpread2(_objectSpread2({}, theme.typography.caption), {}, {
      paddingRight: theme.spacing(5)
    }),
    button: {
      minWidth: theme.spacing(2)
    },
    activeButton: {
      fontWeight: 'bold',
      cursor: 'default'
    },
    arrowButton: {
      display: 'inline-block',
      transform: theme.direction === 'rtl' ? 'rotate(180deg)' : null,
      msTransform: theme.direction === 'rtl' ? 'rotate(180deg)' : null
    },
    prev: {
      marginRight: 0
    },
    next: {
      marginLeft: 0
    },
    '@media(max-width: 768px)': {
      button: {
        display: 'none'
      },
      prev: {
        marginRight: theme.spacing(1)
      },
      next: {
        marginLeft: theme.spacing(1)
      },
      rowsLabel: {
        paddingRight: theme.spacing(2)
      }
    }
  };
};

var PageButton = function PageButton(_ref) {
  var _classNames;

  var text = _ref.text,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      classes = _ref.classes,
      onClick = _ref.onClick;
  var buttonClasses = (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.button, true), _defineProperty(_classNames, classes.activeButton, isActive), _classNames));
  return /*#__PURE__*/(0,react.createElement)(Button/* default */.Z, _extends({
    className: buttonClasses,
    disabled: isDisabled,
    onClick: onClick
  }, isActive ? {
    tabIndex: -1
  } : null), text);
};

 false ? 0 : void 0;
PageButton.defaultProps = {
  onClick: function onClick() {},
  isDisabled: false,
  isActive: false
};
var ellipsisSymbol = "\u2026";

var renderPageButtons = function renderPageButtons(currentPage, totalPageCount, classes, onCurrentPageChange) {
  var pageButtons = [];
  var maxButtonCount = 3;
  var startPage = 1;
  var endPage = totalPageCount || 1; // NOTE: take into account last button and ellipsis (T1004797)

  if (maxButtonCount < totalPageCount - 2) {
    startPage = (0,dx_grid_core_es/* calculateStartPage */.kw6)(currentPage + 1, maxButtonCount, totalPageCount);
    endPage = startPage + maxButtonCount - 1;
  }

  if (startPage > 1) {
    pageButtons.push( /*#__PURE__*/(0,react.createElement)(PageButton, {
      key: 1,
      text: String(1),
      classes: classes,
      onClick: function onClick() {
        return onCurrentPageChange(0);
      }
    }));

    if (startPage > 2) {
      pageButtons.push( /*#__PURE__*/(0,react.createElement)(PageButton, {
        key: "ellipsisStart",
        text: ellipsisSymbol,
        classes: classes,
        isDisabled: true
      }));
    }
  }

  var _loop = function _loop(page) {
    pageButtons.push( /*#__PURE__*/(0,react.createElement)(PageButton, {
      key: page,
      text: String(page),
      isActive: page === currentPage + 1,
      classes: classes,
      onClick: function onClick() {
        return onCurrentPageChange(page - 1);
      },
      isDisabled: startPage === endPage
    }));
  };

  for (var page = startPage; page <= endPage; page += 1) {
    _loop(page);
  }

  if (endPage < totalPageCount) {
    if (endPage < totalPageCount - 1) {
      pageButtons.push( /*#__PURE__*/(0,react.createElement)(PageButton, {
        key: "ellipsisEnd",
        text: ellipsisSymbol,
        classes: classes,
        isDisabled: true
      }));
    }

    pageButtons.push( /*#__PURE__*/(0,react.createElement)(PageButton, {
      key: totalPageCount,
      text: String(totalPageCount),
      classes: classes,
      onClick: function onClick() {
        return onCurrentPageChange(totalPageCount - 1);
      }
    }));
  }

  return pageButtons;
};

var PaginationBase = function PaginationBase(_ref2) {
  var totalPages = _ref2.totalPages,
      totalCount = _ref2.totalCount,
      pageSize = _ref2.pageSize,
      currentPage = _ref2.currentPage,
      onCurrentPageChange = _ref2.onCurrentPageChange,
      getMessage = _ref2.getMessage,
      classes = _ref2.classes;
  var from = (0,dx_grid_core_es/* firstRowOnPage */.dF$)(currentPage, pageSize, totalCount);
  var to = (0,dx_grid_core_es/* lastRowOnPage */.ZN$)(currentPage, pageSize, totalCount);
  return /*#__PURE__*/(0,react.createElement)("div", {
    className: classes.pagination
  }, /*#__PURE__*/(0,react.createElement)("span", {
    className: classes.rowsLabel
  }, getMessage('info', {
    from: from,
    to: to,
    count: totalCount
  })), /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, {
    className: (0,clsx_m/* default */.Z)(classes.arrowButton, classes.prev),
    disabled: currentPage === 0,
    onClick: function onClick() {
      return currentPage > 0 && onCurrentPageChange(currentPage - 1);
    },
    "aria-label": "Previous"
  }, /*#__PURE__*/(0,react.createElement)(ChevronLeft/* default */.Z, null)), renderPageButtons(currentPage, totalPages, classes, onCurrentPageChange), /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, {
    className: (0,clsx_m/* default */.Z)(classes.arrowButton, classes.next),
    disabled: currentPage === totalPages - 1 || totalCount === 0,
    onClick: function onClick() {
      return currentPage < totalPages - 1 && onCurrentPageChange(currentPage + 1);
    },
    "aria-label": "Next"
  }, /*#__PURE__*/(0,react.createElement)(ChevronRight/* default */.Z, null)));
};

 false ? 0 : void 0;
var Pagination = (0,withStyles/* default */.Z)(styles$4, {
  name: 'Pagination'
})(PaginationBase);

var _excluded$8 = ["currentPage", "pageSizes", "totalPages", "pageSize", "classes", "onCurrentPageChange", "onPageSizeChange", "totalCount", "getMessage", "className"];

var styles$5 = function styles(theme) {
  return {
    pager: {
      overflow: 'hidden',
      padding: theme.spacing(1.5),
      display: 'flex',
      flex: 'none',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  };
};

var PagerBase = function PagerBase(_ref) {
  var currentPage = _ref.currentPage,
      pageSizes = _ref.pageSizes,
      totalPages = _ref.totalPages,
      pageSize = _ref.pageSize,
      classes = _ref.classes,
      _onCurrentPageChange = _ref.onCurrentPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      totalCount = _ref.totalCount,
      getMessage = _ref.getMessage,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$8);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.pager, className)
  }, restProps), !!pageSizes.length && /*#__PURE__*/(0,react.createElement)(PageSizeSelector, {
    pageSize: pageSize,
    onPageSizeChange: onPageSizeChange,
    pageSizes: pageSizes,
    getMessage: getMessage
  }), /*#__PURE__*/(0,react.createElement)(Pagination, {
    totalPages: totalPages,
    totalCount: totalCount,
    currentPage: currentPage,
    onCurrentPageChange: function onCurrentPageChange(page) {
      return _onCurrentPageChange(page);
    },
    pageSize: pageSize,
    getMessage: getMessage
  }));
};

 false ? 0 : void 0;
PagerBase.defaultProps = {
  className: undefined
};
var Pager = (0,withStyles/* default */.Z)(styles$5, {
  name: 'Pager'
})(PagerBase);

var _excluded$9 = ["messages"];
var defaultMessages$1 = {
  rowsPerPage: 'Rows per page:'
};
var PagingPanelWithMessages = withPatchedProps(function (_ref) {
  var messages = _ref.messages,
      restProps = _objectWithoutProperties(_ref, _excluded$9);

  return _objectSpread2({
    messages: _objectSpread2(_objectSpread2({}, defaultMessages$1), messages)
  }, restProps);
})(dx_react_grid_es/* PagingPanel */.U6);
PagingPanelWithMessages.propTypes = {
  messages: (0,prop_types.shape)({
    showAll: prop_types.string,
    rowsPerPage: prop_types.string,
    info: (0,prop_types.oneOfType)([prop_types.string, prop_types.func])
  })
};
PagingPanelWithMessages.defaultProps = {
  messages: {}
};
PagingPanelWithMessages.components = dx_react_grid_es/* PagingPanel.components */.U6.components;
var PagingPanel = (0,dx_react_core_es/* withComponents */.we)({
  Container: Pager
})(PagingPanelWithMessages);

var _excluded$a = ["classes", "children", "className"];

var styles$6 = function styles(theme) {
  return {
    panel: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      marginTop: theme.spacing(1.5)
    }
  };
};

var GroupPanelContainerBase = function GroupPanelContainerBase(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$a);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.panel, className)
  }, restProps), children);
};

 false ? 0 : void 0;
GroupPanelContainerBase.defaultProps = {
  children: undefined,
  className: undefined
};
var GroupPanelContainer = (0,withStyles/* default */.Z)(styles$6, {
  name: 'GroupPanelContainer'
})(GroupPanelContainerBase);

var _excluded$b = ["item", "onGroup", "showGroupingControls", "showSortingControls", "sortingDirection", "onSort", "sortingEnabled", "groupingEnabled", "classes", "className"];
var ENTER_KEY_CODE = 13;
var SPACE_KEY_CODE = 32;

var styles$7 = function styles(theme) {
  return {
    button: {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1.5)
    },
    withoutIcon: {
      paddingRight: '13px',
      paddingLeft: '13px'
    },
    draftCell: {
      opacity: 0.3
    }
  };
};

var label = function label(showSortingControls, sortingEnabled, sortingDirection, column, hovered) {
  var title = column.title || column.name;
  return showSortingControls ? /*#__PURE__*/(0,react.createElement)(TableSortLabel_TableSortLabel, {
    active: !!sortingDirection,
    direction: sortingDirection === null ? undefined : sortingDirection,
    disabled: !sortingEnabled,
    hideSortIcon: !hovered,
    tabIndex: -1
  }, title) : title;
};

var GroupPanelItemBase = function GroupPanelItemBase(_ref) {
  var _classNames;

  var _ref$item = _ref.item,
      column = _ref$item.column,
      draft = _ref$item.draft,
      onGroup = _ref.onGroup,
      showGroupingControls = _ref.showGroupingControls,
      showSortingControls = _ref.showSortingControls,
      sortingDirection = _ref.sortingDirection,
      onSort = _ref.onSort,
      sortingEnabled = _ref.sortingEnabled,
      groupingEnabled = _ref.groupingEnabled,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$b);

  var _React$useState = (0,react.useState)(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hovered = _React$useState2[0],
      setHovered = _React$useState2[1];

  var chipClassNames = (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.button, true), _defineProperty(_classNames, classes.withoutIcon, !showSortingControls || !hovered && sortingDirection === null), _defineProperty(_classNames, classes.draftCell, draft), _classNames), className);

  var onClick = function onClick(e) {
    var isActionKeyDown = e.keyCode === ENTER_KEY_CODE || e.keyCode === SPACE_KEY_CODE;
    var isMouseClick = e.keyCode === undefined;
    var cancelSortingRelatedKey = e.metaKey || e.ctrlKey;
    var direction = (isMouseClick || isActionKeyDown) && cancelSortingRelatedKey ? null : undefined;
    onSort({
      direction: direction,
      keepOther: cancelSortingRelatedKey
    });
  };

  return /*#__PURE__*/(0,react.createElement)(Chip/* default */.Z, _extends({
    label: label(showSortingControls, sortingEnabled, sortingDirection, column, hovered),
    className: chipClassNames
  }, showGroupingControls ? {
    onDelete: groupingEnabled ? onGroup : null
  } : null, showSortingControls ? {
    onClick: sortingEnabled ? onClick : null,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  } : null, restProps));
};

 false ? 0 : void 0;
GroupPanelItemBase.defaultProps = {
  showSortingControls: false,
  sortingEnabled: false,
  sortingDirection: undefined,
  onSort: undefined,
  onGroup: undefined,
  showGroupingControls: false,
  groupingEnabled: false,
  className: undefined
};
var GroupPanelItem = (0,withStyles/* default */.Z)(styles$7, {
  name: 'GroupPanelItem'
})(GroupPanelItemBase);

var _excluded$c = ["getMessage", "classes", "className"];

var styles$8 = function styles(theme) {
  return {
    groupInfo: {
      color: theme.typography.caption.color,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize
    }
  };
};

var GroupPanelEmptyMessageBase = function GroupPanelEmptyMessageBase(_ref) {
  var getMessage = _ref.getMessage,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$c);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.groupInfo, className)
  }, restProps), getMessage('groupByColumn'));
};

 false ? 0 : void 0;
GroupPanelEmptyMessageBase.defaultProps = {
  className: undefined
};
var GroupPanelEmptyMessage = (0,withStyles/* default */.Z)(styles$8, {
  name: 'GroupPanelEmptyMessage'
})(GroupPanelEmptyMessageBase);

var GroupingPanel = (0,dx_react_core_es/* withComponents */.we)({
  Container: GroupPanelContainer,
  Item: GroupPanelItem,
  EmptyMessage: GroupPanelEmptyMessage
})(dx_react_grid_es/* GroupingPanel */.dW);

var _excluded$d = ["style", "expanded", "classes", "onToggle", "tableColumn", "tableRow", "row", "className"];

var styles$9 = function styles(theme) {
  return {
    toggleCell: {
      textAlign: 'center',
      textOverflow: 'initial',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: theme.spacing(1)
    },
    toggleCellButton: {
      verticalAlign: 'middle',
      display: 'inline-block',
      padding: theme.spacing(1)
    }
  };
};

var TableDetailToggleCellBase = function TableDetailToggleCellBase(_ref) {
  var style = _ref.style,
      expanded = _ref.expanded,
      classes = _ref.classes,
      onToggle = _ref.onToggle,
      tableColumn = _ref.tableColumn,
      tableRow = _ref.tableRow,
      row = _ref.row,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$d);

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onToggle();
  };

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.toggleCell, className),
    style: style
  }, restProps), /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, {
    className: classes.toggleCellButton,
    onClick: handleClick
  }, expanded ? /*#__PURE__*/(0,react.createElement)(ExpandLess/* default */.Z, null) : /*#__PURE__*/(0,react.createElement)(ExpandMore/* default */.Z, null)));
};

 false ? 0 : void 0;
TableDetailToggleCellBase.defaultProps = {
  style: null,
  expanded: false,
  onToggle: function onToggle() {},
  className: undefined,
  tableColumn: undefined,
  tableRow: undefined,
  row: undefined
};
var TableDetailToggleCell = (0,withStyles/* default */.Z)(styles$9, {
  name: 'TableDetailToggleCell'
})(TableDetailToggleCellBase);

var _excluded$e = ["colSpan", "style", "children", "classes", "className", "tableColumn", "tableRow", "row"];

var styles$a = function styles(theme) {
  return {
    active: {
      backgroundColor: theme.palette.background.default
    }
  };
};

var TableDetailCellBase = function TableDetailCellBase(_ref) {
  var colSpan = _ref.colSpan,
      style = _ref.style,
      children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      tableColumn = _ref.tableColumn,
      tableRow = _ref.tableRow,
      row = _ref.row,
      restProps = _objectWithoutProperties(_ref, _excluded$e);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    style: style,
    colSpan: colSpan,
    className: (0,clsx_m/* default */.Z)(classes.active, className)
  }, restProps), children);
};

 false ? 0 : void 0;
TableDetailCellBase.defaultProps = {
  style: null,
  colSpan: 1,
  className: undefined,
  tableColumn: undefined,
  tableRow: undefined,
  row: undefined,
  children: undefined
};
var TableDetailCell = (0,withStyles/* default */.Z)(styles$a, {
  name: 'TableDetailCell'
})(TableDetailCellBase);

var _excluded$f = ["children", "row", "tableRow"];
var dx_react_grid_material_ui_es_TableRow = function TableRow(_ref) {
  var children = _ref.children,
      row = _ref.row,
      tableRow = _ref.tableRow,
      restProps = _objectWithoutProperties(_ref, _excluded$f);

  return /*#__PURE__*/(0,react.createElement)(TableRow_TableRow, restProps, children);
};
 false ? 0 : void 0;
dx_react_grid_material_ui_es_TableRow.defaultProps = {
  children: undefined,
  row: undefined,
  tableRow: undefined
};

var TableRowDetailWithWidth = function TableRowDetailWithWidth(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* TableRowDetail */.Jd, _extends({
    toggleColumnWidth: 48
  }, props));
};

TableRowDetailWithWidth.components = dx_react_grid_es/* TableRowDetail.components */.Jd.components;
var TableRowDetail = (0,dx_react_core_es/* withComponents */.we)({
  Row: dx_react_grid_material_ui_es_TableRow,
  Cell: TableDetailCell,
  ToggleCell: TableDetailToggleCell
})(TableRowDetailWithWidth);
TableRowDetail.COLUMN_TYPE = dx_react_grid_es/* TableRowDetail.COLUMN_TYPE */.Jd.COLUMN_TYPE;
TableRowDetail.ROW_TYPE = dx_react_grid_es/* TableRowDetail.ROW_TYPE */.Jd.ROW_TYPE;

var _excluded$g = ["contentComponent", "iconComponent", "containerComponent", "inlineSummaryComponent", "inlineSummaryItemComponent", "inlineSummaries", "getMessage", "style", "colSpan", "row", "column", "expanded", "onToggle", "classes", "children", "className", "tableRow", "tableColumn", "side", "position"];

var styles$b = function styles(theme) {
  return {
    cell: {
      cursor: 'pointer',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    },
    cellNoWrap: {
      whiteSpace: 'nowrap'
    }
  };
};

var CellBase = function CellBase(_ref) {
  var _classNames;

  var Content = _ref.contentComponent,
      Icon = _ref.iconComponent,
      Container = _ref.containerComponent,
      InlineSummary = _ref.inlineSummaryComponent,
      InlineSummaryItem = _ref.inlineSummaryItemComponent,
      inlineSummaries = _ref.inlineSummaries,
      getMessage = _ref.getMessage,
      style = _ref.style,
      colSpan = _ref.colSpan,
      row = _ref.row,
      column = _ref.column,
      expanded = _ref.expanded,
      onToggle = _ref.onToggle,
      classes = _ref.classes,
      children = _ref.children,
      className = _ref.className,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      side = _ref.side,
      position = _ref.position,
      restProps = _objectWithoutProperties(_ref, _excluded$g);

  var handleClick = function handleClick() {
    return onToggle();
  };

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    colSpan: colSpan,
    style: style,
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.cell, true), _defineProperty(_classNames, classes.cellNoWrap, !(tableColumn && tableColumn.wordWrapEnabled)), _classNames), className),
    onClick: handleClick
  }, restProps), /*#__PURE__*/(0,react.createElement)(Container, {
    side: side,
    position: position
  }, /*#__PURE__*/(0,react.createElement)(Icon, {
    expanded: expanded
  }), /*#__PURE__*/(0,react.createElement)(Content, {
    column: column,
    row: row
  }, children), inlineSummaries.length ? /*#__PURE__*/(0,react.createElement)(InlineSummary, {
    inlineSummaries: inlineSummaries,
    getMessage: getMessage,
    inlineSummaryItemComponent: InlineSummaryItem
  }) : null));
};

 false ? 0 : void 0;
CellBase.defaultProps = {
  style: null,
  colSpan: 1,
  row: {},
  column: {},
  expanded: false,
  inlineSummaries: [],
  onToggle: function onToggle() {},
  children: undefined,
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  side: 'left',
  position: ''
};
var Cell = (0,withStyles/* default */.Z)(styles$b, {
  name: 'TableGroupCell'
})(CellBase);

var _excluded$h = ["column", "row", "classes", "className", "children"];

var styles$c = function styles() {
  return {
    columnTitle: {
      verticalAlign: 'middle'
    }
  };
};

var ContentBase = function ContentBase(_ref) {
  var column = _ref.column,
      row = _ref.row,
      classes = _ref.classes,
      className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded$h);

  return /*#__PURE__*/(0,react.createElement)("span", _extends({
    className: (0,clsx_m/* default */.Z)(classes.columnTitle, className)
  }, restProps), /*#__PURE__*/(0,react.createElement)("strong", null, column.title || column.name, ":", ' '), children || String(row.value));
};

 false ? 0 : void 0;
ContentBase.defaultProps = {
  row: {},
  column: {},
  children: undefined,
  className: undefined
};
var Content = (0,withStyles/* default */.Z)(styles$c)(ContentBase);

var getBorder = function getBorder(theme) {
  return "1px solid ".concat(theme.palette.type === 'light' ? (0,styles_colorManipulator/* lighten */.$n)((0,styles_colorManipulator/* fade */.U1)(theme.palette.divider, 1), 0.88) : (0,styles_colorManipulator/* darken */._j)((0,styles_colorManipulator/* fade */.U1)(theme.palette.divider, 1), 0.68));
};
var getStickyCellStyle = function getStickyCellStyle(theme) {
  return {
    backgroundColor: theme.palette.background.paper,
    position: 'sticky',
    zIndex: 300,
    backgroundClip: 'padding-box'
  };
};

var _excluded$i = ["children", "style", "classes", "className", "side", "position"];

var styles$d = function styles(theme) {
  return {
    wrapper: _objectSpread2(_objectSpread2({}, getStickyCellStyle(theme)), {}, {
      float: 'left',
      maxWidth: '100%',
      overflowX: 'hidden',
      textOverflow: 'ellipsis'
    })
  };
};

var ContainerBase$1 = function ContainerBase(_ref) {
  var children = _ref.children,
      style = _ref.style,
      classes = _ref.classes,
      className = _ref.className,
      side = _ref.side,
      position = _ref.position,
      restProps = _objectWithoutProperties(_ref, _excluded$i);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.wrapper, className),
    style: _objectSpread2(_objectSpread2({}, style), {}, _defineProperty({}, side, position))
  }, restProps), children);
};

 false ? 0 : void 0;
ContainerBase$1.defaultProps = {
  children: undefined,
  className: undefined,
  style: null,
  side: 'left',
  position: ''
};
var Container$2 = (0,withStyles/* default */.Z)(styles$d)(ContainerBase$1);

var _excluded$j = ["tableRow", "tableColumn", "row", "column", "style", "className", "classes", "position", "side"];

var styles$e = function styles(theme) {
  return {
    indentCell: _objectSpread2(_objectSpread2({}, getStickyCellStyle(theme)), {}, {
      borderBottom: getBorder(theme)
    })
  };
};

var IndentCellBase = function IndentCellBase(_ref) {
  var tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      row = _ref.row,
      column = _ref.column,
      style = _ref.style,
      className = _ref.className,
      classes = _ref.classes,
      position = _ref.position,
      side = _ref.side,
      restProps = _objectWithoutProperties(_ref, _excluded$j);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.indentCell, className),
    style: _objectSpread2(_objectSpread2({}, style), {}, _defineProperty({}, side, position))
  }, restProps));
};

 false ? 0 : void 0;
IndentCellBase.defaultProps = {
  tableRow: undefined,
  tableColumn: undefined,
  row: {},
  column: {},
  style: null,
  className: undefined,
  side: 'left',
  position: undefined
};
var IndentCell = (0,withStyles/* default */.Z)(styles$e)(IndentCellBase);

var _excluded$k = ["expanded", "classes", "className"];

var styles$f = function styles(theme) {
  return {
    groupButton: {
      verticalAlign: 'middle',
      display: 'inline-block',
      padding: theme.spacing(1),
      marginRight: theme.spacing(1)
    }
  };
};

var IconBase = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var expanded = _ref.expanded,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$k);

  return /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, _extends({
    className: (0,clsx_m/* default */.Z)(classes.groupButton, className)
  }, restProps), expanded ? /*#__PURE__*/(0,react.createElement)(ExpandMore/* default */.Z, null) : /*#__PURE__*/(0,react.createElement)(ChevronRight/* default */.Z, null));
});
IconBase.propTypes = {
  expanded: prop_types.bool.isRequired,
  classes: prop_types.object.isRequired,
  className: prop_types.string
};
IconBase.defaultProps = {
  className: undefined
};
var Icon = (0,withStyles/* default */.Z)(styles$f)(IconBase);

var _excluded$l = ["children", "classes", "className"];

var styles$g = function styles() {
  return {
    row: {
      cursor: 'pointer'
    }
  };
};

var RowBase = function RowBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$l);

  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_material_ui_es_TableRow, _extends({}, restProps, {
    className: (0,clsx_m/* default */.Z)(classes.row, className)
  }), children);
};

 false ? 0 : void 0;
RowBase.defaultProps = {
  children: null,
  className: undefined
};
var Row = (0,withStyles/* default */.Z)(styles$g)(RowBase);

var _excluded$m = ["inlineSummaries", "getMessage", "inlineSummaryItemComponent", "classes", "className"];

var styles$h = function styles(theme) {
  return {
    inlineSummary: {
      marginLeft: theme.spacing(1),
      verticalAlign: 'middle'
    }
  };
};

var InlineSummaryBase = function InlineSummaryBase(_ref) {
  var inlineSummaries = _ref.inlineSummaries,
      getMessage = _ref.getMessage,
      InlineSummaryItem = _ref.inlineSummaryItemComponent,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$m);

  return /*#__PURE__*/(0,react.createElement)("span", _extends({
    className: (0,clsx_m/* default */.Z)(classes.inlineSummary, className)
  }, restProps), '(', inlineSummaries.map(function (s) {
    return /*#__PURE__*/(0,react.createElement)(InlineSummaryItem, {
      key: s.type,
      summary: s,
      getMessage: getMessage
    });
  }).reduce(function (acc, summary) {
    return acc.concat(summary, ', ');
  }, []).slice(0, -1), ')');
};

 false ? 0 : void 0;
InlineSummaryBase.defaultProps = {
  className: undefined,
  inlineSummaries: []
};
var InlineSummary = (0,withStyles/* default */.Z)(styles$h)(InlineSummaryBase);

var _excluded$n = ["column", "value", "children", "classes", "tableRow", "tableColumn", "row", "className"];

var styles$i = function styles(theme) {
  return {
    cell: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      '&:first-child': {
        paddingLeft: theme.spacing(3)
      },
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    footer: {
      borderBottom: getBorder(theme)
    },
    cellRightAlign: {
      textAlign: 'right'
    },
    cellCenterAlign: {
      textAlign: 'center'
    },
    cellNoWrap: {
      whiteSpace: 'nowrap'
    }
  };
};

var TableCellBase = function TableCellBase(_ref) {
  var _classNames;

  var column = _ref.column,
      value = _ref.value,
      children = _ref.children,
      classes = _ref.classes,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      row = _ref.row,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$n);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.cell, true), _defineProperty(_classNames, classes.cellRightAlign, tableColumn && tableColumn.align === 'right'), _defineProperty(_classNames, classes.cellCenterAlign, tableColumn && tableColumn.align === 'center'), _defineProperty(_classNames, classes.cellNoWrap, !(tableColumn && tableColumn.wordWrapEnabled)), _classNames), className),
    classes: {
      footer: classes.footer
    }
  }, restProps), children || value);
};

 false ? 0 : void 0;
TableCellBase.defaultProps = {
  value: undefined,
  column: undefined,
  row: undefined,
  children: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  className: undefined
};
var dx_react_grid_material_ui_es_TableCell = (0,withStyles/* default */.Z)(styles$i, {
  name: 'TableCell'
})(TableCellBase);

var _excluded$o = ["onToggle"];
var SummaryCell = function SummaryCell(_ref) {
  var onToggle = _ref.onToggle,
      restProps = _objectWithoutProperties(_ref, _excluded$o);

  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_material_ui_es_TableCell, _extends({}, restProps, {
    onClick: onToggle
  }));
};
 false ? 0 : void 0;
SummaryCell.defaultProps = {
  onToggle: function onToggle() {}
};

var _excluded$p = ["children", "type", "value", "getMessage", "classes", "className"];

var styles$j = function styles(theme) {
  return {
    item: {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(13)
    }
  };
};

var TableSummaryItemBase = function TableSummaryItemBase(_ref) {
  var children = _ref.children,
      type = _ref.type,
      value = _ref.value,
      getMessage = _ref.getMessage,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$p);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(_defineProperty({}, classes.item, true), className)
  }, restProps), /*#__PURE__*/(0,react.createElement)(react.Fragment, null, getMessage(type), ":\xA0\xA0", children));
};

 false ? 0 : void 0;
TableSummaryItemBase.defaultProps = {
  value: null,
  children: undefined,
  className: undefined
};
var TableSummaryItem = (0,withStyles/* default */.Z)(styles$j)(TableSummaryItemBase);

var TableGroupRowWithIndent = function TableGroupRowWithIndent(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* TableGroupRow */.x6, _extends({
    contentCellPadding: "8px",
    indentColumnWidth: 48
  }, props));
};

TableGroupRowWithIndent.components = dx_react_grid_es/* TableGroupRow.components */.x6.components;
var StubCell = SummaryCell;
var TableGroupRow = (0,dx_react_core_es/* withComponents */.we)({
  Row: Row,
  Cell: Cell,
  IndentCell: IndentCell,
  Container: Container$2,
  Content: Content,
  Icon: Icon,
  InlineSummary: InlineSummary,
  InlineSummaryItem: dx_react_grid_es/* InlineSummaryItem */.Ow,
  SummaryCell: SummaryCell,
  SummaryItem: TableSummaryItem,
  StubCell: StubCell
})(TableGroupRowWithIndent);
TableGroupRow.COLUMN_TYPE = dx_react_grid_es/* TableGroupRow.COLUMN_TYPE */.x6.COLUMN_TYPE;
TableGroupRow.ROW_TYPE = dx_react_grid_es/* TableGroupRow.ROW_TYPE */.x6.ROW_TYPE;

var _excluded$q = ["allSelected", "someSelected", "disabled", "onToggle", "classes", "className", "tableRow", "tableColumn", "rowSpan"];

var styles$k = function styles(theme) {
  return {
    cell: {
      overflow: 'visible',
      paddingRight: 0,
      paddingLeft: theme.spacing(1),
      textAlign: 'center'
    },
    checkbox: {
      padding: theme.spacing(1)
    },
    alignWithRowSpan: {
      verticalAlign: 'bottom',
      paddingBottom: theme.spacing(0.5)
    },
    pointer: {
      cursor: 'pointer'
    }
  };
};

var TableSelectAllCellBase = function TableSelectAllCellBase(_ref) {
  var _classNames;

  var allSelected = _ref.allSelected,
      someSelected = _ref.someSelected,
      disabled = _ref.disabled,
      onToggle = _ref.onToggle,
      classes = _ref.classes,
      className = _ref.className,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      rowSpan = _ref.rowSpan,
      restProps = _objectWithoutProperties(_ref, _excluded$q);

  var cellClasses = (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.cell, true), _defineProperty(_classNames, classes.pointer, !disabled), _defineProperty(_classNames, classes.alignWithRowSpan, rowSpan > 1), _classNames), className);
  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    padding: "checkbox",
    className: cellClasses,
    rowSpan: rowSpan
  }, restProps), /*#__PURE__*/(0,react.createElement)(Checkbox/* default */.Z, {
    checked: allSelected,
    className: classes.checkbox,
    indeterminate: someSelected,
    disabled: disabled,
    onClick: function onClick(e) {
      if (disabled) return;
      e.stopPropagation();
      onToggle();
    }
  }));
};

 false ? 0 : void 0;
TableSelectAllCellBase.defaultProps = {
  allSelected: false,
  someSelected: false,
  disabled: false,
  onToggle: function onToggle() {},
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  rowSpan: undefined
};
var TableSelectAllCell = (0,withStyles/* default */.Z)(styles$k, {
  name: 'TableSelectAllCell'
})(TableSelectAllCellBase);

var _excluded$r = ["style", "selected", "onToggle", "classes", "className", "row", "tableRow", "tableColumn"];

var styles$l = function styles(theme) {
  return {
    cell: {
      overflow: 'visible',
      paddingRight: 0,
      paddingLeft: theme.spacing(1),
      textAlign: 'center'
    },
    checkbox: {
      marginTop: '-1px',
      marginBottom: '-1px',
      padding: theme.spacing(1)
    }
  };
};

var TableSelectCellBase = function TableSelectCellBase(_ref) {
  var style = _ref.style,
      selected = _ref.selected,
      onToggle = _ref.onToggle,
      classes = _ref.classes,
      className = _ref.className,
      row = _ref.row,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      restProps = _objectWithoutProperties(_ref, _excluded$r);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    padding: "checkbox",
    style: style,
    className: (0,clsx_m/* default */.Z)(classes.cell, className)
  }, restProps), /*#__PURE__*/(0,react.createElement)(Checkbox/* default */.Z, {
    className: classes.checkbox,
    checked: selected,
    onClick: function onClick(e) {
      e.stopPropagation();
      onToggle();
    }
  }));
};
 false ? 0 : void 0;
TableSelectCellBase.defaultProps = {
  style: null,
  selected: false,
  onToggle: function onToggle() {},
  row: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  className: undefined
};
var TableSelectCell = (0,withStyles/* default */.Z)(styles$l, {
  name: 'TableSelectCell'
})(TableSelectCellBase);

var getSelectionColor = (function (theme) {
  return theme.palette.type === 'light' ? (0,styles_colorManipulator/* lighten */.$n)((0,styles_colorManipulator/* fade */.U1)(theme.palette.action.selected, 1), 0.96) : (0,styles_colorManipulator/* darken */._j)((0,styles_colorManipulator/* fade */.U1)(theme.palette.action.selected, 1), 0.68);
});

var _excluded$s = ["children", "classes", "className", "onToggle", "row", "selectByRowClick", "highlighted", "tableColumn", "tableRow"];

var styles$m = function styles(theme) {
  return {
    selected: {
      backgroundColor: getSelectionColor(theme)
    }
  };
};

var TableSelectRowBase = function TableSelectRowBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      onToggle = _ref.onToggle,
      row = _ref.row,
      selectByRowClick = _ref.selectByRowClick,
      highlighted = _ref.highlighted,
      tableColumn = _ref.tableColumn,
      tableRow = _ref.tableRow,
      restProps = _objectWithoutProperties(_ref, _excluded$s);

  return /*#__PURE__*/(0,react.createElement)(TableRow_TableRow, _extends({
    className: (0,clsx_m/* default */.Z)(_defineProperty({}, classes.selected, highlighted), className),
    onClick: function onClick(e) {
      if (!selectByRowClick) return;
      e.stopPropagation();
      onToggle();
    }
  }, restProps), children);
};

 false ? 0 : void 0;
TableSelectRowBase.defaultProps = {
  children: undefined,
  className: undefined,
  onToggle: function onToggle() {},
  row: undefined,
  selectByRowClick: false,
  highlighted: false,
  tableColumn: undefined,
  tableRow: undefined
};
var TableSelectRow = (0,withStyles/* default */.Z)(styles$m, {
  name: 'TableSelectRow'
})(TableSelectRowBase);

var TableSelectionWithWidth = function TableSelectionWithWidth(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* TableSelection */.vN, _extends({
    selectionColumnWidth: 58
  }, props));
};

TableSelectionWithWidth.components = dx_react_grid_es/* TableSelection.components */.vN.components;
var TableSelection = (0,dx_react_core_es/* withComponents */.we)({
  Row: TableSelectRow,
  Cell: TableSelectCell,
  HeaderCell: TableSelectAllCell
})(TableSelectionWithWidth);
TableSelection.COLUMN_TYPE = dx_react_grid_es/* TableSelection.COLUMN_TYPE */.vN.COLUMN_TYPE;

var _excluded$t = ["children", "classes", "className", "use", "tableRef"];

var styles$n = function styles(theme) {
  return {
    table: {
      tableLayout: 'fixed',
      borderCollapse: 'separate'
    },
    stickyTable: {
      position: 'sticky',
      zIndex: 500,
      overflow: 'visible',
      background: theme.palette.background.paper,
      fallbacks: {
        position: '-webkit-sticky'
      }
    },
    headTable: {
      top: 0
    },
    footTable: {
      borderTop: getBorder(theme),
      bottom: 0
    }
  };
};

var TableBase = function TableBase(_ref) {
  var _classNames;

  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      use = _ref.use,
      tableRef = _ref.tableRef,
      restProps = _objectWithoutProperties(_ref, _excluded$t);

  return /*#__PURE__*/(0,react.createElement)(Table_Table, _extends({
    ref: tableRef,
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.table, true), _defineProperty(_classNames, classes.stickyTable, !!use), _defineProperty(_classNames, classes.headTable, use === 'head'), _defineProperty(_classNames, classes.footTable, use === 'foot'), _classNames), className)
  }, restProps), children);
};

 false ? 0 : void 0;
TableBase.defaultProps = {
  use: undefined,
  className: undefined
};
var dx_react_grid_material_ui_es_Table = (0,withStyles/* default */.Z)(styles$n, {
  name: 'Table'
})(TableBase);

var MINIMAL_COLUMN_WIDTH = 120;
var TableLayout = function TableLayout(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* TableLayout */.df, _extends({
    layoutComponent: dx_react_grid_es/* StaticTableLayout */.RS,
    minColumnWidth: MINIMAL_COLUMN_WIDTH
  }, props));
};

var _excluded$u = ["classes", "className", "tableRow", "tableColumn"];

var styles$o = function styles(theme) {
  return {
    cell: {
      padding: 0
    },
    footer: {
      borderBottom: getBorder(theme)
    }
  };
};

var TableStubCellBase = function TableStubCellBase(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      restProps = _objectWithoutProperties(_ref, _excluded$u);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.cell, className),
    classes: {
      footer: classes.footer
    }
  }, restProps));
};

 false ? 0 : void 0;
TableStubCellBase.defaultProps = {
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined
};
var TableStubCell = (0,withStyles/* default */.Z)(styles$o, {
  name: 'TableStubCell'
})(TableStubCellBase);

var _excluded$v = ["style", "colSpan", "getMessage", "classes", "className", "tableRow", "tableColumn"];

var styles$p = function styles(theme) {
  return {
    cell: {
      padding: theme.spacing(6, 0),
      position: 'static !important'
    },
    textContainer: {
      display: 'inline-block',
      position: 'sticky',
      left: '50%'
    },
    text: {
      transform: 'translateX(-50%)',
      msTransform: 'translateX(-50%)',
      display: 'inline-block'
    }
  };
};

var TableNoDataCellBase = function TableNoDataCellBase(_ref) {
  var style = _ref.style,
      colSpan = _ref.colSpan,
      getMessage = _ref.getMessage,
      classes = _ref.classes,
      className = _ref.className,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      restProps = _objectWithoutProperties(_ref, _excluded$v);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    style: style,
    className: (0,clsx_m/* default */.Z)(classes.cell, className),
    colSpan: colSpan
  }, restProps), /*#__PURE__*/(0,react.createElement)("div", {
    className: classes.textContainer
  }, /*#__PURE__*/(0,react.createElement)("big", {
    className: classes.text
  }, getMessage('noData'))));
};
 false ? 0 : void 0;
TableNoDataCellBase.defaultProps = {
  style: null,
  colSpan: 1,
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined
};
var TableNoDataCell = (0,withStyles/* default */.Z)(styles$p, {
  name: 'TableNoDataCell'
})(TableNoDataCellBase);

var _excluded$w = ["children", "classes", "className"];
var styles$q = {
  root: {
    flexGrow: 1,
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    // NOTE: fix sticky positioning in Safari
    width: '100%'
  }
};

var TableContainerBase = function TableContainerBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$w);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, restProps), /*#__PURE__*/(0,react.createElement)("div", null, children));
};

 false ? 0 : void 0;
TableContainerBase.defaultProps = {
  className: undefined
};
var TableContainer = (0,withStyles/* default */.Z)(styles$q, {
  name: 'TableContainer'
})(TableContainerBase);

var _excluded$x = ["children", "tableRow"];
var TableStubRow = function TableStubRow(_ref) {
  var children = _ref.children,
      tableRow = _ref.tableRow,
      restProps = _objectWithoutProperties(_ref, _excluded$x);

  return /*#__PURE__*/(0,react.createElement)(TableRow_TableRow, restProps, children);
};
 false ? 0 : void 0;
TableStubRow.defaultProps = {
  children: undefined,
  tableRow: undefined
};

var Table$1 = (0,dx_react_core_es/* withComponents */.we)({
  Table: dx_react_grid_material_ui_es_Table,
  TableHead: TableHead_TableHead,
  TableBody: TableBody_TableBody,
  TableFooter: TableFooter_TableFooter,
  Container: TableContainer,
  Layout: TableLayout,
  Row: dx_react_grid_material_ui_es_TableRow,
  Cell: dx_react_grid_material_ui_es_TableCell,
  NoDataRow: dx_react_grid_material_ui_es_TableRow,
  NoDataCell: TableNoDataCell,
  StubRow: TableStubRow,
  StubCell: TableStubCell,
  StubHeaderCell: TableStubCell
})(dx_react_grid_es/* Table */.cO);
Table$1.components = dx_react_grid_es/* Table.components */.cO.components;
Table$1.COLUMN_TYPE = dx_react_grid_es/* Table.COLUMN_TYPE */.cO.COLUMN_TYPE;
Table$1.ROW_TYPE = dx_react_grid_es/* Table.ROW_TYPE */.cO.ROW_TYPE;
Table$1.NODATA_ROW_TYPE = dx_react_grid_es/* Table.NODATA_ROW_TYPE */.cO.NODATA_ROW_TYPE;

var _excluded$y = ["classes", "className", "tableRow", "tableColumn"];

var styles$r = function styles(theme) {
  return {
    cell: {
      padding: theme.spacing(1),
      backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAACqCAYAAABbAOqQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA39pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjYWQ2ODE5MS00ZDMxLWRjNGYtOTU0NC1jNjJkMTIxMjY2M2IiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjY1RUVFQzAzRDYzMTFFODlFNThCOUJBQjU4Q0EzRDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjY1RUVFQkYzRDYzMTFFODlFNThCOUJBQjU4Q0EzRDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVlMjM1Y2U0LTc5ZWUtNGI0NC05ZjlkLTk2NTZmZGFjNjhhNCIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjk1OTQ2MjBiLTUyMTQtYTM0Yy04Nzc5LTEwMmEyMTY4MTlhOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvLbJKYAAADrSURBVHja7N3BDYBACABBsQn7L48q0BoMD5SZxAZuc74gF1V1MMfpCARBEEEQRBAEEQRBdovnuxxDq3RD/LIQRBAEQRBBEEQQBBEEQQQBAAAAAAAAABhi8gZVbgxi6kQQBBEEQQRBEEEQRBAEQRBBAAAAAAAAAAAabX2Daux2lqkTQRBEEAQRBEEEQRBBEARBBAEAAAAAAAAAaLR1g2osUyeCIIggCCIIggiCIIIgCIIIAgAAAAAAAADQ6KsbVPnXIKZOBEEQQRBEEAQRBEEEQRAEEYRXoqqcghuCIIIgiCAIIgiCCMIUtwADALYCCr92l++TAAAAAElFTkSuQmCC)',
      backgroundRepeat: 'no-repeat repeat',
      backgroundOrigin: 'content-box'
    }
  };
};

var TableSkeletonCellBase = function TableSkeletonCellBase(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      restProps = _objectWithoutProperties(_ref, _excluded$y);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.cell, className)
  }, restProps));
};

 false ? 0 : void 0;
TableSkeletonCellBase.defaultProps = {
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined
};
var TableSkeletonCell = (0,withStyles/* default */.Z)(styles$r, {
  name: 'TableSkeletonCell'
})(TableSkeletonCellBase);

var MINIMAL_COLUMN_WIDTH$1 = 120;
var VirtualTableLayout = function VirtualTableLayout(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* TableLayout */.df, _extends({
    layoutComponent: dx_react_grid_es/* VirtualTableLayout */.Gr,
    minColumnWidth: MINIMAL_COLUMN_WIDTH$1
  }, props));
};

var FixedHeader = function FixedHeader(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_material_ui_es_Table, _extends({
    use: "head"
  }, props));
};

var FixedFooter = function FixedFooter(props) {
  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_material_ui_es_Table, _extends({
    use: "foot"
  }, props));
};

var VirtualTable = (0,dx_react_grid_es/* makeVirtualTable */.q3)(Table$1, {
  VirtualLayout: VirtualTableLayout,
  FixedHeader: FixedHeader,
  FixedFooter: FixedFooter,
  SkeletonCell: TableSkeletonCell,
  defaultEstimatedRowHeight: 53,
  defaultHeight: 530
});
VirtualTable.COLUMN_TYPE = Table$1.COLUMN_TYPE;
VirtualTable.ROW_TYPE = Table$1.ROW_TYPE;
VirtualTable.NODATA_ROW_TYPE = Table$1.NODATA_ROW_TYPE;

var _excluded$z = ["filter", "getMessage", "onFilter", "classes", "children", "className", "tableRow", "tableColumn", "column", "filteringEnabled"];

var styles$s = function styles(_ref) {
  var spacing = _ref.spacing;
  return {
    cell: {
      padding: 0,
      '&:first-child': {
        paddingLeft: spacing(3)
      }
    },
    flexContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  };
};

var TableFilterCellBase = function TableFilterCellBase(_ref2) {
  var filter = _ref2.filter,
      getMessage = _ref2.getMessage,
      onFilter = _ref2.onFilter,
      classes = _ref2.classes,
      children = _ref2.children,
      className = _ref2.className,
      tableRow = _ref2.tableRow,
      tableColumn = _ref2.tableColumn,
      column = _ref2.column,
      filteringEnabled = _ref2.filteringEnabled,
      restProps = _objectWithoutProperties(_ref2, _excluded$z);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.cell, className)
  }, restProps), /*#__PURE__*/(0,react.createElement)("div", {
    className: classes.flexContainer
  }, children));
};

 false ? 0 : void 0;
TableFilterCellBase.defaultProps = {
  filter: null,
  onFilter: function onFilter() {},
  children: undefined,
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  column: undefined,
  filteringEnabled: true
};
var TableFilterCell = (0,withStyles/* default */.Z)(styles$s, {
  name: 'TableFilterCell'
})(TableFilterCellBase);

var _excluded$A = ["value", "disabled", "getMessage", "onChange", "classes"];

var styles$t = function styles(theme) {
  return {
    input: {
      width: '100%',
      fontSize: '14px'
    },
    root: {
      margin: theme.spacing(1)
    }
  };
};

var EditorBase = function EditorBase(_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      getMessage = _ref.getMessage,
      _onChange = _ref.onChange,
      classes = _ref.classes,
      restProps = _objectWithoutProperties(_ref, _excluded$A);

  return /*#__PURE__*/(0,react.createElement)(Input/* default */.Z, _extends({
    classes: {
      input: classes.input,
      root: classes.root
    },
    fullWidth: true,
    disabled: disabled,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    placeholder: getMessage('filterPlaceholder')
  }, restProps));
};

 false ? 0 : void 0;
EditorBase.defaultProps = {
  value: '',
  disabled: false,
  onChange: function onChange() {}
};
var Editor = (0,withStyles/* default */.Z)(styles$t, {
  name: 'Editor'
})(EditorBase);

var styles$u = function styles(_ref) {
  var spacing = _ref.spacing;
  return {
    icon: {
      marginRight: spacing(1)
    },
    iconItem: {
      minWidth: spacing(2)
    },
    selectMenu: {
      position: 'absolute !important'
    }
  };
};

var FilterSelectorBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FilterSelectorBase, _React$PureComponent);

  var _super = _createSuper(FilterSelectorBase);

  function FilterSelectorBase(props) {
    var _this;

    _classCallCheck(this, FilterSelectorBase);

    _this = _super.call(this, props);
    _this.state = {
      opened: false
    };

    _this.setButtonRef = function (buttonRef) {
      _this.buttonRef = buttonRef;
    };

    _this.handleButtonClick = function () {
      _this.setState(function (prevState) {
        return {
          opened: !prevState.opened
        };
      });
    };

    _this.handleMenuClose = function () {
      _this.setState({
        opened: false
      });
    };

    _this.handleMenuItemClick = function (nextValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        opened: false
      });

      onChange(nextValue);
    };

    return _this;
  }

  _createClass(FilterSelectorBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          availableValues = _this$props.availableValues,
          disabled = _this$props.disabled,
          getMessage = _this$props.getMessage,
          Icon = _this$props.iconComponent,
          ToggleButton = _this$props.toggleButtonComponent,
          classes = _this$props.classes;
      var opened = this.state.opened;
      return availableValues.length ? /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(ToggleButton, {
        buttonRef: this.setButtonRef,
        onToggle: this.handleButtonClick,
        disabled: disabled || availableValues.length === 1
      }, /*#__PURE__*/(0,react.createElement)(Icon, {
        type: value
      })), /*#__PURE__*/(0,react.createElement)(Menu_Menu/* default */.Z, {
        anchorEl: this.buttonRef,
        open: opened,
        onClose: this.handleMenuClose,
        MenuListProps: {
          dense: true
        },
        className: classes.selectMenu
      }, availableValues.map(function (valueItem) {
        return /*#__PURE__*/(0,react.createElement)(MenuItem/* default */.Z, {
          key: valueItem,
          selected: valueItem === value,
          onClick: function onClick() {
            return _this2.handleMenuItemClick(valueItem);
          }
        }, /*#__PURE__*/(0,react.createElement)(ListItemIcon/* default */.Z, {
          className: classes.iconItem
        }, /*#__PURE__*/(0,react.createElement)(Icon, {
          type: valueItem,
          className: classes.icon,
          fontSize: "small"
        })), /*#__PURE__*/(0,react.createElement)(ListItemText/* default */.Z, null, getMessage(valueItem)));
      }))) : null;
    }
  }]);

  return FilterSelectorBase;
}(react.PureComponent);

 false ? 0 : void 0;
FilterSelectorBase.defaultProps = {
  value: undefined,
  availableValues: [],
  onChange: function onChange() {},
  disabled: false
};
var FilterSelector = (0,withStyles/* default */.Z)(styles$u, {
  name: 'FilterSelector'
})(FilterSelectorBase);

var _excluded$B = ["buttonRef", "onToggle", "disabled", "children"];
var ToggleButton$1 = function ToggleButton(_ref) {
  var buttonRef = _ref.buttonRef,
      onToggle = _ref.onToggle,
      disabled = _ref.disabled,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded$B);

  return /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, _extends({
    buttonRef: buttonRef,
    onClick: onToggle,
    disabled: disabled
  }, restProps), children);
};
 false ? 0 : void 0;
ToggleButton$1.defaultProps = {
  children: undefined,
  disabled: false
};

var _excluded$C = ["type"];
var AVAILABLE_PATHS = {
  contains: 'M6.094 19.563l-2.031 0.281c-0.646 0.094-1.13 0.266-1.453 0.516-0.302 0.24-0.453 0.646-0.453 1.219 0 0.438 0.138 0.799 0.414 1.086s0.664 0.419 1.164 0.398c0.708 0 1.281-0.24 1.719-0.719 0.427-0.49 0.641-1.125 0.641-1.906v-0.875zM8.234 24.641h-2.172v-1.641c-0.677 1.24-1.661 1.859-2.953 1.859-0.927 0-1.682-0.276-2.266-0.828-0.552-0.552-0.828-1.292-0.828-2.219 0-1.927 1.068-3.052 3.203-3.375l2.875-0.438c0-1.469-0.656-2.203-1.969-2.203-1.177 0-2.224 0.427-3.141 1.281v-2.078c1.010-0.656 2.198-0.984 3.563-0.984 2.458 0 3.687 1.302 3.687 3.906v6.719zM14.734 16.797c0.521-0.583 1.167-0.875 1.938-0.875 0.74 0 1.323 0.281 1.75 0.844 0.448 0.583 0.672 1.38 0.672 2.391 0 1.188-0.24 2.13-0.719 2.828-0.49 0.677-1.13 1.016-1.922 1.016-0.719 0-1.302-0.271-1.75-0.813-0.427-0.51-0.641-1.141-0.641-1.891v-1.266c-0.021-0.906 0.203-1.651 0.672-2.234zM16.969 24.859c1.375 0 2.443-0.521 3.203-1.562 0.781-1.042 1.172-2.427 1.172-4.156 0-1.542-0.354-2.771-1.063-3.688-0.688-0.958-1.651-1.438-2.891-1.438-1.427 0-2.531 0.693-3.313 2.078v-6.781h-2.156v15.328h2.172v-1.5c0.677 1.146 1.635 1.719 2.875 1.719zM22.266 6.125c0.135 0 0.245 0.063 0.328 0.188 0.104 0.073 0.156 0.182 0.156 0.328v22.953c0 0.125-0.052 0.24-0.156 0.344-0.083 0.115-0.193 0.172-0.328 0.172h-12.281c-0.146 0-0.266-0.057-0.359-0.172-0.115-0.115-0.172-0.229-0.172-0.344v-22.953c0-0.135 0.057-0.245 0.172-0.328 0.094-0.125 0.214-0.188 0.359-0.188h12.281zM31.531 24.141c-0.76 0.479-1.693 0.719-2.797 0.719-1.427 0-2.589-0.479-3.484-1.438-0.865-0.958-1.286-2.198-1.266-3.719 0-1.688 0.448-3.052 1.344-4.094 0.917-1.042 2.208-1.573 3.875-1.594 0.854 0 1.63 0.177 2.328 0.531v2.156c-0.677-0.531-1.391-0.792-2.141-0.781-0.938 0-1.714 0.339-2.328 1.016-0.594 0.677-0.891 1.552-0.891 2.625 0 1.042 0.297 1.88 0.891 2.516 0.521 0.615 1.25 0.922 2.188 0.922 0.813 0 1.573-0.297 2.281-0.891v2.031z',
  notContains: 'M5.828 20.469v0.328c0 0.385-0.057 0.667-0.172 0.844-0.052 0.083-0.117 0.177-0.195 0.281s-0.174 0.224-0.289 0.359c-0.458 0.521-1.031 0.771-1.719 0.75-0.521 0-0.927-0.141-1.219-0.422-0.292-0.292-0.438-0.661-0.438-1.109 0-0.156 0.010-0.273 0.031-0.352s0.052-0.141 0.094-0.188 0.094-0.086 0.156-0.117 0.141-0.078 0.234-0.141c0.031-0.031 0.078-0.070 0.141-0.117s0.146-0.086 0.25-0.117h3.125zM14.016 18.328c0.010-0.406 0.070-0.729 0.18-0.969s0.289-0.49 0.539-0.75c0.479-0.604 1.13-0.906 1.953-0.906 0.75 0 1.344 0.292 1.781 0.875 0.198 0.25 0.349 0.495 0.453 0.734s0.172 0.578 0.203 1.016h-5.109zM19.078 20.469c-0.063 0.427-0.146 0.708-0.25 0.844-0.052 0.073-0.109 0.159-0.172 0.258l-0.219 0.352c-0.469 0.688-1.135 1.031-2 1.031-0.708 0-1.297-0.271-1.766-0.813l-0.305-0.359c-0.089-0.104-0.159-0.198-0.211-0.281-0.104-0.167-0.156-0.448-0.156-0.844v-0.188h5.078zM33.344 18.328l-6.875 0c0.031-0.198 0.070-0.372 0.117-0.523s0.107-0.284 0.18-0.398 0.154-0.224 0.242-0.328l0.305-0.344c0.604-0.688 1.391-1.031 2.359-1.031 0.771 0 1.51 0.266 2.219 0.797v-2.234c-0.75-0.333-1.552-0.5-2.406-0.5-1.667 0-2.974 0.531-3.922 1.594-0.396 0.427-0.708 0.859-0.938 1.297s-0.385 0.995-0.469 1.672h-2.719c-0.021-0.719-0.117-1.31-0.289-1.773s-0.424-0.914-0.758-1.352c-0.729-0.938-1.719-1.417-2.969-1.438-1.479 0-2.615 0.708-3.406 2.125v-6.953h-2.266v9.391h-3.75v-0.594c0-2.646-1.25-3.969-3.75-3.969-1.365 0-2.583 0.328-3.656 0.984v2.125c0.99-0.865 2.063-1.297 3.219-1.297 1.344 0 2.016 0.75 2.016 2.25l-2.953 0.125c-0.25 0.021-0.487 0.070-0.711 0.148l-0.633 0.227h-3.328v2.141h1.828l-0.281 0.594c-0.073 0.135-0.109 0.37-0.109 0.703 0 0.938 0.276 1.682 0.828 2.234 0.542 0.573 1.313 0.859 2.313 0.859 1.281 0 2.297-0.635 3.047-1.906v1.656h2.172v-4.141h3.75v4.141h2.297v-1.516c0.677 1.188 1.661 1.776 2.953 1.766 1.385 0 2.464-0.531 3.234-1.594 0.302-0.385 0.557-0.792 0.766-1.219 0.198-0.385 0.339-0.911 0.422-1.578h2.703c0.021 0.708 0.141 1.25 0.359 1.625 0.115 0.198 0.253 0.401 0.414 0.609s0.346 0.427 0.555 0.656c0.906 1 2.099 1.5 3.578 1.5 1.104 0 2.057-0.245 2.859-0.734v-2.109c-0.75 0.604-1.526 0.917-2.328 0.938-0.979 0-1.74-0.318-2.281-0.953l-0.328-0.328c-0.094-0.094-0.177-0.195-0.25-0.305s-0.13-0.234-0.172-0.375-0.073-0.315-0.094-0.523h6.906v-2.141zM33.297 5.688c0.146 0 0.266 0.047 0.359 0.141 0.104 0.104 0.156 0.229 0.156 0.375v23.484c0 0.135-0.052 0.255-0.156 0.359-0.094 0.115-0.214 0.172-0.359 0.172h-35.078c-0.135 0-0.26-0.057-0.375-0.172-0.094-0.115-0.135-0.234-0.125-0.359v-23.484c0-0.104 0.042-0.229 0.125-0.375 0.104-0.094 0.229-0.141 0.375-0.141h35.078z',
  startsWith: 'M6.109 20.688c0 0.813-0.219 1.474-0.656 1.984-0.448 0.531-1.010 0.786-1.688 0.766-0.51 0-0.896-0.141-1.156-0.422-0.302-0.292-0.443-0.667-0.422-1.125 0-0.615 0.151-1.042 0.453-1.281 0.177-0.135 0.378-0.245 0.602-0.328s0.497-0.146 0.82-0.188l2.047-0.313v0.906zM8.203 18.063c0-2.688-1.219-4.031-3.656-4.031-1.333 0-2.51 0.339-3.531 1.016v2.141c0.917-0.885 1.948-1.328 3.094-1.328 1.333 0 2 0.766 2 2.297l-2.891 0.453c-2.115 0.333-3.161 1.516-3.141 3.547 0 0.958 0.266 1.724 0.797 2.297 0.542 0.573 1.292 0.859 2.25 0.859 1.292 0 2.26-0.641 2.906-1.922v1.688h2.172v-7.016zM14.703 16.906c0.479-0.604 1.109-0.906 1.891-0.906 0.76 0 1.344 0.297 1.75 0.891 0.438 0.615 0.656 1.443 0.656 2.484 0 1.219-0.229 2.198-0.688 2.938-0.469 0.719-1.109 1.078-1.922 1.078-0.719 0-1.286-0.281-1.703-0.844-0.448-0.542-0.672-1.208-0.672-2v-1.313c-0.010-0.938 0.219-1.714 0.688-2.328zM16.906 25.313c1.365 0 2.422-0.542 3.172-1.625 0.771-1.115 1.156-2.563 1.156-4.344 0-1.604-0.339-2.885-1.016-3.844-0.698-0.979-1.661-1.469-2.891-1.469-1.438 0-2.531 0.719-3.281 2.156v-7.078h-2.188v15.969h2.172v-1.563c0.667 1.198 1.625 1.797 2.875 1.797zM31.375 24.563c-0.75 0.5-1.672 0.75-2.766 0.75-1.427 0-2.583-0.505-3.469-1.516-0.885-0.969-1.318-2.26-1.297-3.875 0-1.74 0.464-3.161 1.391-4.266 0.927-1.063 2.198-1.604 3.813-1.625 0.844 0 1.62 0.172 2.328 0.516v2.25c-0.688-0.563-1.406-0.828-2.156-0.797-0.927 0-1.688 0.349-2.281 1.047-0.583 0.698-0.875 1.609-0.875 2.734 0 1.094 0.281 1.969 0.844 2.625 0.542 0.656 1.286 0.984 2.234 0.984 0.781 0 1.526-0.323 2.234-0.969v2.141zM22.172 5.844c0.115 0 0.224 0.052 0.328 0.156 0.094 0.125 0.141 0.25 0.141 0.375v23.844c0 0.156-0.047 0.286-0.141 0.391-0.115 0.094-0.224 0.141-0.328 0.141h-23.469c-0.125 0-0.24-0.047-0.344-0.141-0.094-0.104-0.141-0.234-0.141-0.391v-23.844c0-0.125 0.047-0.25 0.141-0.375 0.104-0.104 0.219-0.156 0.344-0.156h23.469z',
  endsWith: 'M6.234 19.344l-2.047 0.313c-0.625 0.083-1.104 0.26-1.438 0.531-0.302 0.24-0.453 0.651-0.453 1.234 0 0.469 0.141 0.852 0.422 1.148s0.672 0.435 1.172 0.414c0.677 0 1.234-0.25 1.672-0.75 0.448-0.51 0.672-1.167 0.672-1.969v-0.922zM8.359 24.578h-2.141v-1.656c-0.667 1.26-1.656 1.891-2.969 1.891-0.938 0-1.698-0.276-2.281-0.828-0.542-0.573-0.813-1.328-0.813-2.266 0-2.021 1.063-3.188 3.188-3.5l2.891-0.484c0-1.51-0.661-2.266-1.984-2.266-1.167 0-2.214 0.443-3.141 1.328v-2.125c1.042-0.677 2.224-1.016 3.547-1.016 2.469 0 3.703 1.333 3.703 4v6.922zM14.906 16.516c0.49-0.615 1.13-0.922 1.922-0.922 0.76 0 1.339 0.297 1.734 0.891 0.438 0.615 0.656 1.438 0.656 2.469 0 1.208-0.229 2.182-0.688 2.922-0.469 0.698-1.115 1.047-1.938 1.047-0.708 0-1.276-0.276-1.703-0.828-0.458-0.552-0.688-1.214-0.688-1.984v-1.281c-0.010-0.948 0.224-1.719 0.703-2.313zM17.125 24.813c1.354 0 2.417-0.531 3.188-1.594 0.781-1.073 1.172-2.505 1.172-4.297 0-1.604-0.349-2.87-1.047-3.797-0.698-0.979-1.661-1.469-2.891-1.469-1.438 0-2.542 0.714-3.313 2.141v-7h-2.203v15.781h2.188v-1.531c0.677 1.177 1.646 1.766 2.906 1.766zM31.688 21.969c-0.698 0.635-1.453 0.953-2.266 0.953-0.958 0-1.703-0.323-2.234-0.969-0.563-0.667-0.849-1.536-0.859-2.609 0-1.115 0.297-2.016 0.891-2.703 0.594-0.698 1.359-1.047 2.297-1.047 0.76 0 1.484 0.266 2.172 0.797v-2.219c-0.708-0.344-1.49-0.516-2.344-0.516-1.625 0-2.906 0.536-3.844 1.609-0.938 1.083-1.406 2.495-1.406 4.234 0 1.594 0.438 2.875 1.313 3.844 0.885 0.979 2.052 1.469 3.5 1.469 1.083 0 2.010-0.245 2.781-0.734v-2.109zM33.188 5.563c0.104 0 0.219 0.047 0.344 0.141 0.094 0.146 0.141 0.276 0.141 0.391v23.578c0 0.146-0.047 0.281-0.141 0.406-0.125 0.094-0.24 0.141-0.344 0.141h-23.625c-0.125 0-0.24-0.047-0.344-0.141-0.094-0.135-0.135-0.271-0.125-0.406v-23.578c0-0.115 0.042-0.245 0.125-0.391 0.094-0.094 0.208-0.141 0.344-0.141h23.625z',
  equal: 'M29.438 11.797v2.75h-26.922v-2.75h26.922zM29.438 17.406v2.75h-26.922v-2.75h26.922z',
  notEqual: 'M16.906 11.797l3.016-6.547 2.094 1-2.547 5.547h9.969v2.75h-11.234l-1.328 2.859h12.563v2.75h-13.828l-2.875 6.281-2.094-0.984 2.438-5.297h-10.563v-2.75h11.828l1.297-2.859h-13.125v-2.75h14.391z',
  greaterThan: 'M24.125 16.047l-14.906 8.625-1.375-2.375 10.781-6.25-10.781-6.234 1.375-2.375z',
  greaterThanOrEqual: 'M23.031 14.328l-14.906 8.625-1.375-2.375 10.797-6.25-10.797-6.234 1.375-2.375zM23.828 15.641l1.375 2.391-14.938 8.609-1.375-2.375z',
  lessThan: 'M22.75 7.438l1.375 2.375-10.781 6.234 10.781 6.25-1.375 2.375-14.906-8.609z',
  lessThanOrEqual: 'M23.828 5.719l1.375 2.375-10.813 6.234 10.813 6.25-1.375 2.375-14.922-8.609zM23.047 24.266l-1.375 2.375-14.922-8.609 1.375-2.391z'
};
var Icon$1 = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var type = _ref.type,
      restProps = _objectWithoutProperties(_ref, _excluded$C);

  var path = AVAILABLE_PATHS[type];
  return path ? /*#__PURE__*/(0,react.createElement)(SvgIcon/* default */.Z, _extends({
    viewBox: "0 0 32 32",
    fontSize: "small"
  }, restProps), /*#__PURE__*/(0,react.createElement)("path", {
    d: path
  })) : /*#__PURE__*/(0,react.createElement)(Search/* default */.Z, restProps);
});
 false ? 0 : void 0;
Icon$1.defaultProps = {
  type: undefined
};

var TableFilterRow = (0,dx_react_core_es/* withComponents */.we)({
  Row: dx_react_grid_material_ui_es_TableRow,
  Cell: TableFilterCell,
  Editor: Editor,
  FilterSelector: FilterSelector,
  Icon: Icon$1,
  ToggleButton: ToggleButton$1
})(dx_react_grid_es/* TableFilterRow */.B0);
TableFilterRow.ROW_TYPE = dx_react_grid_es/* TableFilterRow.ROW_TYPE */.B0.ROW_TYPE;

var styles$v = function styles(theme) {
  return {
    resizeHandle: {
      position: 'absolute',
      userSelect: 'none',
      MozUserSelect: 'none',
      WebkitUserSelect: 'none',
      width: theme.spacing(2),
      top: 0,
      right: -theme.spacing(1),
      height: '100%',
      cursor: 'col-resize',
      zIndex: 100
    },
    resizeHandleLine: {
      position: 'absolute',
      backgroundColor: theme.palette.primary.light,
      height: '50%',
      width: '1px',
      top: '25%',
      transition: 'all linear 100ms'
    },
    resizeHandleFirstLine: {
      left: "".concat(theme.spacing(1) - 1, "px")
    },
    resizeHandleSecondLine: {
      left: "".concat(theme.spacing(1) + 1, "px")
    },
    resizeHandleLineActive: {
      left: theme.spacing(1)
    },
    resizeHandleActive: {
      '& $resizeHandleLine': {
        opacity: '1',
        backgroundColor: theme.palette.primary.light,
        height: 'calc(100% - 4px)',
        top: '2px'
      }
    }
  };
};

var ResizingControlBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ResizingControlBase, _React$PureComponent);

  var _super = _createSuper(ResizingControlBase);

  function ResizingControlBase(props) {
    var _this;

    _classCallCheck(this, ResizingControlBase);

    _this = _super.call(this, props);
    _this.state = {
      resizing: false
    };

    _this.onResizeStart = function (_ref) {
      var x = _ref.x;
      _this.resizeStartingX = x;

      _this.setState({
        resizing: true
      });
    };

    _this.onResizeUpdate = function (_ref2) {
      var x = _ref2.x;
      var onWidthDraft = _this.props.onWidthDraft;
      onWidthDraft({
        shift: x - _this.resizeStartingX
      });
    };

    _this.onResizeEnd = function (_ref3) {
      var x = _ref3.x;
      var _this$props = _this.props,
          onWidthChange = _this$props.onWidthChange,
          onWidthDraftCancel = _this$props.onWidthDraftCancel;
      onWidthDraftCancel();
      onWidthChange({
        shift: x - _this.resizeStartingX
      });

      _this.setState({
        resizing: false
      });
    };

    return _this;
  }

  _createClass(ResizingControlBase, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2, _classNames3;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          resizeHandleOpacityClass = _this$props2.resizeHandleOpacityClass,
          resizeLastHandleClass = _this$props2.resizeLastHandleClass;
      var resizing = this.state.resizing;
      return /*#__PURE__*/(0,react.createElement)(dx_react_core_es/* Draggable */._l, {
        onStart: this.onResizeStart,
        onUpdate: this.onResizeUpdate,
        onEnd: this.onResizeEnd
      }, /*#__PURE__*/(0,react.createElement)("div", {
        className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.resizeHandle, true), _defineProperty(_classNames, resizeLastHandleClass, true), _defineProperty(_classNames, classes.resizeHandleActive, resizing), _classNames))
      }, /*#__PURE__*/(0,react.createElement)("div", {
        className: (0,clsx_m/* default */.Z)((_classNames2 = {}, _defineProperty(_classNames2, resizeHandleOpacityClass, true), _defineProperty(_classNames2, classes.resizeHandleLine, true), _defineProperty(_classNames2, classes.resizeHandleFirstLine, true), _defineProperty(_classNames2, classes.resizeHandleLineActive, resizing), _classNames2))
      }), /*#__PURE__*/(0,react.createElement)("div", {
        className: (0,clsx_m/* default */.Z)((_classNames3 = {}, _defineProperty(_classNames3, resizeHandleOpacityClass, true), _defineProperty(_classNames3, classes.resizeHandleLine, true), _defineProperty(_classNames3, classes.resizeHandleSecondLine, true), _defineProperty(_classNames3, classes.resizeHandleLineActive, resizing), _classNames3))
      })));
    }
  }]);

  return ResizingControlBase;
}(react.PureComponent);
 false ? 0 : void 0;
var ResizingControl = (0,withStyles/* default */.Z)(styles$v, {
  name: 'ResizingControl'
})(ResizingControlBase);

var _excluded$D = ["style", "column", "tableColumn", "draggingEnabled", "resizingEnabled", "onWidthChange", "onWidthDraft", "onWidthDraftCancel", "getCellWidth", "classes", "tableRow", "className", "children"];

var styles$w = function styles(theme) {
  return {
    plainTitle: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: theme.spacing(3)
    },
    cell: {
      outline: 'none',
      position: 'relative',
      overflow: 'visible',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      '&:first-child': {
        paddingLeft: theme.spacing(3)
      },
      '&:hover $resizeHandleLine': {
        opacity: 1
      },
      '&:nth-last-child(2) $resizeHandle': {
        width: theme.spacing(1),
        right: '1px'
      }
    },
    resizeHandle: {},
    resizeHandleLine: {
      opacity: 0
    },
    '@media (pointer: fine)': {
      resizeHandleLine: {
        opacity: 0
      },
      resizeHandleActive: {
        '& $resizeHandleLine': {
          opacity: 1
        }
      },
      resizeHandle: {
        '&:hover $resizeHandleLine': {
          opacity: 1
        }
      }
    },
    cellNoUserSelect: {
      userSelect: 'none',
      MozUserSelect: 'none',
      WebkitUserSelect: 'none'
    },
    cellDraggable: {
      cursor: 'pointer'
    },
    cellDimmed: {
      '&:after': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.background.paper,
        opacity: 0.7,
        pointerEvents: 'none',
        zIndex: 400
      }
    },
    cellRight: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      textAlign: 'right'
    },
    cellCenter: {
      textAlign: 'center'
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    cellNoWrap: {
      whiteSpace: 'nowrap'
    }
  };
};

var TableHeaderCellBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableHeaderCellBase, _React$PureComponent);

  var _super = _createSuper(TableHeaderCellBase);

  function TableHeaderCellBase(props) {
    var _this;

    _classCallCheck(this, TableHeaderCellBase);

    _this = _super.call(this, props);
    _this.state = {
      dragging: false
    };
    _this.dragRef = /*#__PURE__*/(0,react.createRef)();
    _this.cellRef = /*#__PURE__*/(0,react.createRef)();

    _this.getWidthGetter = function () {
      var getCellWidth = _this.props.getCellWidth;
      var node = _this.cellRef.current;
      return node && getCellWidth(function () {
        var _node$getBoundingClie = node.getBoundingClientRect(),
            width = _node$getBoundingClie.width;

        return width;
      });
    };

    _this.onDragStart = function () {
      _this.setState({
        dragging: true
      });
    };

    _this.onDragEnd = function () {
      if (_this.dragRef.current) {
        _this.setState({
          dragging: false
        });
      }
    };

    return _this;
  }

  _createClass(TableHeaderCellBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getWidthGetter();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          style = _this$props.style,
          column = _this$props.column,
          tableColumn = _this$props.tableColumn,
          draggingEnabled = _this$props.draggingEnabled,
          resizingEnabled = _this$props.resizingEnabled,
          onWidthChange = _this$props.onWidthChange,
          onWidthDraft = _this$props.onWidthDraft,
          onWidthDraftCancel = _this$props.onWidthDraftCancel,
          getCellWidth = _this$props.getCellWidth,
          classes = _this$props.classes,
          tableRow = _this$props.tableRow,
          className = _this$props.className,
          children = _this$props.children,
          restProps = _objectWithoutProperties(_this$props, _excluded$D);

      var dragging = this.state.dragging;
      var align = tableColumn && tableColumn.align || 'left';
      var tableCellClasses = (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.cell, true), _defineProperty(_classNames, classes.cellRight, align === 'right'), _defineProperty(_classNames, classes.cellCenter, align === 'center'), _defineProperty(_classNames, classes.cellNoUserSelect, draggingEnabled), _defineProperty(_classNames, classes.cellDraggable, draggingEnabled), _defineProperty(_classNames, classes.cellDimmed, dragging || tableColumn && tableColumn.draft), _defineProperty(_classNames, classes.cellNoWrap, !(tableColumn && tableColumn.wordWrapEnabled)), _classNames), className);
      var cellLayout = /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
        style: style,
        className: tableCellClasses,
        ref: this.cellRef
      }, restProps), /*#__PURE__*/(0,react.createElement)("div", {
        className: classes.container
      }, children), resizingEnabled && /*#__PURE__*/(0,react.createElement)(ResizingControl, {
        onWidthChange: onWidthChange,
        onWidthDraft: onWidthDraft,
        onWidthDraftCancel: onWidthDraftCancel,
        resizeLastHandleClass: classes.resizeHandle,
        resizeHandleOpacityClass: classes.resizeHandleLine
      }));
      return draggingEnabled ? /*#__PURE__*/(0,react.createElement)(dx_react_core_es/* DragSource */.Ej, {
        ref: this.dragRef,
        payload: [{
          type: 'column',
          columnName: column.name
        }],
        onStart: this.onDragStart,
        onEnd: this.onDragEnd
      }, cellLayout) : cellLayout;
    }
  }]);

  return TableHeaderCellBase;
}(react.PureComponent);

 false ? 0 : void 0;
TableHeaderCellBase.defaultProps = {
  column: undefined,
  tableColumn: undefined,
  tableRow: undefined,
  style: null,
  draggingEnabled: false,
  resizingEnabled: false,
  onWidthChange: undefined,
  onWidthDraft: undefined,
  onWidthDraftCancel: undefined,
  className: undefined,
  children: undefined,
  getCellWidth: function getCellWidth() {}
};
var TableHeaderCell = (0,withStyles/* default */.Z)(styles$w, {
  name: 'TableHeaderCell'
})(TableHeaderCellBase);

var _excluded$E = ["column", "align", "direction", "children", "onSort", "classes", "getMessage", "disabled", "className"];
var ENTER_KEY_CODE$1 = 13;
var SPACE_KEY_CODE$1 = 32;

var styles$x = function styles() {
  return {
    root: {
      width: '100%',
      userSelect: 'none',
      MozUserSelect: 'none',
      WebkitUserSelect: 'none'
    },
    tooltipRoot: {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    sortLabelRoot: {
      maxWidth: '100%'
    },
    sortLabelRight: {
      flexDirection: 'row-reverse'
    },
    sortLabelActive: {
      color: 'inherit'
    }
  };
};

var _onClick = function onClick(e, onSort) {
  var isActionKeyDown = e.keyCode === ENTER_KEY_CODE$1 || e.keyCode === SPACE_KEY_CODE$1;
  var isMouseClick = e.keyCode === undefined;
  var cancelSortingRelatedKey = e.metaKey || e.ctrlKey;
  var direction = (isMouseClick || isActionKeyDown) && cancelSortingRelatedKey ? null : undefined;
  var keepOther = e.shiftKey || cancelSortingRelatedKey;
  e.preventDefault();
  onSort({
    direction: direction,
    keepOther: keepOther
  });
};

var SortLabelBase = function SortLabelBase(_ref) {
  var _classNames;

  var column = _ref.column,
      align = _ref.align,
      direction = _ref.direction,
      children = _ref.children,
      onSort = _ref.onSort,
      classes = _ref.classes,
      getMessage = _ref.getMessage,
      disabled = _ref.disabled,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$E);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, restProps), /*#__PURE__*/(0,react.createElement)(Tooltip/* default */.ZP, {
    title: getMessage('sortingHint'),
    placement: align === 'right' ? 'bottom-end' : 'bottom-start',
    enterDelay: 300,
    classes: {
      tooltip: classes.tooltipRoot
    }
  }, /*#__PURE__*/(0,react.createElement)(TableSortLabel_TableSortLabel, {
    active: !!direction,
    direction: direction === null ? undefined : direction,
    onClick: function onClick(e) {
      return _onClick(e, onSort);
    },
    disabled: disabled,
    classes: {
      root: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.sortLabelRoot, true), _defineProperty(_classNames, classes.sortLabelRight, align === 'right'), _classNames)),
      active: classes.sortLabelActive
    }
  }, children)));
};

 false ? 0 : void 0;
SortLabelBase.defaultProps = {
  column: undefined,
  direction: undefined,
  disabled: false,
  align: 'left',
  className: null,
  children: undefined
};
var SortLabel = (0,withStyles/* default */.Z)(styles$x, {
  name: 'SortLabel'
})(SortLabelBase);

var _excluded$F = ["disabled", "onGroup", "classes", "className"];

var styles$y = function styles(theme) {
  return {
    root: {
      paddingLeft: 0,
      height: theme.spacing(3),
      cursor: 'pointer'
    },
    disabled: {
      cursor: 'default',
      opacity: 0.3
    }
  };
};

var GroupButtonBase = function GroupButtonBase(_ref) {
  var _classNames;

  var disabled = _ref.disabled,
      onGroup = _ref.onGroup,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$F);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    onClick: function onClick(e) {
      if (disabled) return;
      e.stopPropagation();
      onGroup(e);
    },
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.root, true), _defineProperty(_classNames, classes.disabled, disabled), _classNames), className)
  }, restProps), /*#__PURE__*/(0,react.createElement)(icons_List/* default */.Z, null));
};

 false ? 0 : void 0;
GroupButtonBase.defaultProps = {
  disabled: false,
  className: undefined
};
var GroupButton = (0,withStyles/* default */.Z)(styles$y, {
  name: 'GroupButton'
})(GroupButtonBase);

var _excluded$G = ["children", "classes", "className"];
var styles$z = {
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};

var TitelBase = function TitelBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$G);

  return /*#__PURE__*/(0,react.createElement)("span", _extends({
    className: (0,clsx_m/* default */.Z)(classes.title, className)
  }, restProps), children);
};

 false ? 0 : void 0;
TitelBase.defaultProps = {
  className: null,
  children: undefined
};
var Title = (0,withStyles/* default */.Z)(styles$z, {
  name: 'Title'
})(TitelBase);

var _excluded$H = ["column", "align", "children", "classes", "className"];
var styles$A = {
  content: {
    width: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  alignCenter: {
    justifyContent: 'center'
  },
  alignRight: {
    justifyContent: 'flex-end'
  }
};

var ContentBase$1 = function ContentBase(_ref) {
  var _classNames;

  var column = _ref.column,
      align = _ref.align,
      children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$H);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.content, true), _defineProperty(_classNames, classes.alignCenter, align === 'center'), _defineProperty(_classNames, classes.alignRight, align === 'right'), _classNames), className)
  }, restProps), children);
};

 false ? 0 : void 0;
ContentBase$1.defaultProps = {
  column: undefined,
  align: 'left',
  className: null,
  children: undefined
};
var Content$1 = (0,withStyles/* default */.Z)(styles$A, {
  name: 'Content'
})(ContentBase$1);

var _excluded$I = ["messages"];
var defaultMessages$2 = {
  sortingHint: 'Sort'
};
var TableHeaderRowWithMessages = withPatchedProps(function (_ref) {
  var messages = _ref.messages,
      restProps = _objectWithoutProperties(_ref, _excluded$I);

  return _objectSpread2({
    messages: _objectSpread2(_objectSpread2({}, defaultMessages$2), messages)
  }, restProps);
})(dx_react_grid_es/* TableHeaderRow */.KA);
TableHeaderRowWithMessages.propTypes = {
  messages: (0,prop_types.shape)({
    sortingHint: prop_types.string
  })
};
TableHeaderRowWithMessages.defaultProps = {
  messages: {}
};
TableHeaderRowWithMessages.components = dx_react_grid_es/* TableHeaderRow.components */.KA.components;
var TableHeaderRow = (0,dx_react_core_es/* withComponents */.we)({
  Cell: TableHeaderCell,
  Row: dx_react_grid_material_ui_es_TableRow,
  Content: Content$1,
  SortLabel: SortLabel,
  Title: Title,
  GroupButton: GroupButton
})(TableHeaderRowWithMessages);
TableHeaderRow.ROW_TYPE = dx_react_grid_es/* TableHeaderRow.ROW_TYPE */.KA.ROW_TYPE;

var _excluded$J = ["column", "value", "children", "classes", "tableRow", "tableColumn", "row", "className", "beforeBorder"];

var styles$B = function styles(theme) {
  return {
    cell: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      '&:first-child': {
        paddingLeft: theme.spacing(3)
      },
      '&:last-child': {
        paddingRight: theme.spacing(3),
        borderRight: 0
      },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      borderBottom: getBorder(theme),
      borderRight: getBorder(theme)
    },
    beforeBorder: {
      borderLeft: getBorder(theme)
    }
  };
};

var CellBase$1 = function CellBase(_ref) {
  var _classNames;

  var column = _ref.column,
      value = _ref.value,
      children = _ref.children,
      classes = _ref.classes,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      row = _ref.row,
      className = _ref.className,
      beforeBorder = _ref.beforeBorder,
      restProps = _objectWithoutProperties(_ref, _excluded$J);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.cell, true), _defineProperty(_classNames, classes.beforeBorder, beforeBorder), _classNames), className)
  }, restProps), children);
};

 false ? 0 : void 0;
CellBase$1.defaultProps = {
  value: undefined,
  column: undefined,
  row: undefined,
  children: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  className: undefined,
  beforeBorder: false
};
var Cell$1 = (0,withStyles/* default */.Z)(styles$B, {
  name: 'Cell'
})(CellBase$1);

var _excluded$K = ["component", "className", "classes", "beforeBorder"];

var styles$C = function styles(theme) {
  return {
    headerCellBorder: {
      borderRight: getBorder(theme),
      borderTop: 'none',
      '&:last-child': {
        borderRight: 0
      },
      verticalAlign: 'bottom',
      paddingBottom: theme.spacing(2)
    },
    beforeBorder: {
      borderLeft: getBorder(theme)
    }
  };
};

var BandedHeaderCellBase = function BandedHeaderCellBase(_ref) {
  var _classNames;

  var HeaderCellComponent = _ref.component,
      className = _ref.className,
      classes = _ref.classes,
      beforeBorder = _ref.beforeBorder,
      restProps = _objectWithoutProperties(_ref, _excluded$K);

  return /*#__PURE__*/(0,react.createElement)(HeaderCellComponent, _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.headerCellBorder, true), _defineProperty(_classNames, classes.beforeBorder, beforeBorder), _classNames), className)
  }, restProps));
};
 false ? 0 : void 0;
BandedHeaderCellBase.defaultProps = {
  className: undefined,
  beforeBorder: false
};
var BandedHeaderCell = (0,withStyles/* default */.Z)(styles$C, {
  name: 'BandedHeaderCell'
})(BandedHeaderCellBase);

var styles$D = {
  emptyCell: {
    display: 'none'
  }
};

var InvisibleCellBase = function InvisibleCellBase(_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, {
    className: classes.emptyCell
  });
};

 false ? 0 : void 0;
var InvisibleCell = (0,withStyles/* default */.Z)(styles$D, {
  name: 'InvisibleCell'
})(InvisibleCellBase);

var _excluded$L = ["children", "classes", "className", "row", "tableRow", "tableColumn"];
var styles$E = {
  row: {
    height: 'auto'
  }
};
var RowBase$1 = function RowBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      row = _ref.row,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      restProps = _objectWithoutProperties(_ref, _excluded$L);

  return /*#__PURE__*/(0,react.createElement)(TableRow_TableRow, _extends({
    className: (0,clsx_m/* default */.Z)(classes.row, className)
  }, restProps), children);
};
 false ? 0 : void 0;
RowBase$1.defaultProps = {
  children: undefined,
  row: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  className: undefined
};
var Row$1 = (0,withStyles/* default */.Z)(styles$E, {
  name: 'Row'
})(RowBase$1);

var TableBandHeader = (0,dx_react_core_es/* withComponents */.we)({
  Cell: Cell$1,
  Row: Row$1,
  BandedHeaderCell: BandedHeaderCell,
  InvisibleCell: InvisibleCell
})(dx_react_grid_es/* TableBandHeader */.mg);
TableBandHeader.ROW_TYPE = dx_react_grid_es/* TableBandHeader.ROW_TYPE */.mg.ROW_TYPE;

var _excluded$M = ["column", "value", "onValueChange", "style", "classes", "children", "row", "tableRow", "tableColumn", "editingEnabled", "className", "autoFocus", "onBlur", "onFocus", "onKeyDown"];

var styles$F = function styles(theme) {
  return {
    cell: {
      padding: theme.spacing(1),
      // NOTE: without the TableEditColumn first EditCell changes size
      // (because first TableCell and EditCell have different paddings)
      '&:first-child': {
        paddingLeft: theme.spacing(3)
      }
    },
    inputRoot: {
      width: '100%'
    },
    disabledInput: {
      color: theme.palette.action.disabled,
      '&:before': {
        borderBottom: '1px dotted',
        borderBottomColor: theme.palette.action.disabled
      },
      '&&:hover:before': {
        borderBottom: '1px dotted',
        borderBottomColor: theme.palette.action.disabled
      },
      '&:after': {
        borderBottom: '0px'
      }
    },
    inputRight: {
      textAlign: 'right'
    },
    inputCenter: {
      textAlign: 'center'
    }
  };
};

var EditCellBase = function EditCellBase(_ref) {
  var _classNames, _classNames2;

  var column = _ref.column,
      value = _ref.value,
      onValueChange = _ref.onValueChange,
      style = _ref.style,
      classes = _ref.classes,
      children = _ref.children,
      row = _ref.row,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      editingEnabled = _ref.editingEnabled,
      className = _ref.className,
      autoFocus = _ref.autoFocus,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      restProps = _objectWithoutProperties(_ref, _excluded$M);

  var inputClasses = (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.inputRight, tableColumn && tableColumn.align === 'right'), _defineProperty(_classNames, classes.inputCenter, tableColumn && tableColumn.align === 'center'), _classNames));
  var patchedChildren = children ? /*#__PURE__*/(0,react.cloneElement)(children, {
    autoFocus: autoFocus,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown
  }) : children;
  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.cell, className),
    style: style
  }, restProps), patchedChildren || /*#__PURE__*/(0,react.createElement)(Input/* default */.Z, {
    className: (0,clsx_m/* default */.Z)((_classNames2 = {}, _defineProperty(_classNames2, classes.inputRoot, true), _defineProperty(_classNames2, classes.disabledInput, !editingEnabled), _classNames2)),
    classes: {
      input: inputClasses
    },
    value: value,
    readOnly: !editingEnabled,
    onChange: function onChange(e) {
      return onValueChange(e.target.value);
    } // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: autoFocus,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown
  }));
};

 false ? 0 : void 0;
EditCellBase.defaultProps = {
  column: undefined,
  row: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  value: '',
  style: null,
  children: undefined,
  className: undefined,
  editingEnabled: true,
  autoFocus: false,
  onValueChange: function onValueChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {}
};
var EditCell = (0,withStyles/* default */.Z)(styles$F, {
  name: 'EditCell'
})(EditCellBase);

var TableEditRow = (0,dx_react_core_es/* withComponents */.we)({
  Row: dx_react_grid_material_ui_es_TableRow,
  Cell: EditCell
})(dx_react_grid_es/* TableEditRow */.LV);
TableEditRow.ADDED_ROW_TYPE = dx_react_grid_es/* TableEditRow.ADDED_ROW_TYPE */.LV.ADDED_ROW_TYPE;
TableEditRow.EDIT_ROW_TYPE = dx_react_grid_es/* TableEditRow.EDIT_ROW_TYPE */.LV.EDIT_ROW_TYPE;

var _excluded$N = ["onExecute", "text", "classes", "className"],
    _excluded2$1 = ["children", "classes", "className", "tableRow", "tableColumn", "rowSpan"],
    _excluded3 = ["tableRow", "tableColumn", "row", "children", "classes", "className"];

var styles$G = function styles(theme) {
  return {
    button: {
      padding: theme.spacing(1),
      minWidth: 40
    },
    headingCell: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      padding: theme.spacing(0, 2, 0, 3)
    },
    cell: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      padding: theme.spacing(0, 2, 0, 3)
    },
    alignWithRowSpan: {
      verticalAlign: 'bottom',
      paddingBottom: theme.spacing(1.25)
    }
  };
};

var withEditColumnStyles = (0,withStyles/* default */.Z)(styles$G, {
  name: 'EditColumn'
});

var CommandButtonBase = function CommandButtonBase(_ref) {
  var onExecute = _ref.onExecute,
      text = _ref.text,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$N);

  return /*#__PURE__*/(0,react.createElement)(Button/* default */.Z, _extends({
    color: "primary",
    className: (0,clsx_m/* default */.Z)(classes.button, className),
    onClick: function onClick(e) {
      e.stopPropagation();
      onExecute();
    }
  }, restProps), text);
};

 false ? 0 : void 0;
CommandButtonBase.defaultProps = {
  className: undefined
};
var CommandButton = withEditColumnStyles(CommandButtonBase);

var EditCommandHeadingCellBase = function EditCommandHeadingCellBase(_ref2) {
  var _classNames;

  var children = _ref2.children,
      classes = _ref2.classes,
      className = _ref2.className,
      tableRow = _ref2.tableRow,
      tableColumn = _ref2.tableColumn,
      rowSpan = _ref2.rowSpan,
      restProps = _objectWithoutProperties(_ref2, _excluded2$1);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.headingCell, true), _defineProperty(_classNames, classes.alignWithRowSpan, rowSpan > 1), _classNames), className),
    rowSpan: rowSpan
  }, restProps), children);
};

 false ? 0 : void 0;
EditCommandHeadingCellBase.defaultProps = {
  children: undefined,
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  rowSpan: undefined
};
var EditCommandHeadingCell = withEditColumnStyles(EditCommandHeadingCellBase);

var EditCommandCellBase = function EditCommandCellBase(_ref3) {
  var tableRow = _ref3.tableRow,
      tableColumn = _ref3.tableColumn,
      row = _ref3.row,
      children = _ref3.children,
      classes = _ref3.classes,
      className = _ref3.className,
      restProps = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.cell, className)
  }, restProps), children);
};

 false ? 0 : void 0;
EditCommandCellBase.defaultProps = {
  children: undefined,
  className: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  row: undefined
};
var EditCommandCell = withEditColumnStyles(EditCommandCellBase);

var TableEditColumnWithWidth = withPatchedProps(function (props) {
  return _objectSpread2({
    width: 150
  }, props);
})(dx_react_grid_es/* TableEditColumn */.Al);
TableEditColumnWithWidth.components = dx_react_grid_es/* TableEditColumn.components */.Al.components;
var TableEditColumn = (0,dx_react_core_es/* withComponents */.we)({
  Cell: EditCommandCell,
  HeaderCell: EditCommandHeadingCell,
  Command: CommandButton
})(TableEditColumnWithWidth);
TableEditColumn.COLUMN_TYPE = dx_react_grid_es/* TableEditColumn.COLUMN_TYPE */.Al.COLUMN_TYPE;

var _excluded$O = ["getMessage", "classes"];

var styles$H = function styles(theme) {
  return {
    emptyMessage: {
      margin: '0 auto',
      padding: theme.spacing(5, 0),
      fontFamily: theme.typography.fontFamily,
      color: theme.typography.subtitle1.color,
      fontSize: theme.typography.subtitle1.fontSize
    }
  };
};

var EmptyMessageBase = function EmptyMessageBase(_ref) {
  var getMessage = _ref.getMessage,
      classes = _ref.classes,
      restProps = _objectWithoutProperties(_ref, _excluded$O);

  return /*#__PURE__*/(0,react.createElement)(Toolbar/* default */.Z, restProps, /*#__PURE__*/(0,react.createElement)("big", {
    className: classes.emptyMessage
  }, getMessage('noColumns')));
};
 false ? 0 : void 0;
var EmptyMessage = (0,withStyles/* default */.Z)(styles$H, {
  name: 'EmptyMessage'
})(EmptyMessageBase);

var TableColumnVisibility = (0,dx_react_core_es/* withComponents */.we)({
  EmptyMessage: EmptyMessage
})(dx_react_grid_es/* TableColumnVisibility */.W3);

var TableReorderingCell = function TableReorderingCell(_ref) {
  var style = _ref.style,
      getCellDimensions = _ref.getCellDimensions;

  var refHandler = function refHandler(node) {
    return node && getCellDimensions(function () {
      return (0,dx_grid_core_es/* getCellGeometries */.FY1)(node);
    });
  };

  return /*#__PURE__*/(0,react.createElement)("td", {
    ref: refHandler,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      padding: 0
    })
  });
};
 false ? 0 : void 0;
TableReorderingCell.defaultProps = {
  style: null
};

var _excluded$P = ["className", "classes"];

var styles$I = function styles() {
  return {
    row: {
      visibility: 'hidden'
    }
  };
};

var TableInvisibleRowBase = function TableInvisibleRowBase(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      restParams = _objectWithoutProperties(_ref, _excluded$P);

  return /*#__PURE__*/(0,react.createElement)(dx_react_grid_material_ui_es_TableRow, _extends({
    className: (0,clsx_m/* default */.Z)(classes.row, className)
  }, restParams));
};

 false ? 0 : void 0;
TableInvisibleRowBase.defaultProps = {
  className: undefined
};
var TableInvisibleRow = (0,withStyles/* default */.Z)(styles$I, {
  name: 'TableInvisibleRow'
})(TableInvisibleRowBase);

var TableColumnReordering = (0,dx_react_core_es/* withComponents */.we)({
  Row: TableInvisibleRow,
  Cell: TableReorderingCell
})(dx_react_grid_es/* TableColumnReordering */.nM);

var _excluded$Q = ["minColumnWidth", "maxColumnWidth"];
var TableColumnResizing = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableColumnResizing, _React$PureComponent);

  var _super = _createSuper(TableColumnResizing);

  function TableColumnResizing() {
    _classCallCheck(this, TableColumnResizing);

    return _super.apply(this, arguments);
  }

  _createClass(TableColumnResizing, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          minColumnWidth = _this$props.minColumnWidth,
          maxColumnWidth = _this$props.maxColumnWidth,
          restProps = _objectWithoutProperties(_this$props, _excluded$Q);

      return /*#__PURE__*/(0,react.createElement)(dx_react_grid_es/* TableColumnResizing */.ad, _extends({}, restProps, {
        minColumnWidth: minColumnWidth,
        maxColumnWidth: maxColumnWidth
      }));
    }
  }]);

  return TableColumnResizing;
}(react.PureComponent);
 false ? 0 : void 0;
TableColumnResizing.defaultProps = {
  minColumnWidth: 40,
  maxColumnWidth: Infinity
};

var _excluded$R = ["children", "classes", "className", "style"];

var styles$J = function styles(theme) {
  return {
    toolbar: {
      borderBottom: getBorder(theme),
      flex: 'none'
    }
  };
};

var ToolbarBase = function ToolbarBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      style = _ref.style,
      restProps = _objectWithoutProperties(_ref, _excluded$R);

  return /*#__PURE__*/(0,react.createElement)(Toolbar/* default */.Z, _extends({
    style: style,
    className: (0,clsx_m/* default */.Z)(classes.toolbar, className)
  }, restProps), children);
};

 false ? 0 : void 0;
ToolbarBase.defaultProps = {
  className: undefined,
  style: null
};
var dx_react_grid_material_ui_es_Toolbar = (0,withStyles/* default */.Z)(styles$J, {
  name: 'Toolbar'
})(ToolbarBase);

var FlexibleSpace = function FlexibleSpace() {
  return /*#__PURE__*/(0,react.createElement)("div", {
    style: {
      flex: '0 0 0',
      marginLeft: 'auto'
    }
  });
};

var Toolbar$1 = (0,dx_react_core_es/* withComponents */.we)({
  Root: dx_react_grid_material_ui_es_Toolbar,
  FlexibleSpace: FlexibleSpace
})(dx_react_grid_es/* Toolbar */.o8);

var _excluded$S = ["visible", "expanded", "classes", "onToggle", "className"];

var styles$K = function styles(theme) {
  return {
    button: {
      marginTop: '-1px',
      marginBottom: '-1px',
      marginLeft: -theme.spacing(1),
      marginRight: theme.spacing(2),
      padding: theme.spacing(1)
    },
    hidden: {
      cursor: 'default',
      opacity: 0
    }
  };
};

var TableTreeExpandButtonBase = function TableTreeExpandButtonBase(_ref) {
  var _classNames;

  var visible = _ref.visible,
      expanded = _ref.expanded,
      classes = _ref.classes,
      onToggle = _ref.onToggle,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$S);

  return /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.button, true), _defineProperty(_classNames, classes.hidden, !visible), _classNames), className),
    onClick: function onClick(e) {
      if (!visible) return;
      e.stopPropagation();
      onToggle();
    },
    tabIndex: visible ? 0 : -1
  }, restProps), expanded ? /*#__PURE__*/(0,react.createElement)(ExpandMore/* default */.Z, null) : /*#__PURE__*/(0,react.createElement)(ChevronRight/* default */.Z, null));
};

 false ? 0 : void 0;
TableTreeExpandButtonBase.defaultProps = {
  visible: false,
  expanded: false,
  onToggle: function onToggle() {},
  className: undefined
};
var TableTreeExpandButton = (0,withStyles/* default */.Z)(styles$K)(TableTreeExpandButtonBase);

var _excluded$T = ["disabled", "checked", "indeterminate", "onChange", "classes", "className"];

var styles$L = function styles(theme) {
  return {
    checkbox: {
      marginTop: '-1px',
      marginBottom: '-1px',
      marginRight: theme.spacing(2),
      marginLeft: -theme.spacing(2),
      padding: theme.spacing(1)
    }
  };
};

var TableTreeCheckboxBase = function TableTreeCheckboxBase(_ref) {
  var disabled = _ref.disabled,
      checked = _ref.checked,
      indeterminate = _ref.indeterminate,
      onChange = _ref.onChange,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$T);

  return /*#__PURE__*/(0,react.createElement)(Checkbox/* default */.Z, _extends({
    className: (0,clsx_m/* default */.Z)(classes.checkbox, className),
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled,
    onClick: function onClick(e) {
      if (disabled) return;
      e.stopPropagation();
      onChange();
    }
  }, restProps));
};
 false ? 0 : void 0;
TableTreeCheckboxBase.defaultProps = {
  disabled: false,
  checked: false,
  indeterminate: false,
  onChange: function onChange() {},
  className: undefined
};
var TableTreeCheckbox = (0,withStyles/* default */.Z)(styles$L)(TableTreeCheckboxBase);

var styles$M = function styles(theme) {
  return {
    indent: {
      marginLeft: theme.spacing(3)
    }
  };
};

var TableTreeIndentBase = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var level = _ref.level,
      classes = _ref.classes;
  return Array.from({
    length: level
  }).map(function (value, currentLevel) {
    return /*#__PURE__*/(0,react.createElement)("span", {
      // eslint-disable-next-line react/no-array-index-key
      key: currentLevel,
      className: classes.indent
    });
  });
});
TableTreeIndentBase.propTypes = {
  level: prop_types.number,
  classes: prop_types.object.isRequired
};
TableTreeIndentBase.defaultProps = {
  level: 0
};
var TableTreeIndent = (0,withStyles/* default */.Z)(styles$M)(TableTreeIndentBase);

var _excluded$U = ["children", "classes", "className"];

var styles$N = function styles() {
  return {
    content: {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
};

var TableTreeContentBase = function TableTreeContentBase(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$U);

  return /*#__PURE__*/(0,react.createElement)("div", _extends({
    className: (0,clsx_m/* default */.Z)(_defineProperty({}, classes.content, true), className)
  }, restProps), children);
};

 false ? 0 : void 0;
TableTreeContentBase.defaultProps = {
  children: undefined,
  className: undefined
};
var TableTreeContent = (0,withStyles/* default */.Z)(styles$N)(TableTreeContentBase);

var _excluded$V = ["column", "value", "children", "classes", "tableRow", "tableColumn", "row", "className"];

var styles$O = function styles(theme) {
  return {
    cell: {
      padding: theme.spacing(0.5, 1),
      '&:first-child': {
        paddingLeft: theme.spacing(3)
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    cellNoWrap: {
      whiteSpace: 'nowrap'
    },
    cellRightAlign: {
      textAlign: 'right'
    },
    cellCenterAlign: {
      textAlign: 'center'
    }
  };
};

var TableTreeCellBase = function TableTreeCellBase(_ref) {
  var _classNames;

  var column = _ref.column,
      value = _ref.value,
      children = _ref.children,
      classes = _ref.classes,
      tableRow = _ref.tableRow,
      tableColumn = _ref.tableColumn,
      row = _ref.row,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded$V);

  return /*#__PURE__*/(0,react.createElement)(TableCell_TableCell, _extends({
    className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.cell, true), _defineProperty(_classNames, classes.cellNoWrap, !(tableColumn && tableColumn.wordWrapEnabled)), _defineProperty(_classNames, classes.cellRightAlign, tableColumn && tableColumn.align === 'right'), _defineProperty(_classNames, classes.cellCenterAlign, tableColumn && tableColumn.align === 'center'), _classNames), className)
  }, restProps), /*#__PURE__*/(0,react.createElement)("div", {
    className: classes.container
  }, children));
};

 false ? 0 : void 0;
TableTreeCellBase.defaultProps = {
  value: undefined,
  column: undefined,
  row: undefined,
  children: undefined,
  tableRow: undefined,
  tableColumn: undefined,
  className: undefined
};
var TableTreeCell = (0,withStyles/* default */.Z)(styles$O)(TableTreeCellBase);

var TableTreeColumn = (0,dx_react_core_es/* withComponents */.we)({
  Cell: TableTreeCell,
  Content: TableTreeContent,
  Indent: TableTreeIndent,
  ExpandButton: TableTreeExpandButton,
  Checkbox: TableTreeCheckbox
})(dx_react_grid_es/* TableTreeColumn */.iA);

var _excluded$W = ["onValueChange", "value", "getMessage"];

var styles$P = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.action.active
    }
  };
};

var SearchPanelInputBase = function SearchPanelInputBase(_ref) {
  var onValueChange = _ref.onValueChange,
      value = _ref.value,
      getMessage = _ref.getMessage,
      restProps = _objectWithoutProperties(_ref, _excluded$W);

  return /*#__PURE__*/(0,react.createElement)(Input/* default */.Z, _extends({
    onChange: function onChange(e) {
      return onValueChange(e.target.value);
    },
    value: value,
    type: "text",
    placeholder: getMessage('searchPlaceholder')
  }, restProps, {
    startAdornment: /*#__PURE__*/(0,react.createElement)(InputAdornment/* default */.Z, {
      position: "start"
    }, /*#__PURE__*/(0,react.createElement)(Search/* default */.Z, null))
  }));
};

 false ? 0 : void 0;
SearchPanelInputBase.defaultProps = {
  value: ''
};
var SearchPanelInput = (0,withStyles/* default */.Z)(styles$P)(SearchPanelInputBase);

var SearchPanel = (0,dx_react_core_es/* withComponents */.we)({
  Input: SearchPanelInput
})(dx_react_grid_es/* SearchPanel */.EG);

var _excluded$X = ["className", "classes", "component", "position", "selected", "showLeftDivider", "showRightDivider", "side", "style"];

var styles$Q = function styles(theme) {
  return {
    dividerRight: {
      borderRight: getBorder(theme)
    },
    dividerLeft: {
      borderLeft: getBorder(theme)
    },
    fixedCell: getStickyCellStyle(theme),
    selected: {
      backgroundColor: 'inherit'
    }
  };
};

var FixedCellBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FixedCellBase, _React$PureComponent);

  var _super = _createSuper(FixedCellBase);

  function FixedCellBase() {
    _classCallCheck(this, FixedCellBase);

    return _super.apply(this, arguments);
  }

  _createClass(FixedCellBase, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          className = _this$props.className,
          classes = _this$props.classes,
          CellPlaceholder = _this$props.component,
          position = _this$props.position,
          selected = _this$props.selected,
          showLeftDivider = _this$props.showLeftDivider,
          showRightDivider = _this$props.showRightDivider,
          side = _this$props.side,
          style = _this$props.style,
          restProps = _objectWithoutProperties(_this$props, _excluded$X);

      return /*#__PURE__*/(0,react.createElement)(CellPlaceholder, _extends({
        className: (0,clsx_m/* default */.Z)((_classNames = {}, _defineProperty(_classNames, classes.dividerLeft, showLeftDivider), _defineProperty(_classNames, classes.dividerRight, showRightDivider), _defineProperty(_classNames, classes.fixedCell, true), _defineProperty(_classNames, classes.selected, selected), _classNames), className),
        style: _objectSpread2(_objectSpread2({}, style), {}, _defineProperty({}, side, position))
      }, restProps));
    }
  }]);

  return FixedCellBase;
}(react.PureComponent);

 false ? 0 : void 0;
FixedCellBase.defaultProps = {
  className: undefined,
  position: undefined,
  selected: false,
  showLeftDivider: false,
  showRightDivider: false,
  style: null
};
var FixedCell = (0,withStyles/* default */.Z)(styles$Q, {
  name: 'TableFixedCell'
})(FixedCellBase);

var _excluded$Y = ["className", "classes"],
    _excluded2$2 = ["listen", "onSizeChange"];

var styles$R = function styles() {
  return {
    cell: {
      border: 0
    }
  };
};

var TableBorderlessStubCellBase = function TableBorderlessStubCellBase(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      restProps = _objectWithoutProperties(_ref, _excluded$Y);

  return /*#__PURE__*/(0,react.createElement)(TableStubCell, _extends({
    className: (0,clsx_m/* default */.Z)(classes.cell, className)
  }, restProps));
};

 false ? 0 : void 0;
TableBorderlessStubCellBase.defaultProps = {
  className: undefined
};
var TableBorderlessStubCell = (0,withStyles/* default */.Z)(styles$R, {
  name: 'TableBorderlessStubCell'
})(TableBorderlessStubCellBase);
var TableListenerCell = function TableListenerCell(_ref2) {
  var listen = _ref2.listen,
      onSizeChange = _ref2.onSizeChange,
      restProps = _objectWithoutProperties(_ref2, _excluded2$2);

  return listen ? /*#__PURE__*/(0,react.createElement)(dx_react_core_es/* Sizer */.ne, _extends({
    containerComponent: TableBorderlessStubCell,
    onSizeChange: onSizeChange
  }, restProps)) : /*#__PURE__*/(0,react.createElement)(TableBorderlessStubCell, restProps);
};
 false ? 0 : void 0;

var TableFixedColumns = (0,dx_react_core_es/* withComponents */.we)({
  Cell: FixedCell,
  ListenerRow: TableInvisibleRow,
  ListenerCell: TableListenerCell
})(dx_react_grid_es/* TableFixedColumns */.a$);

var TableSummaryRow = (0,dx_react_core_es/* withComponents */.we)({
  TotalRow: dx_react_grid_material_ui_es_TableRow,
  GroupRow: dx_react_grid_material_ui_es_TableRow,
  TreeRow: dx_react_grid_material_ui_es_TableRow,
  TotalCell: dx_react_grid_material_ui_es_TableCell,
  GroupCell: dx_react_grid_material_ui_es_TableCell,
  TreeCell: dx_react_grid_material_ui_es_TableCell,
  TableTreeCell: TableTreeCell,
  TableTreeContent: TableTreeContent,
  TableTreeIndent: TableTreeIndent,
  Item: TableSummaryItem
})(dx_react_grid_es/* TableSummaryRow */.RA);
TableSummaryRow.TREE_ROW_TYPE = dx_react_grid_es/* TableSummaryRow.TREE_ROW_TYPE */.RA.TREE_ROW_TYPE;
TableSummaryRow.GROUP_ROW_TYPE = dx_react_grid_es/* TableSummaryRow.GROUP_ROW_TYPE */.RA.GROUP_ROW_TYPE;
TableSummaryRow.TOTAL_ROW_TYPE = dx_react_grid_es/* TableSummaryRow.TOTAL_ROW_TYPE */.RA.TOTAL_ROW_TYPE;

var TableInlineCellEditing = (0,dx_react_core_es/* withComponents */.we)({
  Cell: EditCell
})(dx_react_grid_es/* TableInlineCellEditing */.WI);

var _excluded$Z = ["onToggle", "getMessage", "buttonRef"];
var ToggleButton$2 = function ToggleButton(_ref) {
  var onToggle = _ref.onToggle,
      getMessage = _ref.getMessage,
      buttonRef = _ref.buttonRef,
      restProps = _objectWithoutProperties(_ref, _excluded$Z);

  return /*#__PURE__*/(0,react.createElement)(Tooltip/* default */.ZP, {
    title: getMessage('showExportMenu'),
    placement: "bottom",
    enterDelay: 300
  }, /*#__PURE__*/(0,react.createElement)(IconButton/* default */.Z, _extends({
    onClick: onToggle,
    ref: buttonRef
  }, restProps), /*#__PURE__*/(0,react.createElement)(Save/* default */.Z, null)));
};
 false ? 0 : void 0;

var _excluded$_ = ["visible", "target", "onHide", "children"];
var Menu = function Menu(_ref) {
  var visible = _ref.visible,
      target = _ref.target,
      onHide = _ref.onHide,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded$_);

  return /*#__PURE__*/(0,react.createElement)(Menu_Menu/* default */.Z, _extends({
    keepMounted: true,
    open: visible,
    anchorEl: target,
    onClose: onHide
  }, restProps), children);
};
 false ? 0 : void 0;
Menu.defaultProps = {
  visible: false,
  target: null
};

var _excluded$$ = ["text", "onClick"];
var dx_react_grid_material_ui_es_MenuItem = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      restProps = _objectWithoutProperties(_ref, _excluded$$);

  return /*#__PURE__*/(0,react.createElement)(MenuItem/* default */.Z, _extends({
    onClick: onClick,
    ref: ref
  }, restProps), text);
});
dx_react_grid_material_ui_es_MenuItem.propTypes = {
  text: prop_types.string.isRequired,
  onClick: prop_types.func
};
dx_react_grid_material_ui_es_MenuItem.defaultProps = {
  onClick: function onClick() {}
};

var ExportPanel = (0,dx_react_core_es/* withComponents */.we)({
  ToggleButton: ToggleButton$2,
  Menu: Menu,
  MenuItem: dx_react_grid_material_ui_es_MenuItem
})(dx_react_grid_es/* ExportPanel */.Gn);


//# sourceMappingURL=dx-react-grid-material-ui.es.js.map


/***/ }),

/***/ 80797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/internal/SwitchBase.js
var SwitchBase = __webpack_require__(56608);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckBoxOutlineBlank.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckBox.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/IndeterminateCheckBox.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/react.createElement(CheckBox, null);
var defaultIcon = /*#__PURE__*/react.createElement(CheckBoxOutlineBlank, null);
var defaultIndeterminateIcon = /*#__PURE__*/react.createElement(IndeterminateCheckBox, null);
var Checkbox = /*#__PURE__*/react.forwardRef(function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /*#__PURE__*/react.createElement(SwitchBase/* default */.Z, (0,esm_extends/* default */.Z)({
    type: "checkbox",
    classes: {
      root: (0,clsx_m/* default */.Z)(classes.root, classes["color".concat((0,capitalize/* default */.Z)(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: (0,esm_extends/* default */.Z)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiCheckbox'
})(Checkbox));

/***/ }),

/***/ 16204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chip_Chip; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/Cancel.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var Cancel = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js












var styles = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: (0,colorManipulator/* emphasize */._4)(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: (0,colorManipulator/* emphasize */._4)(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: (0,colorManipulator/* alpha */.Fq)(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = /*#__PURE__*/react.forwardRef(function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = react.useRef(null);
  var handleRef = (0,useForkRef/* default */.Z)(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? ButtonBase/* default */.Z : 'div');
  var moreProps = Component === ButtonBase/* default */.Z ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = (0,clsx_m/* default */.Z)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0,capitalize/* default */.Z)(color))] : classes["deleteIconOutlinedColor".concat((0,capitalize/* default */.Z)(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/react.isValidElement(deleteIconProp) ? /*#__PURE__*/react.cloneElement(deleteIconProp, {
      className: (0,clsx_m/* default */.Z)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/react.createElement(Cancel, {
      className: (0,clsx_m/* default */.Z)(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/react.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/react.cloneElement(avatarProp, {
      className: (0,clsx_m/* default */.Z)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0,capitalize/* default */.Z)(color))])
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/react.isValidElement(iconProp)) {
    icon = /*#__PURE__*/react.cloneElement(iconProp, {
      className: (0,clsx_m/* default */.Z)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0,capitalize/* default */.Z)(color))])
    });
  }

  if (false) {}

  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    role: clickable || onDelete ? 'button' : undefined,
    className: (0,clsx_m/* default */.Z)(classes.root, className, color !== 'default' && [classes["color".concat((0,capitalize/* default */.Z)(color))], clickable && classes["clickableColor".concat((0,capitalize/* default */.Z)(color))], onDelete && classes["deletableColor".concat((0,capitalize/* default */.Z)(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/react.createElement("span", {
    className: (0,clsx_m/* default */.Z)(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
 false ? 0 : void 0;
/* harmony default export */ var Chip_Chip = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiChip'
})(Chip));

/***/ }),

/***/ 46869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40922);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66987);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className"]);

  var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon));

/***/ }),

/***/ 85639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40922);
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50998);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.body1, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ListItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),

/***/ 56608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _utils_useControlled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22775);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40922);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17812);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = (0,_utils_useControlled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),

/***/ 59114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = hexToRgb;
__webpack_unused_export__ = rgbToHex;
__webpack_unused_export__ = hslToRgb;
__webpack_unused_export__ = decomposeColor;
__webpack_unused_export__ = recomposeColor;
__webpack_unused_export__ = getContrastRatio;
__webpack_unused_export__ = getLuminance;
__webpack_unused_export__ = emphasize;
exports.U1 = fade;
__webpack_unused_export__ = alpha;
exports._j = darken;
exports.$n = lighten;

var _utils = __webpack_require__(35920);

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {}

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */


function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0, _utils.formatMuiErrorMessage)(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

var warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (false) {}

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),

/***/ 89875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');

exports.Z = _default;

/***/ }),

/***/ 66735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

exports.Z = _default;

/***/ }),

/***/ 35025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

exports.Z = _default;

/***/ }),

/***/ 64566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

exports.Z = _default;

/***/ }),

/***/ 24960:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
}), 'List');

exports.Z = _default;

/***/ }),

/***/ 53375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
}), 'Save');

exports.Z = _default;

/***/ }),

/***/ 88995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.Z = _default;

/***/ }),

/***/ 28270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');

exports.Z = _default;

/***/ }),

/***/ 35920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HTMLElementType": function() { return /* reexport */ HTMLElementType; },
  "chainPropTypes": function() { return /* reexport */ chainPropTypes; },
  "deepmerge": function() { return /* reexport */ deepmerge/* default */.Z; },
  "elementAcceptingRef": function() { return /* reexport */ esm_elementAcceptingRef; },
  "elementTypeAcceptingRef": function() { return /* reexport */ esm_elementTypeAcceptingRef; },
  "exactProp": function() { return /* reexport */ exactProp; },
  "formatMuiErrorMessage": function() { return /* reexport */ formatMuiErrorMessage/* default */.Z; },
  "getDisplayName": function() { return /* reexport */ getDisplayName; },
  "ponyfillGlobal": function() { return /* reexport */ ponyfillGlobal; },
  "refType": function() { return /* reexport */ esm_refType; }
});

;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/chainPropTypes.js
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/elementAcceptingRef.js



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = chainPropTypes((prop_types_default()).element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes((prop_types_default()).element.isRequired, acceptingRef);
/* harmony default export */ var esm_elementAcceptingRef = (elementAcceptingRef);
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/elementTypeAcceptingRef.js



function elementTypeAcceptingRef_isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !elementTypeAcceptingRef_isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* harmony default export */ var esm_elementTypeAcceptingRef = (chainPropTypes(prop_types.elementType, elementTypeAcceptingRef));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/exactProp.js


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return (0,esm_extends/* default */.Z)({}, propTypes, (0,defineProperty/* default */.Z)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(60288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/node_modules/react-is/index.js
var react_is = __webpack_require__(48437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/getDisplayName.js

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if ((0,esm_typeof/* default */.Z)(Component) === 'object') {
    switch (Component.$$typeof) {
      case react_is.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case react_is.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/HTMLElementType.js
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/ponyfillGlobal.js
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* harmony default export */ var ponyfillGlobal = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/refType.js

var refType = prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).object]);
/* harmony default export */ var esm_refType = (refType);
;// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/index.js
/** @license Material-UI v4.11.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











/***/ }),

/***/ 65723:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;exports.ForwardRef=B;__webpack_unused_export__=C;__webpack_unused_export__=D;exports.Memo=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 48437:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



if (true) {
  module.exports = __webpack_require__(65723);
} else {}


/***/ })

}]);